{
  "__README": "THIS FILE IS AUTOGENERATED, SEE BACKEND TASK tools:apidoc:clientgen",
  "openapi": "3.0.0",
  "paths": {
    "/entry-attachments/{entryType}/{entryId}": {
      "get": {
        "operationId": "EntryAttachmentController_list",
        "parameters": [
          {
            "name": "entryType",
            "required": true,
            "in": "path",
            "schema": {
              "$ref": "#/components/schemas/EntryAttachmentType"
            }
          },
          {
            "name": "entryId",
            "required": true,
            "in": "path",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          },
          {
            "name": "afterId",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/EntryAttachmentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "EntryAttachment"
        ]
      }
    },
    "/entry-attachments/{entryType}/{entryId}/files": {
      "post": {
        "operationId": "EntryAttachmentController_attachFile",
        "parameters": [
          {
            "name": "entryType",
            "required": true,
            "in": "path",
            "schema": {
              "$ref": "#/components/schemas/EntryAttachmentType"
            }
          },
          {
            "name": "entryId",
            "required": true,
            "in": "path",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/FileReferenceDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "EntryAttachment"
        ]
      }
    },
    "/entry-attachments/{entryType}/{entryId}/files/{attachmentId}": {
      "delete": {
        "operationId": "EntryAttachmentController_removeFile",
        "parameters": [
          {
            "name": "entryType",
            "required": true,
            "in": "path",
            "schema": {
              "$ref": "#/components/schemas/EntryAttachmentType"
            }
          },
          {
            "name": "entryId",
            "required": true,
            "in": "path",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          },
          {
            "name": "attachmentId",
            "required": true,
            "in": "path",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "EntryAttachment"
        ]
      }
    },
    "/app-config": {
      "get": {
        "operationId": "AppController_getAppConfig",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/AppConfigResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "App"
        ]
      }
    },
    "/healthcheck": {
      "get": {
        "operationId": "AppController_healthcheck",
        "parameters": [],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "App"
        ]
      }
    },
    "/provider/tenants": {
      "post": {
        "operationId": "TenantProviderController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/ProviderCreateTenantDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TenantResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TenantProvider"
        ]
      },
      "get": {
        "operationId": "TenantProviderController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "sortBy",
            "required": false,
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/ProviderTenantSortField"
            }
          },
          {
            "name": "sortDirection",
            "required": false,
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/SortOrder"
            }
          },
          {
            "name": "search",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TenantPaginatedResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TenantProvider"
        ]
      }
    },
    "/provider/tenants/user-roles": {
      "get": {
        "operationId": "TenantProviderController_retrieveUserRoles",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UserRolePaginatedResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TenantProvider"
        ]
      }
    },
    "/provider/tenants/{tenantId}/subscription": {
      "get": {
        "operationId": "TenantProviderController_retrieveSubscription",
        "parameters": [
          {
            "name": "tenantId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ProviderTenantSubscriptionResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TenantProvider"
        ]
      }
    },
    "/provider/tenants/{tenantId}": {
      "put": {
        "operationId": "TenantProviderController_update",
        "parameters": [
          {
            "name": "tenantId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/ProviderUpdateTenantDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TenantResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TenantProvider"
        ]
      },
      "delete": {
        "operationId": "TenantProviderController_delete",
        "parameters": [
          {
            "name": "tenantId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TenantProvider"
        ]
      }
    },
    "/provider/tenants/{tenantId}/add-user": {
      "post": {
        "operationId": "TenantProviderController_addUserRole",
        "parameters": [
          {
            "name": "tenantId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateTenantUserRoleDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UserRoleResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TenantProvider"
        ]
      }
    },
    "/provider/tenants/{tenantId}/user-roles/{userRoleId}": {
      "put": {
        "operationId": "TenantProviderController_updateUserRole",
        "parameters": [
          {
            "name": "userRoleId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "tenantId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateUserRoleDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TenantProvider"
        ]
      },
      "delete": {
        "operationId": "TenantProviderController_removeUserRole",
        "parameters": [
          {
            "name": "tenantId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "userRoleId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TenantProvider"
        ]
      }
    },
    "/provider/tenants/{tenantId}/school-classes": {
      "get": {
        "operationId": "TenantProviderController_retrieveSchoolClasses",
        "parameters": [
          {
            "name": "tenantId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ProviderSchoolClassListResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TenantProvider"
        ]
      }
    },
    "/provider/tenants/{tenantId}/school-classes/{schoolClassId}/subjects": {
      "get": {
        "operationId": "TenantProviderController_retrieveSubjectsForClass",
        "parameters": [
          {
            "name": "tenantId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ProviderSchoolSubjectListResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TenantProvider"
        ]
      }
    },
    "/provider/tenants/{tenantId}/school-classes/{schoolClassId}/subject-groups": {
      "get": {
        "operationId": "TenantProviderController_retrieveSubjectGroupsForClass",
        "parameters": [
          {
            "name": "tenantId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ProviderSchoolSubjectGroupListResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TenantProvider"
        ]
      }
    },
    "/provider/tenants/{tenantId}/user-roles/{userRoleId}/access-rights": {
      "get": {
        "operationId": "TenantProviderController_retrieveUserRoleAccessRights",
        "parameters": [
          {
            "name": "tenantId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "userRoleId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ProviderUserRoleAccessRightListResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TenantProvider"
        ]
      },
      "put": {
        "operationId": "TenantProviderController_upsertUserRoleAccessRights",
        "parameters": [
          {
            "name": "tenantId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "userRoleId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpsertUserAccessRightsDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TenantProvider"
        ]
      }
    },
    "/provider/tenants/{tenantId}/deactivate": {
      "post": {
        "operationId": "TenantProviderController_deactivate",
        "parameters": [
          {
            "name": "tenantId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TenantProvider"
        ]
      }
    },
    "/provider/tenants/{tenantId}/revoke-deletion": {
      "post": {
        "operationId": "TenantProviderController_revokeDeletion",
        "parameters": [
          {
            "name": "tenantId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TenantProvider"
        ]
      }
    },
    "/tenants/current": {
      "get": {
        "operationId": "TenantController_getTenant",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CurrentTenantResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Tenant"
        ]
      },
      "put": {
        "operationId": "TenantController_updateTenant",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateTenantDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TenantResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Tenant"
        ]
      }
    },
    "/tenants/current/get-owners-and-admins": {
      "get": {
        "operationId": "TenantController_getTenantOwnersAndAdmins",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CurrentTenantOwnersAndAdminsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Tenant"
        ]
      }
    },
    "/tenants/current/logo": {
      "put": {
        "operationId": "TenantController_setLogo",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/FileReferenceDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TenantResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Tenant"
        ]
      },
      "delete": {
        "operationId": "TenantController_removeLogo",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TenantResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Tenant"
        ]
      }
    },
    "/tenants/current/tfa/enable": {
      "put": {
        "operationId": "TenantController_enableTfa",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TenantResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Tenant"
        ]
      }
    },
    "/tenants/current/tfa/disable": {
      "put": {
        "operationId": "TenantController_disableTfa",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TenantResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Tenant"
        ]
      }
    },
    "/tenants/current/school-levels": {
      "put": {
        "operationId": "TenantController_updateSchoolLevels",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateTenantSchoolLevelsDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TenantResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Tenant"
        ]
      }
    },
    "/tenants/current/administration-setup/complete": {
      "put": {
        "operationId": "TenantController_completeAdministrationSetup",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TenantResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Tenant"
        ]
      }
    },
    "/tenants/current/competence-setup-choice-dialog/seen": {
      "put": {
        "operationId": "TenantController_markCompetenceSetupChoiceDialogSeen",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TenantResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Tenant"
        ]
      }
    },
    "/tenants/current/add-user/bulk": {
      "post": {
        "operationId": "TenantController_addOrCreateTenantUsersBulk",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/AddTenantUserBulkDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/AddTenantUserBulkResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Tenant"
        ]
      }
    },
    "/tenants/current/user-roles": {
      "get": {
        "operationId": "TenantController_retrieveUserRoles",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UserRolePaginatedResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Tenant"
        ]
      }
    },
    "/tenants/current/subjects/template": {
      "get": {
        "operationId": "TenantController_retrieveTenantSubjectTemplates",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedSchoolSubjectResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Tenant"
        ]
      }
    },
    "/tenants/current/performance-assessments/template": {
      "get": {
        "operationId": "TenantController_retrieveTenantPerformanceAssessmentTemplates",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedPerformanceAssessmentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Tenant"
        ]
      }
    },
    "/tenants/current/user-roles/{userRoleId}": {
      "put": {
        "operationId": "TenantController_updateUserRole",
        "parameters": [
          {
            "name": "userRoleId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateUserRoleDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Tenant"
        ]
      },
      "delete": {
        "operationId": "TenantController_removeUserRole",
        "parameters": [
          {
            "name": "userRoleId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Tenant"
        ]
      }
    },
    "/tenants/current/subjects/template/copy": {
      "post": {
        "operationId": "TenantController_copySubjectsToTenant",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CopySchoolSubjectsWithSchoolLevelDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Tenant"
        ]
      }
    },
    "/tenants/current/subjects/template/export": {
      "get": {
        "operationId": "TenantController_exportTemplateSet",
        "parameters": [],
        "responses": {
          "200": {
            "content": {
              "application/zip": {
                "schema": {
                  "type": "string",
                  "format": "binary"
                }
              }
            },
            "description": ""
          }
        },
        "tags": [
          "Tenant"
        ]
      }
    },
    "/tenants/current/subjects/template/validate": {
      "post": {
        "operationId": "TenantController_validateTemplateSet",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "multipart/form-data": {
              "schema": {
                "type": "object",
                "required": [
                  "file"
                ],
                "properties": {
                  "file": {
                    "type": "string",
                    "format": "binary"
                  }
                }
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TemplateSetPreviewResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Tenant"
        ]
      }
    },
    "/tenants/current/subjects/template/import": {
      "post": {
        "operationId": "TenantController_importTemplateSet",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "multipart/form-data": {
              "schema": {
                "type": "object",
                "required": [
                  "file"
                ],
                "properties": {
                  "file": {
                    "type": "string",
                    "format": "binary"
                  }
                }
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Tenant"
        ]
      }
    },
    "/tenants/current/performance-assessments/{performanceAssessmentId}/import": {
      "post": {
        "operationId": "TenantController_importProviderTemplateToTenant",
        "parameters": [
          {
            "name": "performanceAssessmentId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/ImportPerformanceAssessmentDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Tenant"
        ]
      }
    },
    "/tenants/current/transfer-ownership": {
      "post": {
        "operationId": "TenantController_startTransferOfOwnership",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/TransferOwnershipDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Tenant"
        ]
      }
    },
    "/tenants/current/delete": {
      "post": {
        "operationId": "TenantController_deleteCurrentTenant",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/DeleteCurrentTenantDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "Tenant"
        ]
      }
    },
    "/tenants/delete-owned": {
      "post": {
        "operationId": "TenantController_deleteOwnedTenants",
        "parameters": [],
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "Tenant"
        ]
      }
    },
    "/students": {
      "post": {
        "operationId": "StudentController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateStudentDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/StudentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Student"
        ]
      },
      "get": {
        "operationId": "StudentController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedStudentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Student"
        ]
      }
    },
    "/students/bulk": {
      "post": {
        "operationId": "StudentController_createBulk",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateBulkStudentsDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/BulkStudentsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Student"
        ]
      }
    },
    "/students/{id}": {
      "put": {
        "operationId": "StudentController_update",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateStudentDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/StudentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Student"
        ]
      },
      "delete": {
        "operationId": "StudentController_delete",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Student"
        ]
      },
      "get": {
        "operationId": "StudentController_retrieveOne",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/StudentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Student"
        ]
      }
    },
    "/classes/{schoolClassId}/students": {
      "get": {
        "operationId": "StudentController_retrieveStudentsOfClass",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedStudentWithSubjectAccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Student"
        ]
      }
    },
    "/classes/{schoolClassId}/selectable-students": {
      "get": {
        "operationId": "StudentController_retrieveSelectableStudentsOfClass",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedStudentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Student"
        ]
      }
    },
    "/students/import/file": {
      "post": {
        "operationId": "StudentImportController_readFile",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "multipart/form-data": {
              "schema": {
                "type": "object",
                "required": [
                  "file"
                ],
                "properties": {
                  "file": {
                    "type": "string",
                    "format": "binary"
                  }
                }
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/StudentImportResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "StudentImport"
        ]
      }
    },
    "/students/import/text": {
      "post": {
        "operationId": "StudentImportController_readText",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/ReadStudentImportTextDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/StudentImportResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "StudentImport"
        ]
      }
    },
    "/students/import/match": {
      "post": {
        "operationId": "StudentImportController_matchNames",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/MatchStudentNamesDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/StudentNameMatchesResponseDto"
                }
              }
            }
          }
        },
        "summary": "Tells for each name whether a student of the class or the tenant has it, so the form adds nobody twice.",
        "tags": [
          "StudentImport"
        ]
      }
    },
    "/classes": {
      "post": {
        "operationId": "SchoolClassController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateSchoolClassDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolClassResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolClass"
        ]
      },
      "get": {
        "operationId": "SchoolClassController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedSchoolClassResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolClass"
        ]
      }
    },
    "/classes/setup": {
      "post": {
        "operationId": "SchoolClassController_createSetup",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateSchoolClassSetupDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolClassSetupResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolClass"
        ]
      }
    },
    "/classes/{id}": {
      "put": {
        "operationId": "SchoolClassController_update",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateSchoolClassDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolClassResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolClass"
        ]
      },
      "delete": {
        "operationId": "SchoolClassController_delete",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolClass"
        ]
      }
    },
    "/classes/{id}/dismiss-school-year-over-banner": {
      "post": {
        "operationId": "SchoolClassController_dismissSchoolYearOverBanner",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolClassResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolClass"
        ]
      }
    },
    "/classes/{id}/archive": {
      "post": {
        "operationId": "SchoolClassController_archive",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/ArchiveSchoolClassDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolClassResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolClass"
        ]
      }
    },
    "/classes/{id}/set-base-class": {
      "post": {
        "operationId": "SchoolClassController_setBaseClass",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/SetBaseClassDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolClassResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolClass"
        ]
      }
    },
    "/classes/{schoolClassId}/access-rights": {
      "post": {
        "operationId": "SchoolClassController_upsertAccessRights",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpsertSchoolClassAccessDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolClass"
        ]
      }
    },
    "/classes/{schoolClassId}/invitation-access-rights": {
      "post": {
        "operationId": "SchoolClassController_upsertInvitationAccessRights",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/AddInvitationSchoolClassAccessDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolClass"
        ]
      }
    },
    "/classes/access-rights": {
      "get": {
        "operationId": "SchoolClassController_getAccessRights",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedSchoolClassAccessRightResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolClass"
        ]
      }
    },
    "/classes/invitation-access-rights": {
      "get": {
        "operationId": "SchoolClassController_getInvitationAccessRights",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedInvitationAccessRightResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolClass"
        ]
      }
    },
    "/classes/{schoolClassId}/access-rights/{accessRightId}": {
      "delete": {
        "operationId": "SchoolClassController_removeAccessRights",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "accessRightId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolClass"
        ]
      }
    },
    "/classes/{schoolClassId}/performance-assessments/{performanceAssessmentId}/import": {
      "post": {
        "operationId": "SchoolClassController_importTenantTemplateToClass",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "performanceAssessmentId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/ImportPerformanceAssessmentDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolClass"
        ]
      }
    },
    "/classes/{schoolClassId}/performance-visual-templates": {
      "get": {
        "operationId": "SchoolClassController_retrievePerformanceVisualTemplatesForClass",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedPerformanceVisualResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolClass"
        ]
      }
    },
    "/classes/{schoolClassId}/performance-visuals/{performanceVisualId}/import": {
      "post": {
        "operationId": "SchoolClassController_importPerformanceVisualTemplateToClass",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "performanceVisualId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolClass"
        ]
      }
    },
    "/classes/{schoolClassId}/performance-assessments/{performanceAssessmentId}/subjects/{subjectId}/student-level-counts": {
      "get": {
        "operationId": "SchoolClassController_getStudentLevelCounts",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "performanceAssessmentId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "subjectId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "from",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "to",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PerformanceAssessmentStudentLevelCountsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolClass"
        ]
      }
    },
    "/classes/{schoolClassId}/subjects/{subjectId}/performance-assessments/entry-counts": {
      "get": {
        "operationId": "SchoolClassController_getPerformanceAssessmentEntryCountsForSubject",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "subjectId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "from",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "to",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PerformanceAssessmentEntryCountsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolClass"
        ]
      }
    },
    "/classes/{schoolClassId}/subjects/{subjectId}/performance-assessments/entry-count-totals-by-term": {
      "get": {
        "operationId": "SchoolClassController_getPerformanceAssessmentEntryCountTotalsByTerm",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "subjectId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PerformanceAssessmentEntryCountTotalsByTermResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolClass"
        ]
      }
    },
    "/classes/{schoolClassId}/students/{studentId}/performance-assessments/counts-by-subject": {
      "get": {
        "operationId": "SchoolClassController_countsBySubject",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "studentId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "from",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "to",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PerformanceAssessmentCountsBySubjectResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolClass"
        ]
      }
    },
    "/classes/{schoolClassId}/students/{studentId}/subjects/{subjectId}/performance-assessments/evaluations": {
      "get": {
        "operationId": "SchoolClassController_getPerformanceAssessmentEvaluationsBySubject",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "studentId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "subjectId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "from",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "to",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PerformanceAssessmentEvaluationsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolClass"
        ]
      }
    },
    "/student-class-relations/link": {
      "post": {
        "operationId": "StudentClassRelationController_link",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/EditStudentClassRelationDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "StudentClassRelation"
        ]
      }
    },
    "/student-class-relations/unlink": {
      "post": {
        "operationId": "StudentClassRelationController_unlink",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/EditStudentClassRelationDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "StudentClassRelation"
        ]
      }
    },
    "/subjects/{schoolSubjectId}/duplicate": {
      "post": {
        "operationId": "SchoolSubjectController_duplicate",
        "parameters": [
          {
            "name": "schoolSubjectId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/DuplicateSchoolSubjectDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolSubjectResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubject"
        ]
      }
    },
    "/classes/{schoolClassId}/subjects": {
      "post": {
        "operationId": "SchoolSubjectController_create",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateSchoolSubjectDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolSubjectResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubject"
        ]
      }
    },
    "/classes/{schoolClassId}/subjects/copy": {
      "post": {
        "operationId": "SchoolSubjectController_copyFromTemplate",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CopySchoolSubjectsDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubject"
        ]
      }
    },
    "/subjects/{schoolSubjectId}/students": {
      "put": {
        "operationId": "SchoolSubjectController_assignStudentsToSubject",
        "parameters": [
          {
            "name": "schoolSubjectId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/AssignStudentsToSubjectDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubject"
        ]
      },
      "get": {
        "operationId": "SchoolSubjectController_getStudentsWithAccessToSubject",
        "parameters": [
          {
            "name": "schoolSubjectId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedBaseStudentDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubject"
        ]
      }
    },
    "/classes/{schoolClassId}/subjects/can-access-all": {
      "get": {
        "operationId": "SchoolSubjectController_canUserAccessAllSubjectsInClass",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolSubjectAccessAllResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubject"
        ]
      }
    },
    "/subjects/{schoolSubjectId}": {
      "put": {
        "operationId": "SchoolSubjectController_update",
        "parameters": [
          {
            "name": "schoolSubjectId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateSchoolSubjectDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolSubjectResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubject"
        ]
      },
      "delete": {
        "operationId": "SchoolSubjectController_delete",
        "parameters": [
          {
            "name": "schoolSubjectId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubject"
        ]
      }
    },
    "/subjects": {
      "get": {
        "operationId": "SchoolSubjectController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedSchoolSubjectResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubject"
        ]
      }
    },
    "/subjects/global-templates": {
      "get": {
        "operationId": "SchoolSubjectController_retrieveGlobalTemplates",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedSchoolSubjectResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubject"
        ]
      }
    },
    "/subjects/{id}": {
      "get": {
        "operationId": "SchoolSubjectController_get",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolSubjectResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubject"
        ]
      }
    },
    "/subjects/template": {
      "post": {
        "operationId": "SchoolSubjectController_createTemplate",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateSchoolSubjectDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolSubjectResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubject"
        ]
      }
    },
    "/subjects/{schoolSubjectId}/subject-specific-assessments": {
      "put": {
        "operationId": "SchoolSubjectController_setUseSubjectSpecificAssessments",
        "parameters": [
          {
            "name": "schoolSubjectId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/SetSubjectSpecificAssessmentsDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolSubjectResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubject"
        ]
      }
    },
    "/subjects/{schoolSubjectId}/subject-specific-assessments/setup-preview": {
      "get": {
        "operationId": "SchoolSubjectController_getSubjectSpecificAssessmentSetupPreview",
        "parameters": [
          {
            "name": "schoolSubjectId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SubjectSpecificAssessmentSetupPreviewResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubject"
        ]
      }
    },
    "/subjects/{schoolSubjectId}/subject-specific-assessments/setup": {
      "post": {
        "operationId": "SchoolSubjectController_setupSubjectSpecificAssessments",
        "parameters": [
          {
            "name": "schoolSubjectId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolSubjectResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubject"
        ]
      }
    },
    "/classes/subjects/{schoolSubjectId}/competence-domains": {
      "post": {
        "operationId": "CompetenceDomainController_create",
        "parameters": [
          {
            "name": "schoolSubjectId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateCompetenceDomainDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CompetenceDomainResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CompetenceDomain"
        ]
      }
    },
    "/classes/subjects/competence-domains/{domainId}": {
      "put": {
        "operationId": "CompetenceDomainController_update",
        "parameters": [
          {
            "name": "domainId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateCompetenceDomainDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CompetenceDomainResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CompetenceDomain"
        ]
      }
    },
    "/competence-domains/templates/tenant": {
      "get": {
        "operationId": "CompetenceDomainController_listTenantTemplates",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedCompetenceDomainResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CompetenceDomain"
        ]
      }
    },
    "/competence-domains/global-templates": {
      "get": {
        "operationId": "CompetenceDomainController_retrieveGlobalTemplates",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedCompetenceDomainResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CompetenceDomain"
        ]
      }
    },
    "/competence-domains/{domainId}": {
      "get": {
        "operationId": "CompetenceDomainController_get",
        "parameters": [
          {
            "name": "domainId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CompetenceDomainResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CompetenceDomain"
        ]
      },
      "delete": {
        "operationId": "CompetenceDomainController_delete",
        "parameters": [
          {
            "name": "domainId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CompetenceDomain"
        ]
      }
    },
    "/competence-domains": {
      "get": {
        "operationId": "CompetenceDomainController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedCompetenceDomainResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CompetenceDomain"
        ]
      }
    },
    "/subjects/{schoolSubjectId}/competence-domains/template": {
      "post": {
        "operationId": "CompetenceDomainController_createTemplate",
        "parameters": [
          {
            "name": "schoolSubjectId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateCompetenceDomainDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CompetenceDomainResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CompetenceDomain"
        ]
      }
    },
    "/competence-domains/{domainId}/competences": {
      "post": {
        "operationId": "CompetenceController_create",
        "parameters": [
          {
            "name": "domainId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateCompetenceDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CompetenceResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Competence"
        ]
      }
    },
    "/competence-domains/{domainId}/competences/{competenceId}": {
      "put": {
        "operationId": "CompetenceController_update",
        "parameters": [
          {
            "name": "domainId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "competenceId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateCompetenceDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CompetenceResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Competence"
        ]
      },
      "delete": {
        "operationId": "CompetenceController_delete",
        "parameters": [
          {
            "name": "domainId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "competenceId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Competence"
        ]
      }
    },
    "/users/me": {
      "put": {
        "operationId": "UserController_update",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateUserDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UserDataResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "User"
        ]
      }
    },
    "/users/me/source": {
      "put": {
        "operationId": "UserController_updateSource",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateUserSourceDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UserDataResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "User"
        ]
      }
    },
    "/users/me/tfa/should-be-activated": {
      "get": {
        "operationId": "UserController_shouldTfaBeActivated",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UserShouldTfaBeActivatedResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "User"
        ]
      }
    },
    "/users/me/tfa/enable": {
      "post": {
        "operationId": "UserController_enableTfa",
        "parameters": [],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "User"
        ]
      }
    },
    "/users/me/tfa/disable": {
      "post": {
        "operationId": "UserController_disableTfa",
        "parameters": [],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "User"
        ]
      }
    },
    "/users/me/totp/status": {
      "get": {
        "operationId": "UserController_getTotpStatus",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UserTotpStatusResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "User"
        ]
      }
    },
    "/users/me/tfa/status": {
      "get": {
        "operationId": "UserController_getTfaStatus",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UserTfaStatusResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "User"
        ]
      }
    },
    "/users/me/totp/enable": {
      "post": {
        "operationId": "UserController_enableTotp",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/EnableTotpDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "User"
        ]
      }
    },
    "/users/me/totp/disable": {
      "post": {
        "operationId": "UserController_disableTotp",
        "parameters": [],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "User"
        ]
      }
    },
    "/users/me/delete": {
      "post": {
        "operationId": "UserController_deleteMe",
        "parameters": [],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "User"
        ]
      }
    },
    "/users/roles/{userRoleId}/access-rights": {
      "post": {
        "operationId": "UserController_upsertAccessRights",
        "parameters": [
          {
            "name": "userRoleId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpsertUserAccessRightsDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "User"
        ]
      }
    },
    "/user-settings/me": {
      "put": {
        "operationId": "UserSettingController_update",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateUserSettingDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UserSettingResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "UserSetting"
        ]
      }
    },
    "/school-years": {
      "get": {
        "operationId": "SchoolYearController_retrieveForTenant",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedSchoolYearResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolYear"
        ]
      },
      "post": {
        "operationId": "SchoolYearProviderController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateSchoolYearDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolYearResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolYearProvider"
        ]
      }
    },
    "/school-years/current-term": {
      "get": {
        "operationId": "SchoolYearController_getCurrentSchoolTerm",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CurrentSchoolTermResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolYear"
        ]
      }
    },
    "/school-years/{id}": {
      "put": {
        "operationId": "SchoolYearProviderController_update",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateSchoolYearDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolYearResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolYearProvider"
        ]
      },
      "delete": {
        "operationId": "SchoolYearProviderController_delete",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolYearProvider"
        ]
      }
    },
    "/school-years/provider": {
      "get": {
        "operationId": "SchoolYearProviderController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedSchoolYearResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolYearProvider"
        ]
      }
    },
    "/performance-visuals": {
      "post": {
        "operationId": "PerformanceVisualController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreatePerformanceVisualDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PerformanceVisualResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceVisual"
        ]
      },
      "get": {
        "operationId": "PerformanceVisualController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedPerformanceVisualResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceVisual"
        ]
      }
    },
    "/performance-visuals/{id}": {
      "put": {
        "operationId": "PerformanceVisualController_update",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdatePerformanceVisualDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PerformanceVisualResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceVisual"
        ]
      },
      "delete": {
        "operationId": "PerformanceVisualController_delete",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceVisual"
        ]
      }
    },
    "/provider/performance-visuals/resolved": {
      "post": {
        "operationId": "PerformanceVisualProviderController_resolveForScope",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/GlobalTemplateScopeDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedPerformanceVisualResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceVisualProvider"
        ]
      }
    },
    "/performance-visuals/{visualId}/performance-levels": {
      "post": {
        "operationId": "PerformanceLevelV2Controller_create",
        "parameters": [
          {
            "name": "visualId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreatePerformanceLevelV2Dto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PerformanceLevelV2ResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceLevelV2"
        ]
      }
    },
    "/performance-visuals/{visualId}/performance-levels/{id}": {
      "put": {
        "operationId": "PerformanceLevelV2Controller_update",
        "parameters": [
          {
            "name": "visualId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdatePerformanceLevelV2Dto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PerformanceLevelV2ResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceLevelV2"
        ]
      },
      "delete": {
        "operationId": "PerformanceLevelV2Controller_delete",
        "parameters": [
          {
            "name": "visualId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceLevelV2"
        ]
      }
    },
    "/performance-assessments": {
      "post": {
        "operationId": "PerformanceAssessmentController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreatePerformanceAssessmentDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PerformanceAssessmentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceAssessment"
        ]
      },
      "get": {
        "operationId": "PerformanceAssessmentController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedPerformanceAssessmentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceAssessment"
        ]
      }
    },
    "/performance-assessments/{id}": {
      "put": {
        "operationId": "PerformanceAssessmentController_update",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdatePerformanceAssessmentDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PerformanceAssessmentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceAssessment"
        ]
      },
      "delete": {
        "operationId": "PerformanceAssessmentController_delete",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceAssessment"
        ]
      }
    },
    "/provider/performance-assessments": {
      "post": {
        "operationId": "PerformanceAssessmentProviderController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/ProviderCreatePerformanceAssessmentDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PerformanceAssessmentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceAssessmentProvider"
        ]
      }
    },
    "/provider/performance-assessments/{id}": {
      "put": {
        "operationId": "PerformanceAssessmentProviderController_update",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/ProviderUpdatePerformanceAssessmentDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PerformanceAssessmentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceAssessmentProvider"
        ]
      },
      "delete": {
        "operationId": "PerformanceAssessmentProviderController_delete",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceAssessmentProvider"
        ]
      }
    },
    "/provider/performance-assessments/resolved": {
      "post": {
        "operationId": "PerformanceAssessmentProviderController_resolveForScope",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/GlobalTemplateScopeDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedPerformanceAssessmentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceAssessmentProvider"
        ]
      }
    },
    "/observations/classes/{schoolClassId}/students/{studentId}/competence-trend": {
      "get": {
        "operationId": "CompetenceObservationController_getStudentCompetenceTrend",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "studentId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "subjectId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "competenceDomainId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "competenceId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "performanceAssessmentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "from",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "to",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "calculationType",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string",
              "enum": [
                "lastHistoricalEntry",
                "allHistoricalEntries"
              ]
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/StudentCompetenceTrendResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CompetenceObservation"
        ]
      }
    },
    "/observations/bulk": {
      "put": {
        "operationId": "CompetenceObservationController_bulkUpdateLevel",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/BulkUpdateCompetenceObservationLevelDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CompetenceObservation"
        ]
      }
    },
    "/observations/{observationId}": {
      "put": {
        "operationId": "CompetenceObservationController_update",
        "parameters": [
          {
            "name": "observationId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateCompetenceObservationDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CompetenceObservationResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CompetenceObservation"
        ]
      }
    },
    "/observations": {
      "get": {
        "operationId": "CompetenceObservationController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedCompetenceObservationResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CompetenceObservation"
        ]
      }
    },
    "/classes/{schoolClassId}/reports/bulk": {
      "post": {
        "operationId": "ReportController_createBulkForClass",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateBulkReportsDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ReportsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Report"
        ]
      }
    },
    "/classes/{schoolClassId}/reports/bulk/async": {
      "post": {
        "operationId": "ReportController_createBulkForClassAsync",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateBulkReportsDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/AsyncOperationCreatedResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Report"
        ]
      }
    },
    "/classes/{schoolClassId}/reports/{reportId}/competence/{competenceId}": {
      "patch": {
        "operationId": "ReportController_updateReportCompetence",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "reportId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "competenceId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateReportCompetenceDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ReportCompetenceResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Report"
        ]
      }
    },
    "/reports/{reportId}": {
      "patch": {
        "operationId": "ReportController_updateReport",
        "parameters": [
          {
            "name": "reportId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateReportDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/BaseReportResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Report"
        ]
      },
      "get": {
        "operationId": "ReportController_retrieveReport",
        "parameters": [
          {
            "name": "reportId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ReportResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Report"
        ]
      },
      "delete": {
        "operationId": "ReportController_deleteReport",
        "parameters": [
          {
            "name": "reportId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Report"
        ]
      }
    },
    "/classes/{schoolClassId}/reports": {
      "get": {
        "operationId": "ReportController_getReportsForClass",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          },
          {
            "name": "search",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedReportResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Report"
        ]
      }
    },
    "/reports/{reportId}/close": {
      "patch": {
        "operationId": "ReportController_closeReport",
        "parameters": [
          {
            "name": "reportId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Report"
        ]
      }
    },
    "/reports/{reportId}/cover-image": {
      "put": {
        "operationId": "ReportController_setReportCoverImage",
        "parameters": [
          {
            "name": "reportId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/FileReferenceDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Report"
        ]
      },
      "delete": {
        "operationId": "ReportController_removeReportCoverImage",
        "parameters": [
          {
            "name": "reportId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Report"
        ]
      }
    },
    "/reports/{reportId}/comment": {
      "patch": {
        "operationId": "ReportController_updateReportComment",
        "parameters": [
          {
            "name": "reportId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateReportGeneralCommentDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Report"
        ]
      }
    },
    "/reports/{reportId}/subjects/{subjectId}": {
      "patch": {
        "operationId": "ReportController_updateReportSubject",
        "parameters": [
          {
            "name": "reportId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "subjectId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateReportSubjectDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Report"
        ]
      },
      "delete": {
        "operationId": "ReportController_deleteReportSubject",
        "parameters": [
          {
            "name": "reportId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "subjectId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Report"
        ]
      }
    },
    "/reports/{reportId}/pdf": {
      "get": {
        "operationId": "ReportController_getReportForPrint",
        "parameters": [
          {
            "name": "reportId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ReportResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Report"
        ]
      }
    },
    "/classes/reports/pdf": {
      "post": {
        "operationId": "ReportController_bulkPrintReports",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/BulkPdfGenerationDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/AsyncOperationCreatedResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Report"
        ]
      }
    },
    "/reports/observed-subject-ids": {
      "post": {
        "operationId": "ReportController_getObservedSubjectIds",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/GetObservedSubjectIdsDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ObservedSubjectIdsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Report"
        ]
      }
    },
    "/reports/note-subject-ids": {
      "post": {
        "operationId": "ReportController_getNoteSubjectIds",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/GetObservedSubjectIdsDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/NoteSubjectIdsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Report"
        ]
      }
    },
    "/reports/classes/{schoolClassId}/can-report-be-created": {
      "get": {
        "operationId": "ReportController_canReportBeCreated",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ReportDataStatusResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Report"
        ]
      }
    },
    "/reports/classes/{schoolClassId}/creation-interval": {
      "get": {
        "operationId": "ReportController_getReportCreationInterval",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ReportCreationIntervalResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Report"
        ]
      }
    },
    "/classes/{schoolClassId}/report-groups": {
      "post": {
        "operationId": "ReportGroupController_createGroup",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateReportGroupDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ReportGroupResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ReportGroup"
        ]
      },
      "get": {
        "operationId": "ReportGroupController_getGroups",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedReportGroupResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ReportGroup"
        ]
      }
    },
    "/classes/{schoolClassId}/report-groups/{groupId}/assign": {
      "patch": {
        "operationId": "ReportGroupController_assignReports",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "groupId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/AssignReportsToGroupDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ReportGroup"
        ]
      }
    },
    "/classes/{schoolClassId}/report-groups/{groupId}/unassign/{reportId}": {
      "patch": {
        "operationId": "ReportGroupController_unassignReport",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "groupId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "reportId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ReportGroup"
        ]
      }
    },
    "/classes/{schoolClassId}/report-groups/{groupId}": {
      "delete": {
        "operationId": "ReportGroupController_deleteGroup",
        "parameters": [
          {
            "name": "groupId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ReportGroup"
        ]
      }
    },
    "/states": {
      "get": {
        "operationId": "StateController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedStateResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "State"
        ]
      }
    },
    "/provider/states": {
      "post": {
        "operationId": "StateProviderController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateStateDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/StateResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "StateProvider"
        ]
      }
    },
    "/provider/states/{id}": {
      "put": {
        "operationId": "StateProviderController_update",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateStateDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/StateResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "StateProvider"
        ]
      },
      "delete": {
        "operationId": "StateProviderController_delete",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "StateProvider"
        ]
      }
    },
    "/provider/school-subject-types": {
      "get": {
        "operationId": "SchoolSubjectTypeProviderController_retrieve",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedSchoolSubjectTypeResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectTypeProvider"
        ]
      },
      "post": {
        "operationId": "SchoolSubjectTypeProviderController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateSchoolSubjectTypeDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolSubjectTypeResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectTypeProvider"
        ]
      }
    },
    "/provider/school-subject-types/{id}": {
      "put": {
        "operationId": "SchoolSubjectTypeProviderController_update",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateSchoolSubjectTypeDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolSubjectTypeResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectTypeProvider"
        ]
      },
      "delete": {
        "operationId": "SchoolSubjectTypeProviderController_delete",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectTypeProvider"
        ]
      }
    },
    "/provider/school-subject-type-classifier/subjects": {
      "post": {
        "operationId": "SchoolSubjectTypeClassifierProviderController_classifyAllSubjects",
        "parameters": [],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/AsyncOperationCreatedResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectTypeClassifierProvider"
        ]
      }
    },
    "/provider/school-subject-type-classifier/subjects/selected": {
      "post": {
        "operationId": "SchoolSubjectTypeClassifierProviderController_classifySelectedSubjects",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/ClassifySchoolSubjectsDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/AsyncOperationCreatedResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectTypeClassifierProvider"
        ]
      }
    },
    "/provider/school-subject-type-classifier/materials": {
      "post": {
        "operationId": "SchoolSubjectTypeClassifierProviderController_classifyAllMaterials",
        "parameters": [],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ClassifyMaterialsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectTypeClassifierProvider"
        ]
      }
    },
    "/provider/school-subject-type-classifier/materials/selected": {
      "post": {
        "operationId": "SchoolSubjectTypeClassifierProviderController_classifySelectedMaterials",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/ClassifyExternalMaterialsDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ClassifyMaterialsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectTypeClassifierProvider"
        ]
      }
    },
    "/external-materials/custom": {
      "post": {
        "operationId": "ExternalMaterialController_createCustom",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateCustomExternalMaterialDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CustomExternalMaterialResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ExternalMaterial"
        ]
      }
    },
    "/provider/external-materials": {
      "get": {
        "operationId": "ExternalMaterialProviderController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          },
          {
            "name": "search",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "onlyWithoutTypes",
            "required": false,
            "in": "query",
            "schema": {
              "type": "boolean"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedExternalMaterialResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ExternalMaterialProvider"
        ]
      },
      "post": {
        "operationId": "ExternalMaterialProviderController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateExternalMaterialDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ExternalMaterialResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ExternalMaterialProvider"
        ]
      }
    },
    "/provider/external-materials/{id}": {
      "put": {
        "operationId": "ExternalMaterialProviderController_update",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateExternalMaterialDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ExternalMaterialResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ExternalMaterialProvider"
        ]
      },
      "delete": {
        "operationId": "ExternalMaterialProviderController_delete",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ExternalMaterialProvider"
        ]
      }
    },
    "/provider/external-materials/import": {
      "post": {
        "operationId": "ExternalMaterialProviderController_importCatalog",
        "parameters": [],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ExternalMaterialImportResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ExternalMaterialProvider"
        ]
      }
    },
    "/provider/external-materials/{id}/logo": {
      "put": {
        "operationId": "ExternalMaterialProviderController_setLogo",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/FileReferenceDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ExternalMaterialResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ExternalMaterialProvider"
        ]
      },
      "delete": {
        "operationId": "ExternalMaterialProviderController_removeLogo",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ExternalMaterialResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ExternalMaterialProvider"
        ]
      }
    },
    "/external-materials/recommendations": {
      "get": {
        "operationId": "ExternalMaterialRecommenderController_recommendMaterials",
        "parameters": [
          {
            "name": "schoolSubjectId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "schoolClassId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "search",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ExternalMaterialRecommendationsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ExternalMaterialRecommender"
        ]
      }
    },
    "/school-types": {
      "get": {
        "operationId": "SchoolTypeController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedSchoolTypeResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolType"
        ]
      }
    },
    "/provider/school-types": {
      "post": {
        "operationId": "SchoolTypeProviderController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateSchoolTypeDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolTypeResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolTypeProvider"
        ]
      }
    },
    "/provider/school-types/{id}": {
      "put": {
        "operationId": "SchoolTypeProviderController_update",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateSchoolTypeDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolTypeResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolTypeProvider"
        ]
      },
      "delete": {
        "operationId": "SchoolTypeProviderController_delete",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolTypeProvider"
        ]
      }
    },
    "/subjects/templates/move": {
      "patch": {
        "operationId": "SchoolSubjectGroupController_moveTemplates",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/MoveSchoolSubjectTemplatesDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectGroup"
        ]
      }
    },
    "/classes/{schoolClassId}/school-subject-groups": {
      "post": {
        "operationId": "SchoolSubjectGroupController_create",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateSchoolSubjectGroupDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolSubjectGroupResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectGroup"
        ]
      },
      "get": {
        "operationId": "SchoolSubjectGroupController_retrieveAllForClass",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedSchoolSubjectGroupResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectGroup"
        ]
      }
    },
    "/school-subject-groups/{groupId}": {
      "delete": {
        "operationId": "SchoolSubjectGroupController_delete",
        "parameters": [
          {
            "name": "groupId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectGroup"
        ]
      },
      "put": {
        "operationId": "SchoolSubjectGroupController_update",
        "parameters": [
          {
            "name": "groupId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateSchoolSubjectGroupDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolSubjectGroupResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectGroup"
        ]
      }
    },
    "/school-subject-groups/{groupId}/assign": {
      "patch": {
        "operationId": "SchoolSubjectGroupController_assignSubjects",
        "parameters": [
          {
            "name": "groupId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/AssignSubjectDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectGroup"
        ]
      }
    },
    "/school-subject-groups/{groupId}/unassign": {
      "patch": {
        "operationId": "SchoolSubjectGroupController_unassignSubjects",
        "parameters": [
          {
            "name": "groupId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UnassignSubjectDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectGroup"
        ]
      }
    },
    "/school-subjects/reorder-unassigned": {
      "patch": {
        "operationId": "SchoolSubjectGroupController_reorderUnassignedSubjects",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/ReorderUnassignedSubjectDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectGroup"
        ]
      }
    },
    "/school-subject-groups/templates/tenant": {
      "get": {
        "operationId": "SchoolSubjectGroupController_listTenantTemplates",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedSchoolSubjectGroupResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectGroup"
        ]
      },
      "post": {
        "operationId": "SchoolSubjectGroupController_createTenantTemplate",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateSchoolSubjectGroupDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolSubjectGroupResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectGroup"
        ]
      }
    },
    "/school-subject-groups/global-templates": {
      "get": {
        "operationId": "SchoolSubjectGroupController_retrieveGlobalTemplates",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedSchoolSubjectGroupResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectGroup"
        ]
      }
    },
    "/provider/school-subject-groups/templates": {
      "get": {
        "operationId": "SchoolSubjectGroupProviderController_listProviderTemplates",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedSchoolSubjectGroupResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectGroupProvider"
        ]
      }
    },
    "/provider/school-subject-groups/templates/global": {
      "post": {
        "operationId": "SchoolSubjectGroupProviderController_createProviderTemplate",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateSchoolSubjectGroupProviderDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolSubjectGroupResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectGroupProvider"
        ]
      }
    },
    "/provider/school-subject-groups/{groupId}/assign": {
      "patch": {
        "operationId": "SchoolSubjectGroupProviderController_assignProviderSubjects",
        "parameters": [
          {
            "name": "groupId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/AssignSubjectDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectGroupProvider"
        ]
      }
    },
    "/provider/school-subject-groups/{groupId}/unassign": {
      "patch": {
        "operationId": "SchoolSubjectGroupProviderController_unassignProviderSubjects",
        "parameters": [
          {
            "name": "groupId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UnassignSubjectDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectGroupProvider"
        ]
      }
    },
    "/provider/school-subjects/reorder-unassigned": {
      "patch": {
        "operationId": "SchoolSubjectGroupProviderController_reorderProviderUnassignedSubjects",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/ReorderUnassignedSubjectDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectGroupProvider"
        ]
      }
    },
    "/competence-assessments": {
      "get": {
        "operationId": "CompetenceAssessmentController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedCompetenceAssessmentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CompetenceAssessment"
        ]
      }
    },
    "/competence-assessments/{id}/change-visual": {
      "patch": {
        "operationId": "CompetenceAssessmentController_changeVisual",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/ChangeCompetenceAssessmentVisualDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CompetenceAssessmentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CompetenceAssessment"
        ]
      }
    },
    "/competence-assessments/{id}/configuration": {
      "patch": {
        "operationId": "CompetenceAssessmentController_updateVisualAndLevelTexts",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateCompetenceAssessmentConfigurationDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CompetenceAssessmentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CompetenceAssessment"
        ]
      }
    },
    "/provider/competence-assessments": {
      "post": {
        "operationId": "CompetenceAssessmentProviderController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateCompetenceAssessmentDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CompetenceAssessmentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CompetenceAssessmentProvider"
        ]
      },
      "get": {
        "operationId": "CompetenceAssessmentProviderController_list",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedCompetenceAssessmentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CompetenceAssessmentProvider"
        ]
      }
    },
    "/provider/competence-assessments/{id}": {
      "put": {
        "operationId": "CompetenceAssessmentProviderController_update",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateCompetenceAssessmentDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CompetenceAssessmentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CompetenceAssessmentProvider"
        ]
      }
    },
    "/performance-assessment-entries/{id}": {
      "get": {
        "operationId": "PerformanceAssessmentEntryController_retrieveById",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PerformanceAssessmentEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceAssessmentEntry"
        ]
      },
      "put": {
        "operationId": "PerformanceAssessmentEntryController_update",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdatePerformanceAssessmentEntryDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PerformanceAssessmentEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceAssessmentEntry"
        ]
      },
      "delete": {
        "operationId": "PerformanceAssessmentEntryController_delete",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceAssessmentEntry"
        ]
      }
    },
    "/performance-assessment-entries": {
      "post": {
        "operationId": "PerformanceAssessmentEntryController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreatePerformanceAssessmentEntryDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PerformanceAssessmentEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceAssessmentEntry"
        ]
      }
    },
    "/performance-assessment-entries/{id}/competences": {
      "post": {
        "operationId": "PerformanceAssessmentEntryController_addCompetences",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/AddCompetencesToEntryDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceAssessmentEntry"
        ]
      },
      "put": {
        "operationId": "PerformanceAssessmentEntryController_setCompetences",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/SetPerformanceAssessmentEntryCompetencesDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PerformanceAssessmentEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceAssessmentEntry"
        ]
      }
    },
    "/performance-assessment-entries/{id}/competences/{competenceId}": {
      "delete": {
        "operationId": "PerformanceAssessmentEntryController_removeCompetence",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "competenceId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceAssessmentEntry"
        ]
      }
    },
    "/performance-assessment-entries/duplicate": {
      "post": {
        "operationId": "PerformanceAssessmentEntryController_duplicate",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/DuplicatePerformanceAssessmentEntryDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PerformanceAssessmentEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceAssessmentEntry"
        ]
      }
    },
    "/performance-assessment-entries/{id}/pdf": {
      "post": {
        "operationId": "PerformanceAssessmentEntryController_startPdfExport",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/StartPerformanceAssessmentEntryPdfDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/AsyncOperationCreatedResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceAssessmentEntry"
        ]
      }
    },
    "/performance-assessment-student-entries/overview": {
      "get": {
        "operationId": "PerformanceAssessmentStudentEntryController_retrieveOverview",
        "parameters": [
          {
            "name": "classId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "subjectId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "performanceAssessmentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "studentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "from",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "to",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "maximum": 1000,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PerformanceAssessmentStudentEntryOverviewResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceAssessmentStudentEntry"
        ]
      }
    },
    "/performance-assessment-student-entries": {
      "post": {
        "operationId": "PerformanceAssessmentStudentEntryController_createBulk",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreatePerformanceAssessmentStudentEntryDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceAssessmentStudentEntry"
        ]
      }
    },
    "/performance-assessment-student-entries/{id}": {
      "put": {
        "operationId": "PerformanceAssessmentStudentEntryController_update",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdatePerformanceAssessmentStudentEntryDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PerformanceAssessmentStudentEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceAssessmentStudentEntry"
        ]
      },
      "delete": {
        "operationId": "PerformanceAssessmentStudentEntryController_delete",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PerformanceAssessmentStudentEntry"
        ]
      }
    },
    "/notes": {
      "post": {
        "operationId": "NoteController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateNoteDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/NoteResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Note"
        ]
      }
    },
    "/notes/{id}": {
      "get": {
        "operationId": "NoteController_retrieveById",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/NoteResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Note"
        ]
      },
      "put": {
        "operationId": "NoteController_update",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateNoteDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/NoteResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Note"
        ]
      },
      "delete": {
        "operationId": "NoteController_delete",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Note"
        ]
      }
    },
    "/observation-timeline-entries/stats": {
      "get": {
        "operationId": "ObservationTimelineController_retrieveStats",
        "parameters": [
          {
            "name": "entryType",
            "required": false,
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/ObservationTimelineEntryType"
            }
          },
          {
            "name": "performanceAssessmentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "filterIncomplete",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string",
              "enum": [
                "true",
                "false"
              ]
            }
          },
          {
            "name": "filterActiveSupportMeasures",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string",
              "enum": [
                "true",
                "false"
              ]
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "schoolSubjectId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "competenceId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "competenceDomainId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "filterString",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "fromDate",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "toDate",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "includeSupportMeasures",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string",
              "enum": [
                "true",
                "false"
              ]
            }
          },
          {
            "name": "schoolClassId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "studentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ObservationTimelineStatsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ObservationTimeline"
        ]
      }
    },
    "/observation-timeline-entries": {
      "get": {
        "operationId": "ObservationTimelineController_retrieve",
        "parameters": [
          {
            "name": "entryType",
            "required": false,
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/ObservationTimelineEntryType"
            }
          },
          {
            "name": "performanceAssessmentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "filterIncomplete",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string",
              "enum": [
                "true",
                "false"
              ]
            }
          },
          {
            "name": "filterActiveSupportMeasures",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string",
              "enum": [
                "true",
                "false"
              ]
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "schoolSubjectId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "competenceId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "competenceDomainId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "filterString",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "fromDate",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "toDate",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "includeSupportMeasures",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string",
              "enum": [
                "true",
                "false"
              ]
            }
          },
          {
            "name": "schoolClassId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "studentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedObservationTimelineSummaryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ObservationTimeline"
        ]
      }
    },
    "/observation-timeline-entries/{entryType}/{id}": {
      "get": {
        "operationId": "ObservationTimelineController_retrieveById",
        "parameters": [
          {
            "name": "entryType",
            "required": true,
            "in": "path",
            "schema": {
              "$ref": "#/components/schemas/ObservationTimelineEntryType"
            }
          },
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "schoolClassId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "studentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ObservationTimelineEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ObservationTimeline"
        ]
      }
    },
    "/support-measure-entries": {
      "post": {
        "operationId": "SupportMeasureEntryController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateSupportMeasureEntryDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SupportMeasureEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SupportMeasureEntry"
        ]
      }
    },
    "/support-measure-entries/{id}": {
      "get": {
        "operationId": "SupportMeasureEntryController_retrieveById",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SupportMeasureEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SupportMeasureEntry"
        ]
      },
      "put": {
        "operationId": "SupportMeasureEntryController_update",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateSupportMeasureEntryDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SupportMeasureEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SupportMeasureEntry"
        ]
      },
      "delete": {
        "operationId": "SupportMeasureEntryController_delete",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SupportMeasureEntry"
        ]
      }
    },
    "/support-measure-entries/{id}/students": {
      "get": {
        "operationId": "SupportMeasureEntryController_retrieveStudents",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SupportMeasureFilterStudentsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SupportMeasureEntry"
        ]
      },
      "post": {
        "operationId": "SupportMeasureEntryController_addStudents",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/AddStudentsToSupportMeasureEntryDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SupportMeasureEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SupportMeasureEntry"
        ]
      },
      "put": {
        "operationId": "SupportMeasureEntryController_setStudents",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/SetSupportMeasureEntryStudentsDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SupportMeasureEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SupportMeasureEntry"
        ]
      }
    },
    "/support-measure-entries/{id}/competences": {
      "post": {
        "operationId": "SupportMeasureEntryController_addCompetences",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/AddCompetencesToSupportMeasureEntryDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SupportMeasureEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SupportMeasureEntry"
        ]
      },
      "put": {
        "operationId": "SupportMeasureEntryController_setCompetences",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/SetSupportMeasureEntryCompetencesDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SupportMeasureEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SupportMeasureEntry"
        ]
      }
    },
    "/support-measure-entries/{id}/competences/{competenceId}": {
      "delete": {
        "operationId": "SupportMeasureEntryController_removeCompetence",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "competenceId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SupportMeasureEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SupportMeasureEntry"
        ]
      }
    },
    "/support-measure-entries/{id}/students/{studentId}": {
      "post": {
        "operationId": "SupportMeasureEntryController_removeStudent",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "studentId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SupportMeasureEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SupportMeasureEntry"
        ]
      },
      "delete": {
        "operationId": "SupportMeasureEntryController_deleteStudent",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "studentId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SupportMeasureEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SupportMeasureEntry"
        ]
      }
    },
    "/support-measure-entries/{id}/materials": {
      "post": {
        "operationId": "SupportMeasureEntryController_addMaterials",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/AddMaterialsToSupportMeasureEntryDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SupportMeasureEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SupportMeasureEntry"
        ]
      },
      "put": {
        "operationId": "SupportMeasureEntryController_setMaterials",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/SetSupportMeasureEntryMaterialsDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SupportMeasureEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SupportMeasureEntry"
        ]
      }
    },
    "/support-measure-entries/{id}/materials/{externalMaterialId}": {
      "delete": {
        "operationId": "SupportMeasureEntryController_removeMaterial",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "externalMaterialId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SupportMeasureEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SupportMeasureEntry"
        ]
      }
    },
    "/support-measure-entries/{id}/protocol": {
      "post": {
        "operationId": "SupportMeasureEntryController_createProtocolEntry",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateSupportMeasureProtocolEntryDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CreatedSupportMeasureProtocolEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SupportMeasureEntry"
        ]
      }
    },
    "/support-measure-entries/protocol/{protocolEntryId}": {
      "put": {
        "operationId": "SupportMeasureEntryController_updateProtocolEntry",
        "parameters": [
          {
            "name": "protocolEntryId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateSupportMeasureProtocolEntryDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SupportMeasureEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SupportMeasureEntry"
        ]
      },
      "delete": {
        "operationId": "SupportMeasureEntryController_deleteProtocolEntry",
        "parameters": [
          {
            "name": "protocolEntryId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SupportMeasureEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SupportMeasureEntry"
        ]
      }
    },
    "/support-measure-entries/protocol/{protocolEntryId}/rating": {
      "put": {
        "operationId": "SupportMeasureEntryController_setProtocolEntryRating",
        "parameters": [
          {
            "name": "protocolEntryId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/SetSupportMeasureProtocolEntryRatingDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SupportMeasureEntryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SupportMeasureEntry"
        ]
      }
    },
    "/support-measure-entries/{id}/pdf-data": {
      "get": {
        "operationId": "SupportMeasureEntryController_retrieveReportPdfData",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "studentIds",
            "required": false,
            "in": "query",
            "description": "Defaults to the current members of the measure.",
            "schema": {
              "type": "array",
              "items": {
                "type": "number"
              }
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SupportMeasureReportPdfDataResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SupportMeasureEntry"
        ]
      }
    },
    "/support-measure-entries/{id}/pdf": {
      "post": {
        "operationId": "SupportMeasureEntryController_startPdfExport",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/StartSupportMeasureReportPdfDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/AsyncOperationCreatedResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SupportMeasureEntry"
        ]
      }
    },
    "/countries": {
      "get": {
        "operationId": "CountryController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedCountryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Country"
        ]
      }
    },
    "/provider/countries": {
      "post": {
        "operationId": "CountryProviderController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateCountryDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CountryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CountryProvider"
        ]
      }
    },
    "/provider/countries/{id}": {
      "put": {
        "operationId": "CountryProviderController_update",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateCountryDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CountryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CountryProvider"
        ]
      },
      "delete": {
        "operationId": "CountryProviderController_delete",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CountryProvider"
        ]
      }
    },
    "/provider/languages": {
      "get": {
        "operationId": "LanguageProviderController_retrieve",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/LanguageListResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "LanguageProvider"
        ]
      },
      "post": {
        "operationId": "LanguageProviderController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateLanguageDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/LanguageResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "LanguageProvider"
        ]
      }
    },
    "/provider/languages/{languageId}": {
      "put": {
        "operationId": "LanguageProviderController_update",
        "parameters": [
          {
            "name": "languageId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateLanguageDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/LanguageResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "LanguageProvider"
        ]
      },
      "delete": {
        "operationId": "LanguageProviderController_delete",
        "parameters": [
          {
            "name": "languageId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "LanguageProvider"
        ]
      }
    },
    "/provider/queue/jobs": {
      "get": {
        "operationId": "QueueProviderController_retrieveQueueJobs",
        "parameters": [
          {
            "name": "category",
            "required": true,
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/QueueJobCategory"
            }
          },
          {
            "name": "offset",
            "required": true,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": true,
            "in": "query",
            "schema": {
              "minimum": 1,
              "maximum": 100,
              "default": 10,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/QueueJobsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "QueueProvider"
        ]
      }
    },
    "/provider/queue/executions": {
      "get": {
        "operationId": "QueueProviderController_retrieveQueueExecutions",
        "parameters": [
          {
            "name": "offset",
            "required": true,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": true,
            "in": "query",
            "schema": {
              "minimum": 1,
              "maximum": 100,
              "default": 10,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/QueueExecutionsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "QueueProvider"
        ]
      }
    },
    "/provider/queue/reset": {
      "post": {
        "operationId": "QueueProviderController_resetQueue",
        "parameters": [],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/QueueResetResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "QueueProvider"
        ]
      }
    },
    "/provider/queue/jobs/{graphileJobId}/execute-now": {
      "post": {
        "operationId": "QueueProviderController_executeQueueJobNow",
        "parameters": [
          {
            "name": "graphileJobId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/QueueJobActionResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "QueueProvider"
        ]
      }
    },
    "/provider/cron": {
      "get": {
        "operationId": "CronProviderController_retrieveCronJobs",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CronJobsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "CronProvider"
        ]
      }
    },
    "/provider/subjects": {
      "get": {
        "operationId": "SchoolSubjectProviderController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          },
          {
            "name": "search",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "onlyWithoutTypes",
            "required": false,
            "in": "query",
            "schema": {
              "type": "boolean"
            }
          },
          {
            "name": "onlyNotClassifiable",
            "required": false,
            "in": "query",
            "schema": {
              "type": "boolean"
            }
          },
          {
            "name": "schoolTypeId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedProviderSchoolSubjectResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectProvider"
        ]
      }
    },
    "/provider/subjects/{schoolSubjectId}/types": {
      "put": {
        "operationId": "SchoolSubjectProviderController_setTypes",
        "parameters": [
          {
            "name": "schoolSubjectId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/SetSchoolSubjectTypesDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ProviderSchoolSubjectResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectProvider"
        ]
      }
    },
    "/provider/subjects/templates": {
      "post": {
        "operationId": "SchoolSubjectProviderController_createSubjectTemplate",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateSchoolSubjectProviderDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolSubjectResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectProvider"
        ]
      }
    },
    "/provider/subjects/templates/{schoolSubjectId}": {
      "put": {
        "operationId": "SchoolSubjectProviderController_updateSubjectTemplate",
        "parameters": [
          {
            "name": "schoolSubjectId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateSchoolSubjectProviderDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolSubjectResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectProvider"
        ]
      }
    },
    "/provider/subjects/{schoolSubjectId}/competence-domains/template": {
      "post": {
        "operationId": "SchoolSubjectProviderController_createCompetenceDomainTemplate",
        "parameters": [
          {
            "name": "schoolSubjectId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateCompetenceDomainDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CompetenceDomainResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolSubjectProvider"
        ]
      }
    },
    "/provider/users": {
      "get": {
        "operationId": "UserProviderController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "sortBy",
            "required": false,
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/ProviderUserSortField"
            }
          },
          {
            "name": "sortDirection",
            "required": false,
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/SortOrder"
            }
          },
          {
            "name": "search",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UserDataWithCountsPaginatedResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "UserProvider"
        ]
      }
    },
    "/provider/users/{userId}/email-changes": {
      "get": {
        "operationId": "UserProviderController_retrieveEmailChanges",
        "parameters": [
          {
            "name": "userId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UserEmailChangesResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "UserProvider"
        ]
      }
    },
    "/provider/users/{userId}/attribution": {
      "get": {
        "operationId": "UserProviderController_retrieveAttribution",
        "parameters": [
          {
            "name": "userId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UserAttributionResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "UserProvider"
        ]
      }
    },
    "/provider/users/{userId}/approve": {
      "post": {
        "operationId": "UserProviderController_approve",
        "parameters": [
          {
            "name": "userId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "UserProvider"
        ]
      }
    },
    "/provider/users/{userId}/revoke": {
      "post": {
        "operationId": "UserProviderController_revoke",
        "parameters": [
          {
            "name": "userId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "UserProvider"
        ]
      }
    },
    "/provider/users/{userId}/deactivate": {
      "post": {
        "operationId": "UserProviderController_deactivate",
        "parameters": [
          {
            "name": "userId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "UserProvider"
        ]
      }
    },
    "/provider/users/{userId}": {
      "delete": {
        "operationId": "UserProviderController_delete",
        "parameters": [
          {
            "name": "userId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "UserProvider"
        ]
      }
    },
    "/provider/users/{userId}/revoke-deletion": {
      "post": {
        "operationId": "UserProviderController_revokeDeletion",
        "parameters": [
          {
            "name": "userId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "UserProvider"
        ]
      }
    },
    "/provider/users/{userId}/reset-tfa": {
      "post": {
        "operationId": "UserProviderController_resetTfa",
        "parameters": [
          {
            "name": "userId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "UserProvider"
        ]
      }
    },
    "/provider/users/{userId}/send-weekly-report": {
      "post": {
        "operationId": "UserProviderController_sendWeeklyReport",
        "parameters": [
          {
            "name": "userId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "UserProvider"
        ]
      }
    },
    "/schools/search": {
      "get": {
        "operationId": "SchoolController_search",
        "parameters": [
          {
            "name": "countryId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "searchQuery",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolWithTenantCountAndRelationsPaginatedResponse"
                }
              }
            }
          }
        },
        "tags": [
          "School"
        ]
      }
    },
    "/schools/{schoolId}": {
      "get": {
        "operationId": "SchoolController_get",
        "parameters": [
          {
            "name": "schoolId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolWithTenantCountAndRelationsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "School"
        ]
      },
      "put": {
        "operationId": "SchoolProviderController_update",
        "parameters": [
          {
            "name": "schoolId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateSchoolDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolProvider"
        ]
      },
      "delete": {
        "operationId": "SchoolProviderController_delete",
        "parameters": [
          {
            "name": "schoolId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolProvider"
        ]
      }
    },
    "/schools/import": {
      "post": {
        "operationId": "SchoolProviderController_import",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "multipart/form-data": {
              "schema": {
                "type": "object",
                "required": [
                  "file"
                ],
                "properties": {
                  "file": {
                    "type": "string",
                    "format": "binary"
                  }
                }
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CreateSchoolImportResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolProvider"
        ]
      }
    },
    "/schools": {
      "get": {
        "operationId": "SchoolProviderController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          },
          {
            "name": "search",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolWithTenantCountAndRelationsPaginatedResponse"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolProvider"
        ]
      },
      "post": {
        "operationId": "SchoolProviderController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateSchoolDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolProvider"
        ]
      }
    },
    "/releases/{releaseId}": {
      "get": {
        "operationId": "ReleaseController_get",
        "parameters": [
          {
            "name": "releaseId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ReleaseWithContentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Release"
        ]
      },
      "put": {
        "operationId": "ReleaseProviderController_update",
        "parameters": [
          {
            "name": "releaseId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateReleaseDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ReleaseResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ReleaseProvider"
        ]
      },
      "post": {
        "operationId": "ReleaseProviderController_releaseNow",
        "parameters": [
          {
            "name": "releaseId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/AsyncOperationCreatedResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ReleaseProvider"
        ]
      }
    },
    "/releases/{releaseId}/banner-image": {
      "get": {
        "operationId": "ReleaseController_getPublicBannerImage",
        "parameters": [
          {
            "name": "releaseId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "summary": "Public, unauthenticated endpoint that serves the banner image bytes of a released\nrelease. Mirrors the inline release-content image endpoint — only rows that belong\nto a published release are served, so it is safe for e-mail embedding.",
        "tags": [
          "Release"
        ]
      },
      "post": {
        "operationId": "ReleaseProviderController_setBannerImage",
        "parameters": [
          {
            "name": "releaseId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/FileReferenceDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ReleaseResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ReleaseProvider"
        ]
      },
      "put": {
        "operationId": "ReleaseProviderController_replaceBannerImage",
        "parameters": [
          {
            "name": "releaseId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/FileReferenceDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ReleaseResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ReleaseProvider"
        ]
      },
      "delete": {
        "operationId": "ReleaseProviderController_deleteBannerImage",
        "parameters": [
          {
            "name": "releaseId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ReleaseProvider"
        ]
      }
    },
    "/releases": {
      "get": {
        "operationId": "ReleaseProviderController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ReleasePaginatedResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ReleaseProvider"
        ]
      },
      "post": {
        "operationId": "ReleaseProviderController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateReleaseDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ReleaseResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ReleaseProvider"
        ]
      }
    },
    "/releases/{releaseId}/test-email": {
      "post": {
        "operationId": "ReleaseProviderController_sendTestEmail",
        "parameters": [
          {
            "name": "releaseId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/SendReleaseTestEmailDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ReleaseProvider"
        ]
      }
    },
    "/release-content/{id}/image": {
      "get": {
        "operationId": "ReleaseContentController_getPublicImage",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "summary": "Public, unauthenticated endpoint that serves the image bytes of a release-content\nimage row. Only rows that belong to a released release are served.\nUsed for embedding images in release-note e-mails, where signed S3 URLs are unsuitable\nbecause they expire after a short window.",
        "tags": [
          "ReleaseContent"
        ]
      },
      "put": {
        "operationId": "ReleaseContentProviderController_replaceImage",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/FileReferenceDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ReleaseContentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ReleaseContentProvider"
        ]
      },
      "delete": {
        "operationId": "ReleaseContentProviderController_deleteImage",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ReleaseContentProvider"
        ]
      }
    },
    "/release-content/release/{releaseId}/image": {
      "post": {
        "operationId": "ReleaseContentProviderController_setImage",
        "parameters": [
          {
            "name": "releaseId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/FileReferenceDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ReleaseContentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ReleaseContentProvider"
        ]
      }
    },
    "/faqs": {
      "get": {
        "operationId": "FaqController_list",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/FaqCategoryWithArticlesPaginatedResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Faq"
        ]
      }
    },
    "/help-videos": {
      "get": {
        "operationId": "HelpVideoController_list",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/HelpVideoPaginatedResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "HelpVideo"
        ]
      }
    },
    "/api-tokens/create-token": {
      "get": {
        "operationId": "ApiTokenController_createToken",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiCreateTokenResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ApiToken"
        ]
      }
    },
    "/api-tokens": {
      "get": {
        "operationId": "ApiTokenController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedApiTokenResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ApiToken"
        ]
      },
      "post": {
        "operationId": "ApiTokenController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateApiTokenDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiTokenResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ApiToken"
        ]
      }
    },
    "/api-tokens/{id}": {
      "get": {
        "operationId": "ApiTokenController_get",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiTokenResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ApiToken"
        ]
      },
      "put": {
        "operationId": "ApiTokenController_update",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateApiTokenDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiTokenResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ApiToken"
        ]
      },
      "delete": {
        "operationId": "ApiTokenController_delete",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ApiToken"
        ]
      }
    },
    "/statistics/base": {
      "get": {
        "operationId": "StatisticsController_getBaseStatistics",
        "parameters": [
          {
            "name": "startDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "endDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "excludeDemoClasses",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "roleType",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "country",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/BaseStatisticsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Statistics"
        ]
      }
    },
    "/statistics/user-types": {
      "get": {
        "operationId": "StatisticsController_getUserTypeStatistics",
        "parameters": [
          {
            "name": "startDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "endDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "roleType",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "country",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UserTypeStatisticsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Statistics"
        ]
      }
    },
    "/statistics/joined-usage": {
      "get": {
        "operationId": "StatisticsController_getJoinedUsageStatistics",
        "parameters": [
          {
            "name": "startDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "endDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "roleType",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "country",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "devicePlatform",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/JoinedUsageStatisticsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Statistics"
        ]
      }
    },
    "/statistics/product-status": {
      "get": {
        "operationId": "StatisticsController_getProductStatusStatistics",
        "parameters": [
          {
            "name": "startDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "endDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "roleType",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "country",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ProductStatusStatisticsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Statistics"
        ]
      }
    },
    "/statistics/acquisition-sources": {
      "get": {
        "operationId": "StatisticsController_getAcquisitionSourceStatistics",
        "parameters": [
          {
            "name": "startDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "endDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "roleType",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "country",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/AcquisitionSourceStatisticsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Statistics"
        ]
      }
    },
    "/statistics/star-ratings": {
      "get": {
        "operationId": "StatisticsController_getStarRatingStatistics",
        "parameters": [
          {
            "name": "startDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "endDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "roleType",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "country",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/StarRatingStatisticsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Statistics"
        ]
      }
    },
    "/statistics/role-distribution": {
      "get": {
        "operationId": "StatisticsController_getRoleDistributionStatistics",
        "parameters": [
          {
            "name": "startDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "endDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "roleType",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "country",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/RoleDistributionStatisticsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Statistics"
        ]
      }
    },
    "/statistics/entry-activity": {
      "get": {
        "operationId": "StatisticsController_getEntryActivityStatistics",
        "parameters": [
          {
            "name": "startDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "endDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "roleType",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "resolution",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "country",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/EntryActivityStatisticsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Statistics"
        ]
      }
    },
    "/statistics/new-users": {
      "get": {
        "operationId": "StatisticsController_getNewUsersStatistics",
        "parameters": [
          {
            "name": "startDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "endDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "roleType",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "resolution",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "country",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/NewUsersStatisticsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Statistics"
        ]
      }
    },
    "/statistics/timeline-activity": {
      "get": {
        "operationId": "StatisticsController_getTimelineActivityStatistics",
        "parameters": [
          {
            "name": "startDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "endDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "roleType",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "resolution",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "country",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TimelineActivityStatisticsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Statistics"
        ]
      }
    },
    "/statistics/report-distribution": {
      "get": {
        "operationId": "StatisticsController_getReportDistributionStatistics",
        "parameters": [
          {
            "name": "startDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "endDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "roleType",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "country",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ReportDistributionStatisticsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Statistics"
        ]
      }
    },
    "/statistics/school-type-distribution": {
      "get": {
        "operationId": "StatisticsController_getSchoolTypeDistributionStatistics",
        "parameters": [
          {
            "name": "startDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "endDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "roleType",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "country",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolTypeDistributionStatisticsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Statistics"
        ]
      }
    },
    "/statistics/tenant-location-distribution": {
      "get": {
        "operationId": "StatisticsController_getTenantLocationDistributionStatistics",
        "parameters": [
          {
            "name": "startDate",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "endDate",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "roleType",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "country",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TenantLocationDistributionStatisticsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Statistics"
        ]
      }
    },
    "/statistics/login-provider-distribution": {
      "get": {
        "operationId": "StatisticsController_getLoginProviderDistributionStatistics",
        "parameters": [
          {
            "name": "startDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "endDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "roleType",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "country",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/LoginProviderDistributionStatisticsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Statistics"
        ]
      }
    },
    "/statistics/trial-expired-feedback": {
      "get": {
        "operationId": "StatisticsController_getTrialExpiredFeedbackStatistics",
        "parameters": [
          {
            "name": "startDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "endDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "roleType",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "country",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TrialExpiredFeedbackStatisticsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Statistics"
        ]
      }
    },
    "/statistics/onboarding-funnel": {
      "get": {
        "operationId": "StatisticsController_getOnboardingFunnelStatistics",
        "parameters": [
          {
            "name": "startDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "endDate",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "roleType",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "country",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "funnelMode",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/OnboardingFunnelStatisticsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Statistics"
        ]
      }
    },
    "/onboard/user": {
      "put": {
        "operationId": "OnboardController_setUserOnboarded",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Onboard"
        ]
      }
    },
    "/onboard/tenant": {
      "post": {
        "operationId": "OnboardController_onboardTenant",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateTenantDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TenantWithDemoClassResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Onboard"
        ]
      }
    },
    "/onboard/invitations/accept": {
      "post": {
        "operationId": "OnboardController_acceptCode",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/AcceptInvitationDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Onboard"
        ]
      }
    },
    "/billing/onboarding-checkout/info": {
      "get": {
        "operationId": "OnboardingCheckoutController_getOnboardingCheckoutInfo",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/BillingOnboardingCheckoutInfoResponseDto"
                }
              }
            }
          }
        },
        "summary": "The purchase offer (discount percent, promotion state, publishable key, trial days).\nNull hides the purchase screens — the onboarding must never block on billing (fail open).",
        "tags": [
          "OnboardingCheckout"
        ]
      }
    },
    "/billing/onboarding-checkout/preview": {
      "post": {
        "operationId": "OnboardingCheckoutController_previewOnboardingCheckout",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/OnboardingCheckoutPreviewDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/OnboardingCheckoutPreviewResponseDto"
                }
              }
            }
          }
        },
        "summary": "Tenantless order-summary preview; VAT derives from the country of the school that is about to be created.",
        "tags": [
          "OnboardingCheckout"
        ]
      }
    },
    "/billing/onboarding-checkout/session": {
      "post": {
        "operationId": "OnboardingCheckoutController_startOnboardingCheckoutSession",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/OnboardingCheckoutSessionDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/OnboardingCheckoutSessionResponseDto"
                }
              }
            }
          }
        },
        "summary": "The buy click: validates the school configuration, snapshots it on a checkout draft and creates the\nincomplete subscription to confirm in-app (Stripe Payment Element). No tenant is created here.\nThrottled — every call creates Stripe objects.",
        "tags": [
          "OnboardingCheckout"
        ]
      }
    },
    "/billing/onboarding-checkout/complete": {
      "post": {
        "operationId": "OnboardingCheckoutController_completeOnboardingCheckout",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/OnboardingCheckoutCompleteDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/OnboardingCheckoutCompleteResponseDto"
                }
              }
            }
          }
        },
        "summary": "Verifies the payment against live Stripe state and provisions the tenant on success (idempotent).",
        "tags": [
          "OnboardingCheckout"
        ]
      }
    },
    "/billing/onboarding-checkout/pending": {
      "get": {
        "operationId": "OnboardingCheckoutController_getPendingOnboardingCheckout",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/OnboardingCheckoutPendingResponseDto"
                }
              }
            }
          }
        },
        "summary": "The checkout draft a tenant-less user should resume, so a paid-but-lost checkout (closed tab,\ncrashed browser) is picked up again without relying on client-side storage.",
        "tags": [
          "OnboardingCheckout"
        ]
      }
    },
    "/billing/onboarding-checkout/status/{draftId}": {
      "get": {
        "operationId": "OnboardingCheckoutController_getOnboardingCheckoutStatus",
        "parameters": [
          {
            "name": "draftId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/OnboardingCheckoutStatusResponseDto"
                }
              }
            }
          }
        },
        "summary": "Draft state + configuration snapshot — restores the checkout UI after a 3DS redirect and backs polling.",
        "tags": [
          "OnboardingCheckout"
        ]
      }
    },
    "/provider/onboarding-checkout-drafts": {
      "get": {
        "operationId": "OnboardingCheckoutProviderController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          },
          {
            "name": "search",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/OnboardingCheckoutDraftPaginatedResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "OnboardingCheckoutProvider"
        ]
      }
    },
    "/provider/onboarding-checkout-drafts/{draftUuid}/provision": {
      "post": {
        "operationId": "OnboardingCheckoutProviderController_provision",
        "parameters": [
          {
            "name": "draftUuid",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/OnboardingCheckoutDraftResolutionResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "OnboardingCheckoutProvider"
        ]
      }
    },
    "/provider/onboarding-checkout-drafts/{draftUuid}/discard": {
      "post": {
        "operationId": "OnboardingCheckoutProviderController_discard",
        "parameters": [
          {
            "name": "draftUuid",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/OnboardingCheckoutDraftResolutionResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "OnboardingCheckoutProvider"
        ]
      }
    },
    "/provider/referrals/tenants/{tenantId}": {
      "get": {
        "operationId": "ReferralProviderController_retrieveTenantReferral",
        "parameters": [
          {
            "name": "tenantId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ProviderTenantReferralResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ReferralProvider"
        ]
      }
    },
    "/provider/referrals/tenants/{tenantId}/grants": {
      "post": {
        "operationId": "ReferralProviderController_grantTenantDiscount",
        "parameters": [
          {
            "name": "tenantId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/ProviderGrantReferralDiscountDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ProviderTenantReferralResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "ReferralProvider"
        ]
      }
    },
    "/analysis/classes/{classId}/subject-scores": {
      "get": {
        "operationId": "AnalysisController_getClassSubjectScores",
        "parameters": [
          {
            "name": "classId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "studentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "subjectIds",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "type": "number"
              }
            }
          },
          {
            "name": "calculationType",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string",
              "enum": [
                "lastHistoricalEntry",
                "allHistoricalEntries"
              ]
            }
          },
          {
            "name": "from",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "to",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ClassSubjectScoresResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Analysis"
        ]
      }
    },
    "/analysis/classes/{classId}/subject-scores/count": {
      "get": {
        "operationId": "AnalysisController_getClassSubjectScoresCount",
        "parameters": [
          {
            "name": "classId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "studentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "subjectIds",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "type": "number"
              }
            }
          },
          {
            "name": "calculationType",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string",
              "enum": [
                "lastHistoricalEntry",
                "allHistoricalEntries"
              ]
            }
          },
          {
            "name": "from",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "to",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ClassSubjectScoresCountResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Analysis"
        ]
      }
    },
    "/user-feedback/account-deactivation/status": {
      "get": {
        "operationId": "UserFeedbackController_accountDeactivationStatus",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/AccountDeactivationFeedbackStatusResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "UserFeedback"
        ]
      }
    },
    "/user-feedback": {
      "post": {
        "operationId": "UserFeedbackController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateUserFeedbackDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UserFeedbackResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "UserFeedback"
        ]
      },
      "get": {
        "operationId": "UserFeedbackProviderController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          },
          {
            "name": "search",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedUserFeedbackResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "UserFeedbackProvider"
        ]
      }
    },
    "/user-feedback/{id}": {
      "put": {
        "operationId": "UserFeedbackController_update",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateUserFeedbackDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UserFeedbackResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "UserFeedback"
        ]
      },
      "get": {
        "operationId": "UserFeedbackController_retrieveById",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UserFeedbackDetailedResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "UserFeedback"
        ]
      },
      "delete": {
        "operationId": "UserFeedbackProviderController_delete",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "UserFeedbackProvider"
        ]
      }
    },
    "/user-feedback/user/{id}/should-see-rating-prompt": {
      "get": {
        "operationId": "UserFeedbackController_shouldSeeRatingPrompt",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UserShouldSeeRatingPromptResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "UserFeedback"
        ]
      }
    },
    "/user-feedback/{id}/handled": {
      "put": {
        "operationId": "UserFeedbackProviderController_setHandled",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/SetUserFeedbackHandledDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "UserFeedbackProvider"
        ]
      }
    },
    "/avatar-pictures/me": {
      "put": {
        "operationId": "AvatarPictureController_setMyAvatarPicture",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/FileReferenceDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UserDataResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "AvatarPicture"
        ]
      }
    },
    "/avatar-pictures/students/{id}": {
      "put": {
        "operationId": "AvatarPictureController_setStudentAvatarPicture",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/FileReferenceDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/StudentResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "AvatarPicture"
        ]
      }
    },
    "/files/{id}/url": {
      "get": {
        "operationId": "FileController_getSignedUrl",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "x-digidoo-shared-file",
            "required": false,
            "in": "header",
            "description": "Require files to be safe for shared output.",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/FileUrlResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "File"
        ]
      }
    },
    "/provider/files/monitoring": {
      "get": {
        "operationId": "FileMonitoringProviderController_retrieveMonitoring",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/FileMonitoringResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "FileMonitoringProvider"
        ]
      }
    },
    "/files/uploads": {
      "post": {
        "operationId": "FileUploadController_initiate",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/InitiateFileUploadDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/FileUploadPermitResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "FileUpload"
        ]
      }
    },
    "/files/uploads/{id}/complete": {
      "post": {
        "operationId": "FileUploadController_complete",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CompleteFileUploadDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/FileUploadResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "FileUpload"
        ]
      }
    },
    "/classes/{id}/appearance": {
      "put": {
        "operationId": "EntityAppearanceController_updateClassAppearance",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateEntityAppearanceDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolClassResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "EntityAppearance"
        ]
      }
    },
    "/classes/{id}/appearance/image": {
      "put": {
        "operationId": "EntityAppearanceController_setClassImage",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/FileReferenceDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolClassResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "EntityAppearance"
        ]
      }
    },
    "/async-operations/{uuid}": {
      "get": {
        "operationId": "AsyncOperationsController_getStatusByUuid",
        "parameters": [
          {
            "name": "uuid",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/AsyncOperationStatusResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "AsyncOperations"
        ]
      }
    },
    "/provider/emails": {
      "get": {
        "operationId": "EmailProviderController_retrieve",
        "parameters": [
          {
            "name": "type",
            "required": false,
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/EMailType"
            }
          },
          {
            "name": "search",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "maximum": 100,
              "default": 25,
              "type": "number"
            }
          },
          {
            "name": "userId",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ProviderEmailsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "EmailProvider"
        ]
      }
    },
    "/provider/emails/{id}": {
      "get": {
        "operationId": "EmailProviderController_retrieveOne",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ProviderEmailResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "EmailProvider"
        ]
      }
    },
    "/webhooks/ses/{secret}": {
      "post": {
        "operationId": "SesWebhookController_handle",
        "parameters": [
          {
            "name": "secret",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "SesWebhook"
        ]
      }
    },
    "/auth/auth-url/{providerId}": {
      "get": {
        "operationId": "CoreAuthController_getAuthUrl",
        "parameters": [
          {
            "name": "providerId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "loginHint",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "redirectUri",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "CoreAuth"
        ]
      }
    },
    "/auth/auth-attempt/{authAttemptId}/unlock": {
      "post": {
        "operationId": "CoreAuthController_unlockAuthAttempt",
        "parameters": [
          {
            "name": "authAttemptId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "CoreAuth"
        ]
      }
    },
    "/auth/auth-attempt/{id}/status": {
      "post": {
        "operationId": "CoreAuthController_getAuthAttemptStatus",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/GetAuthAttemptStatusDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "CoreAuth"
        ]
      }
    },
    "/auth/auth-attempt/{authAttemptId}/redeem": {
      "post": {
        "operationId": "CoreAuthController_redeemAuthAttempt",
        "parameters": [
          {
            "name": "authAttemptId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/RedeemAuthAttemptDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "CoreAuth"
        ]
      }
    },
    "/auth/logout": {
      "post": {
        "operationId": "CoreAuthController_logout",
        "parameters": [],
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "CoreAuth"
        ]
      }
    },
    "/auth/expire-other-sessions": {
      "post": {
        "operationId": "CoreAuthController_expireOtherSessions",
        "parameters": [],
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "CoreAuth"
        ]
      }
    },
    "/auth/local/login": {
      "post": {
        "operationId": "LocalLoginController_login",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/LocalLoginDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/LocalLoginResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "LocalLogin"
        ]
      }
    },
    "/auth/local/login-totp": {
      "post": {
        "operationId": "LocalLoginController_loginTotp",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/TfaLoginDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TfaLoginResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "LocalLogin"
        ]
      }
    },
    "/auth/local/login-email-otp": {
      "post": {
        "operationId": "LocalLoginController_loginEmailOtp",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/TfaLoginDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TfaLoginResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "LocalLogin"
        ]
      }
    },
    "/auth/tfa/enable": {
      "post": {
        "operationId": "TfaController_enableTfa",
        "parameters": [],
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "Tfa"
        ]
      }
    },
    "/auth/tfa/disable": {
      "post": {
        "operationId": "TfaController_disableTfa",
        "parameters": [],
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "Tfa"
        ]
      }
    },
    "/auth/tfa/status": {
      "get": {
        "operationId": "TfaController_getTfaStatus",
        "parameters": [],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "Tfa"
        ]
      }
    },
    "/auth/totp/generate-secret": {
      "post": {
        "operationId": "TotpController_generateSecret",
        "parameters": [],
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "Totp"
        ]
      }
    },
    "/auth/totp/enable": {
      "post": {
        "operationId": "TotpController_enable",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/EnableTotpDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "Totp"
        ]
      }
    },
    "/auth/totp/disable": {
      "post": {
        "operationId": "TotpController_disable",
        "parameters": [],
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "Totp"
        ]
      }
    },
    "/auth/totp/status": {
      "get": {
        "operationId": "TotpController_getStatus",
        "parameters": [],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "Totp"
        ]
      }
    },
    "/auth/email-otp/send-email": {
      "post": {
        "operationId": "EmailOtpController_sendEmail",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/SendEmailOtpDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "EmailOtp"
        ]
      }
    },
    "/auth/openid/callback/{authProviderId}": {
      "get": {
        "operationId": "OpenIdLoginController_callback",
        "parameters": [
          {
            "name": "authProviderId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "OpenIdLogin"
        ]
      },
      "post": {
        "operationId": "OpenIdLoginController_callbackPost",
        "parameters": [
          {
            "name": "authProviderId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "OpenIdLogin"
        ]
      }
    },
    "/auth/whoami": {
      "get": {
        "operationId": "AuthController_whoAmI",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/WhoAmIResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Auth"
        ]
      }
    },
    "/auth/register": {
      "post": {
        "operationId": "AuthController_register",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/LocalLoginRegisterDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Auth"
        ]
      }
    },
    "/auth/sso/start/{providerId}": {
      "get": {
        "operationId": "AuthController_startSsoFromExternalGet",
        "parameters": [
          {
            "name": "providerId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "Auth"
        ]
      },
      "post": {
        "operationId": "AuthController_startSsoFromExternalPost",
        "parameters": [
          {
            "name": "providerId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "Auth"
        ]
      }
    },
    "/auth/sso-providers": {
      "get": {
        "operationId": "AuthController_retrieveSsoProviders",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SsoAuthProviderListResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Auth"
        ]
      }
    },
    "/auth/change-user-role": {
      "post": {
        "operationId": "AuthController_changeUserRole",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/ChangeUserRoleDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "Auth"
        ]
      }
    },
    "/auth/local/password/send-reset-mail": {
      "post": {
        "operationId": "PasswordResetController_sendResetMail",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreatePasswordResetCodeDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "summary": "Sends a \"password forgotten\" link to the given email address.\nWill always return successfully, even if the email address does not exist",
        "tags": [
          "PasswordReset"
        ]
      }
    },
    "/auth/local/password/validate-code": {
      "post": {
        "operationId": "PasswordResetController_checkResetValidity",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CheckPasswordResetCodeDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CheckPasswordValidityResponse"
                }
              }
            }
          }
        },
        "summary": "Check if the email and code provided by {@link sendResetMail} or {@link AuthController#register} is a valid password reset.\nIn case it is not Frontend can redirect to the login page, etc.",
        "tags": [
          "PasswordReset"
        ]
      }
    },
    "/auth/local/password/set-new": {
      "post": {
        "operationId": "PasswordResetController_setNewPassword",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UsePasswordResetCodeDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PasswordResetResponse"
                }
              }
            }
          }
        },
        "summary": "Set the user password to the given password, if the given code is a valid code provided by {@link sendResetMail} or {@link AuthController#register}.\nThe code is invalidated after usage.",
        "tags": [
          "PasswordReset"
        ]
      }
    },
    "/auth/local/password/change-password": {
      "post": {
        "operationId": "PasswordResetController_changePassword",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/ChangePasswordDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "PasswordReset"
        ]
      }
    },
    "/auth/local/email/request-change": {
      "post": {
        "operationId": "EmailChangeController_requestEmailChange",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/RequestEmailChangeDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "EmailChange"
        ]
      }
    },
    "/auth/local/email/confirm-change": {
      "post": {
        "operationId": "EmailChangeController_confirmEmailChange",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/ConfirmEmailChangeDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "EmailChange"
        ]
      }
    },
    "/attribution/sso/{authAttemptId}": {
      "post": {
        "operationId": "AttributionController_savePendingSsoAttribution",
        "parameters": [
          {
            "name": "authAttemptId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/SavePendingSsoAttributionDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Attribution"
        ]
      }
    },
    "/invitations/verify/{code}": {
      "get": {
        "operationId": "InvitationController_verifyInvitationCode",
        "parameters": [
          {
            "name": "code",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "type",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/VerifyInvitationCodeResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Invitation"
        ]
      }
    },
    "/invitations/accept": {
      "post": {
        "operationId": "InvitationController_accept",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/AcceptInvitationDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/AcceptInvitationResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Invitation"
        ]
      }
    },
    "/invitations/active": {
      "get": {
        "operationId": "InvitationController_getActiveInvitationsForCurrentTenant",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TenantUserInvitationsPaginatedDto"
                }
              }
            }
          }
        },
        "summary": "Returns all invitations that are currently active (i.e. not used too often and not expired)",
        "tags": [
          "Invitation"
        ]
      }
    },
    "/invitations/{id}": {
      "delete": {
        "operationId": "InvitationController_delete",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Invitation"
        ]
      },
      "post": {
        "operationId": "InvitationController_renew",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/RenewInvitationDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Invitation"
        ]
      }
    },
    "/invitations/url/{code}": {
      "get": {
        "operationId": "InvitationController_getInvitationUrlByCode",
        "parameters": [
          {
            "name": "code",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          }
        },
        "tags": [
          "Invitation"
        ]
      }
    },
    "/notifications": {
      "get": {
        "operationId": "NotificationController_retrieve",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedNotificationResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Notification"
        ]
      }
    },
    "/notifications/mark-as-read": {
      "put": {
        "operationId": "NotificationController_markAsRead",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/MarkNotificationsAsReadDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Notification"
        ]
      }
    },
    "/template-sets": {
      "get": {
        "operationId": "TemplateSetController_listAllTemplateSets",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedTemplateSetResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TemplateSet"
        ]
      }
    },
    "/template-sets/resolved": {
      "post": {
        "operationId": "TemplateSetController_resolveTemplateSet",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/GlobalTemplateScopeDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ResolvedTemplateSetResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TemplateSet"
        ]
      }
    },
    "/template-sets/validate": {
      "post": {
        "operationId": "TemplateSetProviderController_validate",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "multipart/form-data": {
              "schema": {
                "type": "object",
                "required": [
                  "file"
                ],
                "properties": {
                  "file": {
                    "type": "string",
                    "format": "binary"
                  }
                }
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TemplateSetUploadValidationResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TemplateSetProvider"
        ]
      }
    },
    "/template-sets/upload": {
      "post": {
        "operationId": "TemplateSetProviderController_upload",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "multipart/form-data": {
              "schema": {
                "$ref": "#/components/schemas/IntersectionUploadTemplateSetDtoWithFile"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TemplateSetProvider"
        ]
      }
    },
    "/template-sets/{id}/pdf-data": {
      "get": {
        "operationId": "TemplateSetProviderController_getTemplateSetPdfData",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "schoolLevel",
            "required": true,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "performanceVisualId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "subjectGroupIds",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "type": "number"
              }
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TemplateSetPdfPrintDataResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TemplateSetProvider"
        ]
      }
    },
    "/template-sets/{id}/pdf": {
      "post": {
        "operationId": "TemplateSetProviderController_generateTemplateSetPdf",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/TemplateSetPdfGenerateDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/AsyncOperationCreatedResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TemplateSetProvider"
        ]
      }
    },
    "/template-sets/{id}": {
      "delete": {
        "operationId": "TemplateSetProviderController_delete",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "TemplateSetProvider"
        ]
      }
    },
    "/billing/tenant-checkout": {
      "post": {
        "operationId": "BillingController_checkoutTenant",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/BillingCheckoutDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/BillingLinkResponseDto"
                }
              }
            }
          }
        },
        "summary": "Checkout/buy a new license for the current tenant",
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/tenant-checkout-preview": {
      "post": {
        "operationId": "BillingController_checkoutTenantPreview",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/BillingCheckoutPreviewDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/BillingCheckoutPreviewResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/tenant-checkout-options": {
      "get": {
        "operationId": "BillingController_getTenantCheckoutOptions",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/BillingCheckoutOptionsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/tenant/invoice-address": {
      "get": {
        "operationId": "BillingController_getTenantInvoiceAddress",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/BillingInvoiceAddressResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Billing"
        ]
      },
      "put": {
        "operationId": "BillingController_updateTenantInvoiceAddress",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpsertTenantInvoiceAddressDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/BillingInvoiceAddressResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/tenant/invoices": {
      "get": {
        "operationId": "BillingController_getTenantInvoices",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedBillingInvoiceResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/tenant/offers": {
      "get": {
        "operationId": "BillingController_getTenantOffers",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedBillingOfferResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Billing"
        ]
      },
      "post": {
        "operationId": "BillingController_createTenantOffer",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateBillingOfferDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/BillingOfferResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/tenant-invoice-checkout": {
      "post": {
        "operationId": "BillingController_checkoutTenantViaInvoice",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/BillingCheckoutDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TenantInvoiceCheckoutResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/tenant/offers/{offerId}/address": {
      "put": {
        "operationId": "BillingController_updateTenantOfferAddress",
        "parameters": [
          {
            "name": "offerId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpsertTenantInvoiceAddressDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/BillingOfferResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/tenant/offers/{offerId}/accept-invoice": {
      "post": {
        "operationId": "BillingController_acceptTenantOfferViaInvoice",
        "parameters": [
          {
            "name": "offerId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/BillingOfferResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/tenant/offers/{offerId}/accept-online": {
      "post": {
        "operationId": "BillingController_acceptTenantOfferOnline",
        "parameters": [
          {
            "name": "offerId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/AcceptBillingOfferOnlineDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/BillingLinkResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/tenant/offers/{offerId}/pdf": {
      "get": {
        "operationId": "BillingController_downloadTenantOfferPdf",
        "parameters": [
          {
            "name": "offerId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "content": {
              "application/pdf": {
                "schema": {
                  "type": "string",
                  "format": "binary"
                }
              }
            },
            "description": ""
          }
        },
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/tenant/offers/{offerId}": {
      "delete": {
        "operationId": "BillingController_deleteTenantOffer",
        "parameters": [
          {
            "name": "offerId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/tenant-portal": {
      "post": {
        "operationId": "BillingController_getTenantPortalLink",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/BillingPortalDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/BillingLinkResponseDto"
                }
              }
            }
          }
        },
        "summary": "Manage licenses for the current tenant - returns a link to the stripe portal",
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/status": {
      "get": {
        "operationId": "BillingController_status",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/BillingStatusResponseDto"
                }
              }
            }
          }
        },
        "summary": "The following route returns the tenant-scoped status of the billing.",
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/checkout-summary/{checkoutSessionId}": {
      "get": {
        "operationId": "BillingController_getCheckoutSummary",
        "parameters": [
          {
            "name": "checkoutSessionId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/CheckoutSummaryResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/tenant/switch-preview": {
      "post": {
        "operationId": "BillingController_tenantSwitchPlanPreview",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/BillingPlanSwitchPreviewDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/BillingPlanSwitchPreviewResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/tenant/scheduled-plan-change": {
      "get": {
        "operationId": "BillingController_getTenantScheduledPlanChange",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/BillingScheduledPlanChangeResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/tenant/switch": {
      "post": {
        "operationId": "BillingController_tenantSwitchPlan",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/BillingCheckoutDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/tenant/upcoming-billing-amount": {
      "get": {
        "operationId": "BillingController_getUpcomingBillingAmount",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UpcomingBillingAmountResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/tenant/default-billing-method": {
      "get": {
        "operationId": "BillingController_tenantHasUsablePaymentMethod",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TenantHasUsablePaymentMethodResponseDto"
                }
              }
            }
          }
        },
        "summary": "The following route returns the status of the billing.",
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/tenant/trial-expired/seen": {
      "post": {
        "operationId": "BillingController_markTenantTrialExpiredSeen",
        "parameters": [],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/tenant/extend-trial": {
      "post": {
        "operationId": "BillingController_extendTenantTrial",
        "parameters": [],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/products/pricing": {
      "get": {
        "operationId": "BillingController_getBillingMarketPricing",
        "parameters": [
          {
            "name": "countryId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/BillingMarketPricingResponseDto"
                }
              }
            }
          }
        },
        "summary": "Per-market price catalog for plan cards/calculator: amounts + currency straight from the Stripe\nprices' currency options. Tenant context wins (locked-currency aware); pre-tenant callers pass\nthe future school's countryId. Fail-open: a catalog outage yields an empty product list.",
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/products": {
      "get": {
        "operationId": "BillingController_getBillingProducts",
        "parameters": [
          {
            "name": "filter",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilter"
              }
            }
          },
          {
            "name": "order",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/SingleFilterOrder"
              }
            }
          },
          {
            "name": "offset",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 0,
              "default": 0,
              "type": "number"
            }
          },
          {
            "name": "limit",
            "required": false,
            "in": "query",
            "schema": {
              "minimum": 1,
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedBillingProductResponse"
                }
              }
            }
          }
        },
        "tags": [
          "Billing"
        ]
      }
    },
    "/billing/sync-tenant/{tenantId}": {
      "post": {
        "operationId": "BillingProviderController_syncTenant",
        "parameters": [
          {
            "name": "tenantId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/BillingSyncCustomerSuccessResponse"
                }
              }
            }
          }
        },
        "tags": [
          "BillingProvider"
        ]
      }
    },
    "/billing/tenant/{tenantId}/end-trial": {
      "post": {
        "operationId": "BillingProviderController_endTenantTrialNow",
        "parameters": [
          {
            "name": "tenantId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "BillingProvider"
        ]
      }
    },
    "/stripe/webhook": {
      "post": {
        "operationId": "StripeWebhookController_receiveStripeWebhook",
        "parameters": [],
        "responses": {
          "201": {
            "description": ""
          }
        },
        "summary": "This webhook is called by stripe and authenticated by the `stripe-signature` header",
        "tags": [
          "StripeWebhook"
        ]
      }
    },
    "/referrals/tenant/link": {
      "get": {
        "operationId": "ReferralController_getTenantReferralLink",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ReferralLinkResponseDto"
                }
              }
            }
          }
        },
        "summary": "Get or create the referral link for the current tenant.\nAll tenant users share the same link!",
        "tags": [
          "Referral"
        ]
      }
    },
    "/referrals/tenant/status": {
      "get": {
        "operationId": "ReferralController_getTenantReferralStatus",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ReferralStatusResponseDto"
                }
              }
            }
          }
        },
        "summary": "Returns current referral discount status for the referral tenant",
        "tags": [
          "Referral"
        ]
      }
    },
    "/referrals/attribute": {
      "post": {
        "operationId": "ReferralController_attributeReferral",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/AttributeReferralDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "summary": "Attributes the current tenant as referee using a tenants referral code!",
        "tags": [
          "Referral"
        ]
      }
    },
    "/classes/{schoolClassId}/grading/recommendations": {
      "get": {
        "operationId": "GradeRecommendationController_getClassSubjectRecommendationSummaries",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "subjectIds",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "type": "number"
              }
            }
          },
          {
            "name": "from",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "to",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/GradeCalculationClassRecommendationListResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "GradeRecommendation"
        ]
      }
    },
    "/classes/{schoolClassId}/students/{studentId}/grading/recommendations": {
      "get": {
        "operationId": "GradeRecommendationController_getStudentSubjectRecommendationSummaries",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "studentId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "from",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "to",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/GradeCalculationSubjectRecommendationListResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "GradeRecommendation"
        ]
      }
    },
    "/classes/{schoolClassId}/students/{studentId}/subjects/{subjectId}/grading/recommendation": {
      "get": {
        "operationId": "GradeRecommendationController_getStudentSubjectRecommendation",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "studentId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "subjectId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "from",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "to",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/GradeCalculationSubjectRecommendationResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "GradeRecommendation"
        ]
      }
    },
    "/tenants/current/grading/weightings": {
      "put": {
        "operationId": "GradeWeightingController_updateTenantWeightings",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateGradeCalculationWeightingsDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "GradeWeighting"
        ]
      }
    },
    "/classes/{schoolClassId}/grading/weightings": {
      "put": {
        "operationId": "GradeWeightingController_updateClassWeightings",
        "parameters": [
          {
            "name": "schoolClassId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateGradeCalculationWeightingsDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "GradeWeighting"
        ]
      }
    },
    "/tenants/current/grading/settings": {
      "get": {
        "operationId": "GradeCalculationSettingsController_getSettings",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/GradeCalculationSettingsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "GradeCalculationSettings"
        ]
      },
      "patch": {
        "operationId": "GradeCalculationSettingsController_updateSettings",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateGradeCalculationSettingsDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/GradeCalculationSettingsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "GradeCalculationSettings"
        ]
      }
    },
    "/tenants/current/grading/scale/usage": {
      "get": {
        "operationId": "GradeScaleController_getGradeScaleUsage",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/GradeScaleUsageResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "GradeScale"
        ]
      }
    },
    "/tenants/current/grading/scale": {
      "patch": {
        "operationId": "GradeScaleController_updateScale",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateSchoolGradeScaleDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/GradeCalculationSettingsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "GradeScale"
        ]
      }
    },
    "/provider/grade-scales": {
      "post": {
        "operationId": "GradeScaleProviderController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateGradeScaleDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/GradeScaleResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "GradeScaleProvider"
        ]
      }
    },
    "/provider/grade-scales/{id}": {
      "put": {
        "operationId": "GradeScaleProviderController_update",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateGradeScaleDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/GradeScaleResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "GradeScaleProvider"
        ]
      },
      "get": {
        "operationId": "GradeScaleProviderController_get",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/GradeScaleResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "GradeScaleProvider"
        ]
      }
    },
    "/provider/grade-scales/resolved": {
      "post": {
        "operationId": "GradeScaleProviderController_resolveForScope",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/GlobalTemplateScopeDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedGradeScaleResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "GradeScaleProvider"
        ]
      }
    },
    "/provider/grade-scales/{id}/grade-levels": {
      "post": {
        "operationId": "GradeScaleProviderController_addGradeLevel",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateGradeLevelDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/GradeLevelResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "GradeScaleProvider"
        ]
      }
    },
    "/provider/grade-scales/{id}/grade-levels/{levelId}": {
      "patch": {
        "operationId": "GradeScaleProviderController_updateGradeLevel",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "levelId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateGradeLevelDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/GradeLevelResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "GradeScaleProvider"
        ]
      },
      "delete": {
        "operationId": "GradeScaleProviderController_deleteGradeLevel",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "levelId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "GradeScaleProvider"
        ]
      }
    },
    "/growth/cta": {
      "get": {
        "operationId": "GrowthController_getCta",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/GrowthCtaResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Growth"
        ]
      }
    },
    "/growth/state": {
      "get": {
        "operationId": "GrowthController_getState",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/GrowthStateResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Growth"
        ]
      }
    },
    "/growth/popup-dismissed": {
      "post": {
        "operationId": "GrowthController_dismissPopup",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/GrowthPopupDismissDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Growth"
        ]
      }
    },
    "/setup-checklist/state": {
      "get": {
        "operationId": "SetupChecklistController_getState",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SetupChecklistStateResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SetupChecklist"
        ]
      }
    },
    "/setup-checklist/dismiss": {
      "post": {
        "operationId": "SetupChecklistController_dismiss",
        "parameters": [],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SetupChecklist"
        ]
      }
    },
    "/provider/school-type-configurations": {
      "post": {
        "operationId": "SchoolTypeConfigurationProviderController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateSchoolTypeConfigurationDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolTypeConfigurationResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolTypeConfigurationProvider"
        ]
      }
    },
    "/provider/school-type-configurations/{id}": {
      "put": {
        "operationId": "SchoolTypeConfigurationProviderController_update",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateSchoolTypeConfigurationDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SchoolTypeConfigurationResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolTypeConfigurationProvider"
        ]
      },
      "delete": {
        "operationId": "SchoolTypeConfigurationProviderController_delete",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ApiSuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolTypeConfigurationProvider"
        ]
      }
    },
    "/provider/school-type-configurations/resolved": {
      "post": {
        "operationId": "SchoolTypeConfigurationProviderController_resolveForScope",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/GlobalTemplateScopeDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PaginatedSchoolTypeConfigurationResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "SchoolTypeConfigurationProvider"
        ]
      }
    },
    "/provider/auth-providers": {
      "get": {
        "operationId": "AuthProviderProviderController_retrieve",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/AuthProviderListResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "AuthProviderProvider"
        ]
      },
      "post": {
        "operationId": "AuthProviderProviderController_create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateAuthProviderDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/AuthProviderResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "AuthProviderProvider"
        ]
      }
    },
    "/provider/auth-providers/{authProviderId}": {
      "put": {
        "operationId": "AuthProviderProviderController_update",
        "parameters": [
          {
            "name": "authProviderId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateAuthProviderDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/AuthProviderResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "AuthProviderProvider"
        ]
      }
    },
    "/analytics/registration/consume": {
      "post": {
        "operationId": "AnalyticsController_consumeRegistration",
        "parameters": [],
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ConsumeRegistrationAnalyticsResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Analytics"
        ]
      }
    }
  },
  "info": {
    "title": "Digidoo API",
    "description": "API for Digidoo",
    "version": "0.1",
    "contact": {}
  },
  "tags": [],
  "servers": [],
  "components": {
    "schemas": {
      "EntryAttachmentType": {
        "type": "string",
        "enum": [
          "performanceAssessmentEntry",
          "performanceAssessmentStudentEntry",
          "note",
          "supportMeasureEntry",
          "supportMeasureProtocolEntry"
        ]
      },
      "AttachmentContentType": {
        "type": "string",
        "enum": [
          "image",
          "file",
          "app"
        ]
      },
      "EntryAttachmentItemDto": {
        "type": "object",
        "properties": {
          "type": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/AttachmentContentType"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "fileId": {
            "type": "number"
          },
          "thumbnailFileId": {
            "type": "number",
            "nullable": true
          },
          "byteSize": {
            "type": "number"
          },
          "contentType": {
            "type": "string",
            "nullable": true
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          }
        },
        "required": [
          "type",
          "id",
          "name",
          "fileId",
          "thumbnailFileId",
          "byteSize",
          "contentType",
          "createdAt"
        ]
      },
      "EntryAttachmentResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "items": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/EntryAttachmentItemDto"
            }
          },
          "totalCount": {
            "type": "number"
          },
          "nextCursor": {
            "type": "number",
            "nullable": true
          },
          "canEdit": {
            "type": "boolean"
          },
          "schoolClassId": {
            "type": "number"
          },
          "schoolSubjectId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "success",
          "items",
          "totalCount",
          "nextCursor",
          "canEdit",
          "schoolClassId",
          "schoolSubjectId"
        ]
      },
      "FileReferenceDto": {
        "type": "object",
        "properties": {
          "fileId": {
            "type": "number",
            "minimum": 1
          }
        },
        "required": [
          "fileId"
        ]
      },
      "ApiSuccessResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          }
        },
        "required": [
          "success"
        ]
      },
      "SelectableLanguageDto": {
        "type": "object",
        "properties": {
          "code": {
            "type": "string"
          },
          "name": {
            "type": "string"
          }
        },
        "required": [
          "code",
          "name"
        ]
      },
      "AppConfigDataDto": {
        "type": "object",
        "properties": {
          "environment": {
            "type": "string",
            "description": "Deployment environment this backend runs in (e.g. local, development, staging, production)."
          },
          "languageSwitchEnabled": {
            "type": "boolean",
            "description": "When true, the frontend exposes the language switcher; otherwise the UI is pinned to the default language."
          },
          "languages": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SelectableLanguageDto"
            }
          },
          "studentImportEnabled": {
            "type": "boolean",
            "description": "When true, teachers can add students from an uploaded class list."
          },
          "trackingEnabled": {
            "type": "boolean",
            "description": "When true, the frontend loads its analytics and ad trackers (still subject to the visitor's consent)."
          }
        },
        "required": [
          "environment",
          "languageSwitchEnabled",
          "languages",
          "studentImportEnabled",
          "trackingEnabled"
        ]
      },
      "AppConfigResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/AppConfigDataDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "TemplateSetSource": {
        "type": "string",
        "enum": [
          "digidoo",
          "bmukk",
          "custom",
          "official"
        ]
      },
      "BillingMode": {
        "type": "string",
        "enum": [
          "perTenant",
          "billedExternally"
        ]
      },
      "ProviderCreateTenantDto": {
        "type": "object",
        "properties": {
          "templateSetSource": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/TemplateSetSource"
              }
            ]
          },
          "billingMode": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingMode"
              }
            ]
          },
          "isDisabled": {
            "type": "boolean"
          },
          "name": {
            "type": "string",
            "maxLength": 256
          },
          "slogan": {
            "type": "string"
          },
          "countryId": {
            "type": "number"
          },
          "stateId": {
            "type": "number"
          },
          "schoolTypeId": {
            "type": "number"
          },
          "customSchoolTypeName": {
            "type": "string"
          },
          "contentLanguageId": {
            "type": "number",
            "description": "Content language for provisioned curricula/configs. Defaults to the country's primary content language."
          },
          "zipCode": {
            "type": "string",
            "maxLength": 5000
          },
          "city": {
            "type": "string",
            "maxLength": 5000
          },
          "street": {
            "type": "string",
            "maxLength": 5000
          },
          "email": {
            "type": "string",
            "nullable": true,
            "maxLength": 512
          },
          "telephone": {
            "type": "string",
            "nullable": true
          },
          "website": {
            "type": "string",
            "nullable": true
          },
          "nameOfSchoolAdministration": {
            "type": "string",
            "nullable": true,
            "maxLength": 250
          },
          "schoolId": {
            "type": "number"
          },
          "schoolLevels": {
            "type": "array",
            "items": {
              "type": "number",
              "maximum": 13,
              "minimum": 0
            }
          }
        },
        "required": [
          "name",
          "countryId",
          "stateId",
          "zipCode",
          "city",
          "street"
        ]
      },
      "SchoolLevelLabelMode": {
        "type": "string",
        "enum": [
          "adjusted",
          "raw"
        ]
      },
      "SchoolPublicOrPrivate": {
        "type": "string",
        "enum": [
          "private",
          "public",
          "unknown"
        ]
      },
      "SchoolDto": {
        "type": "object",
        "properties": {
          "isPublicOrPrivate": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SchoolPublicOrPrivate"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "skz": {
            "type": "string"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "title": {
            "type": "string"
          },
          "address": {
            "type": "string"
          },
          "zipCode": {
            "type": "string"
          },
          "city": {
            "type": "string"
          },
          "maintainer": {
            "type": "string",
            "nullable": true
          },
          "supervisoryAuthority": {
            "type": "string",
            "nullable": true
          },
          "hasChildCare": {
            "type": "boolean",
            "nullable": true
          },
          "telephone": {
            "type": "string",
            "nullable": true
          },
          "fax": {
            "type": "string",
            "nullable": true
          },
          "email": {
            "type": "string",
            "nullable": true
          },
          "website": {
            "type": "string",
            "nullable": true
          },
          "countryId": {
            "type": "number"
          },
          "stateId": {
            "type": "number"
          },
          "schoolTypeId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "isPublicOrPrivate",
          "id",
          "skz",
          "createdAt",
          "updatedAt",
          "title",
          "address",
          "zipCode",
          "city",
          "countryId",
          "stateId"
        ]
      },
      "GradeVisualizationType": {
        "type": "string",
        "enum": [
          "NUMERIC"
        ]
      },
      "GradeLevelDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "level": {
            "type": "number"
          },
          "key": {
            "type": "string",
            "nullable": true
          },
          "isNameCustomized": {
            "type": "boolean"
          },
          "name": {
            "type": "string"
          },
          "description": {
            "type": "string"
          }
        },
        "required": [
          "id",
          "level",
          "key",
          "isNameCustomized",
          "name",
          "description"
        ]
      },
      "GradeCalculationSettingsDto": {
        "type": "object",
        "properties": {
          "visualizationType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/GradeVisualizationType"
              }
            ]
          },
          "decimalGradesEnabled": {
            "type": "boolean"
          },
          "gradeModifiersEnabled": {
            "type": "boolean"
          },
          "enabled": {
            "type": "boolean"
          },
          "gradeScaleId": {
            "type": "number",
            "nullable": true
          },
          "gradeLevels": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/GradeLevelDto"
            }
          },
          "useAllSchoolLevels": {
            "type": "boolean"
          },
          "schoolLevels": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "lowerGradeValueIsBetter": {
            "type": "boolean"
          }
        },
        "required": [
          "visualizationType",
          "decimalGradesEnabled",
          "gradeModifiersEnabled",
          "enabled",
          "gradeScaleId",
          "gradeLevels",
          "useAllSchoolLevels",
          "schoolLevels",
          "lowerGradeValueIsBetter"
        ]
      },
      "GradeCalculationTagDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "key": {
            "type": "string"
          },
          "weightMultiplier": {
            "type": "number"
          },
          "sortOrder": {
            "type": "number"
          },
          "isDefault": {
            "type": "boolean"
          }
        },
        "required": [
          "id",
          "createdAt",
          "updatedAt",
          "key",
          "weightMultiplier",
          "sortOrder",
          "isDefault"
        ]
      },
      "TenantDto": {
        "type": "object",
        "properties": {
          "templateSetSource": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/TemplateSetSource"
              }
            ]
          },
          "billingMode": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingMode"
              }
            ]
          },
          "schoolLevelLabelMode": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SchoolLevelLabelMode"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "slogan": {
            "type": "string",
            "nullable": true
          },
          "isDisabled": {
            "type": "boolean"
          },
          "deactivatedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "isProvider": {
            "type": "boolean"
          },
          "isWizardFinalized": {
            "type": "boolean"
          },
          "isAdministrationSetupCompleted": {
            "type": "boolean"
          },
          "hasSeenCompetenceSetupChoiceDialog": {
            "type": "boolean"
          },
          "requiresTwoFactorAuth": {
            "type": "boolean"
          },
          "countryId": {
            "type": "number",
            "nullable": true
          },
          "countryIsoCode": {
            "type": "string",
            "nullable": true,
            "description": "ISO alpha-2 of the tenant country; populated only on whoami"
          },
          "stateId": {
            "type": "number",
            "nullable": true
          },
          "schoolTypeId": {
            "type": "number",
            "nullable": true
          },
          "contentLanguageId": {
            "type": "number",
            "nullable": true
          },
          "schoolTypeAbbr": {
            "type": "string",
            "nullable": true
          },
          "schoolTypeName": {
            "type": "string",
            "nullable": true
          },
          "zipCode": {
            "type": "string"
          },
          "city": {
            "type": "string"
          },
          "street": {
            "type": "string"
          },
          "email": {
            "type": "string",
            "nullable": true
          },
          "telephone": {
            "type": "string",
            "nullable": true
          },
          "website": {
            "type": "string",
            "nullable": true
          },
          "nameOfSchoolAdministration": {
            "type": "string",
            "nullable": true
          },
          "schoolId": {
            "type": "number",
            "nullable": true
          },
          "schoolLevels": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "logoId": {
            "type": "number",
            "nullable": true
          },
          "school": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SchoolDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "gradeCalculation": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/GradeCalculationSettingsDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "gradeCalculationTags": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/GradeCalculationTagDto"
            }
          }
        },
        "required": [
          "templateSetSource",
          "billingMode",
          "schoolLevelLabelMode",
          "id",
          "createdAt",
          "updatedAt",
          "name",
          "isDisabled",
          "deactivatedAt",
          "isProvider",
          "isWizardFinalized",
          "isAdministrationSetupCompleted",
          "hasSeenCompetenceSetupChoiceDialog",
          "requiresTwoFactorAuth",
          "zipCode",
          "city",
          "street",
          "email",
          "telephone",
          "website",
          "nameOfSchoolAdministration",
          "schoolLevels",
          "logoId",
          "gradeCalculation",
          "gradeCalculationTags"
        ]
      },
      "TenantResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/TenantDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "FilterOperationType": {
        "type": "string",
        "enum": [
          "=",
          "<",
          "<=",
          ">",
          ">=",
          "!=",
          "like",
          "ilike",
          "contains",
          "icontains",
          "search",
          "isearch",
          "startswith",
          "istartswith",
          "endswith",
          "iendswith",
          "eqstring",
          "nestring",
          "in",
          "notin",
          "instrings",
          "notinstrings",
          "eqnull",
          "nenull",
          "array_contains",
          "array_starts_with",
          "array_ends_with"
        ]
      },
      "SingleFilter": {
        "type": "object",
        "properties": {
          "field": {
            "type": "string"
          },
          "type": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/FilterOperationType"
              }
            ]
          },
          "value": {
            "oneOf": [
              {
                "type": "string"
              },
              {
                "type": "array",
                "items": {
                  "type": "string"
                }
              }
            ]
          }
        },
        "required": [
          "field",
          "type",
          "value"
        ]
      },
      "SingleFilterOrder": {
        "type": "object",
        "properties": {
          "field": {
            "type": "string"
          },
          "dir": {
            "type": "string",
            "enum": [
              "asc",
              "desc"
            ]
          }
        },
        "required": [
          "field",
          "dir"
        ]
      },
      "ProviderTenantSortField": {
        "type": "string",
        "enum": [
          "name",
          "country",
          "userCount",
          "schoolClassCount",
          "studentCount",
          "billingMode",
          "createdAt",
          "isDisabled",
          "deactivatedAt"
        ]
      },
      "SortOrder": {
        "type": "string",
        "enum": [
          "asc",
          "desc"
        ]
      },
      "Product": {
        "type": "string",
        "enum": [
          "school",
          "team",
          "proUser"
        ]
      },
      "SubscriptionState": {
        "type": "string",
        "enum": [
          "active",
          "trialing",
          "trialEnded",
          "cancelScheduled",
          "subscriptionOver"
        ]
      },
      "CountryLanguageDto": {
        "type": "object",
        "properties": {
          "languageId": {
            "type": "number"
          },
          "code": {
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "isPrimary": {
            "type": "boolean"
          }
        },
        "required": [
          "languageId",
          "code",
          "name",
          "isPrimary"
        ]
      },
      "CountryDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "isoCode": {
            "type": "string"
          },
          "isSupported": {
            "type": "boolean"
          },
          "currencyCode": {
            "type": "string"
          },
          "languages": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CountryLanguageDto"
            }
          }
        },
        "required": [
          "id",
          "createdAt",
          "updatedAt",
          "name",
          "isoCode",
          "isSupported",
          "currencyCode",
          "languages"
        ]
      },
      "FileStorageUsageDto": {
        "type": "object",
        "properties": {
          "totalBytes": {
            "type": "number",
            "default": 0
          },
          "reportsBytes": {
            "type": "number",
            "default": 0
          },
          "attachmentsBytes": {
            "type": "number",
            "default": 0
          },
          "otherBytes": {
            "type": "number",
            "default": 0
          }
        },
        "required": [
          "totalBytes",
          "reportsBytes",
          "attachmentsBytes",
          "otherBytes"
        ]
      },
      "TenantDtoWithEntityCountAndBillingAndCountry": {
        "type": "object",
        "properties": {
          "templateSetSource": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/TemplateSetSource"
              }
            ]
          },
          "billingMode": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingMode"
              }
            ]
          },
          "schoolLevelLabelMode": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SchoolLevelLabelMode"
              }
            ]
          },
          "currentProduct": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/Product"
              },
              {
                "nullable": true
              }
            ]
          },
          "subscriptionState": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SubscriptionState"
              },
              {
                "nullable": true
              }
            ]
          },
          "country": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/CountryDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "storageUsage": {
            "$ref": "#/components/schemas/FileStorageUsageDto"
          },
          "userCount": {
            "type": "number"
          },
          "studentCount": {
            "type": "number"
          },
          "schoolClassCount": {
            "type": "number"
          },
          "billingCustomerId": {
            "type": "string",
            "nullable": true
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "slogan": {
            "type": "string",
            "nullable": true
          },
          "isDisabled": {
            "type": "boolean"
          },
          "deactivatedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "isProvider": {
            "type": "boolean"
          },
          "isWizardFinalized": {
            "type": "boolean"
          },
          "isAdministrationSetupCompleted": {
            "type": "boolean"
          },
          "hasSeenCompetenceSetupChoiceDialog": {
            "type": "boolean"
          },
          "requiresTwoFactorAuth": {
            "type": "boolean"
          },
          "countryId": {
            "type": "number",
            "nullable": true
          },
          "countryIsoCode": {
            "type": "string",
            "nullable": true,
            "description": "ISO alpha-2 of the tenant country; populated only on whoami"
          },
          "stateId": {
            "type": "number",
            "nullable": true
          },
          "schoolTypeId": {
            "type": "number",
            "nullable": true
          },
          "contentLanguageId": {
            "type": "number",
            "nullable": true
          },
          "schoolTypeAbbr": {
            "type": "string",
            "nullable": true
          },
          "schoolTypeName": {
            "type": "string",
            "nullable": true
          },
          "zipCode": {
            "type": "string"
          },
          "city": {
            "type": "string"
          },
          "street": {
            "type": "string"
          },
          "email": {
            "type": "string",
            "nullable": true
          },
          "telephone": {
            "type": "string",
            "nullable": true
          },
          "website": {
            "type": "string",
            "nullable": true
          },
          "nameOfSchoolAdministration": {
            "type": "string",
            "nullable": true
          },
          "schoolId": {
            "type": "number",
            "nullable": true
          },
          "schoolLevels": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "logoId": {
            "type": "number",
            "nullable": true
          },
          "school": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SchoolDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "gradeCalculation": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/GradeCalculationSettingsDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "gradeCalculationTags": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/GradeCalculationTagDto"
            }
          }
        },
        "required": [
          "templateSetSource",
          "billingMode",
          "schoolLevelLabelMode",
          "currentProduct",
          "subscriptionState",
          "country",
          "storageUsage",
          "userCount",
          "studentCount",
          "schoolClassCount",
          "billingCustomerId",
          "id",
          "createdAt",
          "updatedAt",
          "name",
          "isDisabled",
          "deactivatedAt",
          "isProvider",
          "isWizardFinalized",
          "isAdministrationSetupCompleted",
          "hasSeenCompetenceSetupChoiceDialog",
          "requiresTwoFactorAuth",
          "zipCode",
          "city",
          "street",
          "email",
          "telephone",
          "website",
          "nameOfSchoolAdministration",
          "schoolLevels",
          "logoId",
          "gradeCalculation",
          "gradeCalculationTags"
        ]
      },
      "TenantPaginatedResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/TenantDtoWithEntityCountAndBillingAndCountry"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "UserRoleType": {
        "type": "string",
        "enum": [
          "owner",
          "admin",
          "user",
          "external"
        ]
      },
      "UserRoleStatus": {
        "type": "string",
        "enum": [
          "active",
          "disabled",
          "invitationDeclined",
          "invitationPending"
        ]
      },
      "UserSource": {
        "type": "string",
        "enum": [
          "GOOGLE_SEARCH",
          "COLLEAGUE_REFERRAL",
          "SCHOOL_ADMIN",
          "SOCIAL_MEDIA",
          "EVENT_TRAINING",
          "OTHER"
        ]
      },
      "UserDataDto": {
        "type": "object",
        "properties": {
          "source": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserSource"
              },
              {
                "nullable": true
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "email": {
            "type": "string"
          },
          "firstName": {
            "type": "string",
            "nullable": true
          },
          "lastName": {
            "type": "string",
            "nullable": true
          },
          "avatar": {
            "type": "string",
            "nullable": true
          },
          "avatarPictureId": {
            "type": "number",
            "nullable": true,
            "description": "File id of the uploaded avatar picture; resolve the signed url via GET /files/:id/url"
          },
          "sourceOther": {
            "type": "string",
            "nullable": true
          },
          "isSetupCompleted": {
            "type": "boolean"
          },
          "isApproved": {
            "type": "boolean"
          },
          "countryId": {
            "type": "number",
            "nullable": true
          },
          "stateId": {
            "type": "number",
            "nullable": true
          },
          "demoClassWizardSeen": {
            "type": "boolean"
          },
          "ratingDialogSeenAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "weeklyReportActive": {
            "type": "boolean"
          },
          "deactivatedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "language": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "source",
          "id",
          "createdAt",
          "updatedAt",
          "email",
          "firstName",
          "lastName",
          "avatar",
          "avatarPictureId",
          "sourceOther",
          "isSetupCompleted",
          "isApproved",
          "countryId",
          "stateId",
          "demoClassWizardSeen",
          "ratingDialogSeenAt",
          "weeklyReportActive",
          "deactivatedAt",
          "language"
        ]
      },
      "UserRoleWithUserDto": {
        "type": "object",
        "properties": {
          "roleType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserRoleType"
              }
            ]
          },
          "status": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserRoleStatus"
              }
            ]
          },
          "user": {
            "$ref": "#/components/schemas/UserDataDto"
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "tenantId": {
            "type": "number"
          },
          "isMaintenanceRole": {
            "type": "boolean"
          }
        },
        "required": [
          "roleType",
          "status",
          "user",
          "id",
          "createdAt",
          "updatedAt",
          "tenantId",
          "isMaintenanceRole"
        ]
      },
      "UserRolePaginatedResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/UserRoleWithUserDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "SubscriptionStatus": {
        "type": "string",
        "enum": [
          "active",
          "canceled",
          "incomplete",
          "incomplete_expired",
          "past_due",
          "paused",
          "trialing",
          "unpaid"
        ]
      },
      "BillingInterval": {
        "type": "string",
        "enum": [
          "year",
          "month"
        ]
      },
      "ProviderTenantSubscriptionDto": {
        "type": "object",
        "properties": {
          "status": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SubscriptionStatus"
              }
            ]
          },
          "product": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/Product"
              },
              {
                "nullable": true
              }
            ]
          },
          "billingInterval": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingInterval"
              },
              {
                "nullable": true
              }
            ]
          },
          "cancelAtPeriodEnd": {
            "type": "boolean"
          },
          "startedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "endedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "currentPeriodEnd": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "seats": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "status",
          "product",
          "billingInterval",
          "cancelAtPeriodEnd",
          "startedAt",
          "endedAt",
          "currentPeriodEnd",
          "seats"
        ]
      },
      "ProviderTenantSubscriptionResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ProviderTenantSubscriptionDto"
              },
              {
                "nullable": true
              }
            ]
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "ProviderUpdateTenantDto": {
        "type": "object",
        "properties": {
          "templateSetSource": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/TemplateSetSource"
              }
            ]
          },
          "billingMode": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingMode"
              }
            ]
          },
          "name": {
            "type": "string",
            "maxLength": 256
          },
          "slogan": {
            "type": "string"
          },
          "countryId": {
            "type": "number"
          },
          "stateId": {
            "type": "number"
          },
          "schoolTypeId": {
            "type": "number"
          },
          "customSchoolTypeName": {
            "type": "string"
          },
          "contentLanguageId": {
            "type": "number",
            "description": "Content language for provisioned curricula/configs. Defaults to the country's primary content language."
          },
          "zipCode": {
            "type": "string",
            "maxLength": 5000
          },
          "city": {
            "type": "string",
            "maxLength": 5000
          },
          "street": {
            "type": "string",
            "maxLength": 5000
          },
          "email": {
            "type": "string",
            "nullable": true,
            "maxLength": 512
          },
          "telephone": {
            "type": "string",
            "nullable": true
          },
          "website": {
            "type": "string",
            "nullable": true
          },
          "nameOfSchoolAdministration": {
            "type": "string",
            "nullable": true,
            "maxLength": 250
          },
          "schoolId": {
            "type": "number"
          },
          "schoolLevels": {
            "type": "array",
            "items": {
              "type": "number",
              "maximum": 13,
              "minimum": 0
            }
          },
          "isDisabled": {
            "type": "boolean"
          }
        }
      },
      "CreateTenantUserRoleDto": {
        "type": "object",
        "properties": {
          "userRoleType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserRoleType"
              }
            ]
          },
          "userId": {
            "type": "number"
          }
        },
        "required": [
          "userRoleType",
          "userId"
        ]
      },
      "UserRoleDto": {
        "type": "object",
        "properties": {
          "roleType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserRoleType"
              }
            ]
          },
          "status": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserRoleStatus"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "tenantId": {
            "type": "number"
          },
          "isMaintenanceRole": {
            "type": "boolean"
          }
        },
        "required": [
          "roleType",
          "status",
          "id",
          "createdAt",
          "updatedAt",
          "tenantId",
          "isMaintenanceRole"
        ]
      },
      "UserRoleResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/UserRoleDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateUserRoleDto": {
        "type": "object",
        "properties": {
          "userRoleType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserRoleType"
              }
            ]
          },
          "active": {
            "type": "boolean"
          }
        }
      },
      "SchoolClassType": {
        "type": "string",
        "enum": [
          "class",
          "group"
        ]
      },
      "SchoolTermSemester": {
        "type": "string",
        "enum": [
          "first",
          "second"
        ]
      },
      "SchoolTermDto": {
        "type": "object",
        "properties": {
          "schoolTermSemester": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SchoolTermSemester"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "startDate": {
            "format": "date-time",
            "type": "string"
          },
          "endDate": {
            "format": "date-time",
            "type": "string"
          },
          "schoolYearId": {
            "type": "number"
          }
        },
        "required": [
          "schoolTermSemester",
          "id",
          "createdAt",
          "updatedAt",
          "name",
          "startDate",
          "endDate",
          "schoolYearId"
        ]
      },
      "BaseSchoolYearDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "year": {
            "type": "number"
          },
          "schoolYearStart": {
            "format": "date-time",
            "type": "string"
          },
          "schoolYearEnd": {
            "format": "date-time",
            "type": "string"
          },
          "terms": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolTermDto"
            }
          }
        },
        "required": [
          "id",
          "createdAt",
          "updatedAt",
          "year",
          "schoolYearStart",
          "schoolYearEnd",
          "terms"
        ]
      },
      "EntityAppearanceType": {
        "type": "string",
        "enum": [
          "text",
          "emoji",
          "icon",
          "image"
        ]
      },
      "EntityAppearanceDto": {
        "type": "object",
        "properties": {
          "type": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/EntityAppearanceType"
              }
            ]
          },
          "backgroundColor": {
            "type": "string",
            "nullable": true
          },
          "key": {
            "type": "string",
            "nullable": true
          },
          "emojiUnicode": {
            "type": "string",
            "nullable": true
          },
          "imageFileId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "type",
          "backgroundColor",
          "key",
          "emojiUnicode",
          "imageFileId"
        ]
      },
      "SchoolClassDto": {
        "type": "object",
        "properties": {
          "type": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SchoolClassType"
              }
            ]
          },
          "studentCount": {
            "type": "number"
          },
          "schoolSubjectCount": {
            "type": "number",
            "description": "all subjects of the container — the subject list a caller can fetch is filtered by access"
          },
          "nextClassId": {
            "type": "number",
            "nullable": true
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "creatorId": {
            "type": "number",
            "nullable": true
          },
          "isActive": {
            "type": "boolean"
          },
          "isOnboardingFinalized": {
            "type": "boolean"
          },
          "isAssessmentTypeOnboardingFinalized": {
            "type": "boolean"
          },
          "isStudentOnboardingFinalized": {
            "type": "boolean"
          },
          "isTemplate": {
            "type": "boolean"
          },
          "name": {
            "type": "string"
          },
          "nickname": {
            "type": "string",
            "nullable": true
          },
          "originId": {
            "type": "number"
          },
          "schoolLevel": {
            "type": "number"
          },
          "schoolYearId": {
            "type": "number",
            "nullable": true
          },
          "tenantId": {
            "type": "number",
            "nullable": true
          },
          "year": {
            "type": "number"
          },
          "archivedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "finalNote": {
            "type": "string",
            "nullable": true
          },
          "isSchoolYearOverBannerDismissed": {
            "type": "boolean"
          },
          "baseClassId": {
            "type": "number",
            "nullable": true
          },
          "isDemoClass": {
            "type": "boolean"
          },
          "schoolYear": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BaseSchoolYearDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "appearance": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/EntityAppearanceDto"
              },
              {
                "nullable": true
              }
            ]
          }
        },
        "required": [
          "type",
          "studentCount",
          "schoolSubjectCount",
          "nextClassId",
          "id",
          "createdAt",
          "updatedAt",
          "creatorId",
          "isActive",
          "isOnboardingFinalized",
          "isAssessmentTypeOnboardingFinalized",
          "isStudentOnboardingFinalized",
          "isTemplate",
          "name",
          "nickname",
          "originId",
          "schoolLevel",
          "schoolYearId",
          "tenantId",
          "year",
          "archivedAt",
          "finalNote",
          "isSchoolYearOverBannerDismissed",
          "baseClassId",
          "isDemoClass",
          "schoolYear",
          "appearance"
        ]
      },
      "ProviderSchoolClassListResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolClassDto"
            }
          }
        },
        "required": [
          "success",
          "rows"
        ]
      },
      "SchoolSubjectDto": {
        "type": "object",
        "properties": {
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "tenantId": {
            "type": "number",
            "nullable": true
          },
          "schoolClassId": {
            "type": "number",
            "nullable": true
          },
          "isTemplate": {
            "type": "boolean"
          },
          "competenceDomainCount": {
            "type": "number"
          },
          "schoolLevel": {
            "type": "number"
          },
          "isPreselected": {
            "type": "boolean"
          },
          "useSubjectSpecificAssessments": {
            "type": "boolean"
          },
          "order": {
            "type": "number"
          },
          "groupId": {
            "type": "number",
            "nullable": true
          },
          "id": {
            "type": "number"
          },
          "originId": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "abbreviation": {
            "type": "string"
          },
          "color": {
            "type": "string"
          }
        },
        "required": [
          "createdAt",
          "updatedAt",
          "tenantId",
          "schoolClassId",
          "isTemplate",
          "competenceDomainCount",
          "schoolLevel",
          "isPreselected",
          "useSubjectSpecificAssessments",
          "order",
          "groupId",
          "id",
          "originId",
          "name",
          "abbreviation",
          "color"
        ]
      },
      "ProviderSchoolSubjectListResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolSubjectDto"
            }
          }
        },
        "required": [
          "success",
          "rows"
        ]
      },
      "SchoolSubjectGroupDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "originId": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "schoolLevel": {
            "type": "number"
          },
          "tenantId": {
            "type": "number",
            "nullable": true
          },
          "schoolClassId": {
            "type": "number",
            "nullable": true
          },
          "isTemplate": {
            "type": "boolean"
          },
          "order": {
            "type": "number"
          }
        },
        "required": [
          "id",
          "originId",
          "createdAt",
          "updatedAt",
          "name",
          "schoolLevel",
          "tenantId",
          "schoolClassId",
          "isTemplate",
          "order"
        ]
      },
      "ProviderSchoolSubjectGroupListResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolSubjectGroupDto"
            }
          }
        },
        "required": [
          "success",
          "rows"
        ]
      },
      "BaseSchoolSubjectDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "originId": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "abbreviation": {
            "type": "string"
          },
          "color": {
            "type": "string"
          }
        },
        "required": [
          "id",
          "originId",
          "name",
          "abbreviation",
          "color"
        ]
      },
      "AccessRightPermissionsDto": {
        "type": "object",
        "properties": {
          "canManageAccessRights": {
            "type": "boolean"
          },
          "canManageStudents": {
            "type": "boolean"
          },
          "canManagePerformanceAssessments": {
            "type": "boolean"
          },
          "canManageCompetences": {
            "type": "boolean"
          },
          "subjects": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/BaseSchoolSubjectDto"
            }
          }
        },
        "required": [
          "canManageAccessRights",
          "canManageStudents",
          "canManagePerformanceAssessments",
          "canManageCompetences"
        ]
      },
      "SchoolClassAccessRightDto": {
        "type": "object",
        "properties": {
          "userRoleType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserRoleType"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "user": {
            "$ref": "#/components/schemas/UserDataDto"
          },
          "schoolClass": {
            "$ref": "#/components/schemas/SchoolClassDto"
          },
          "permissions": {
            "$ref": "#/components/schemas/AccessRightPermissionsDto"
          }
        },
        "required": [
          "userRoleType",
          "id",
          "createdAt",
          "updatedAt",
          "user",
          "schoolClass",
          "permissions"
        ]
      },
      "ProviderUserRoleAccessRightListResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolClassAccessRightDto"
            }
          }
        },
        "required": [
          "success",
          "rows"
        ]
      },
      "UpsertUserAccessRightDto": {
        "type": "object",
        "properties": {
          "schoolClassId": {
            "type": "number"
          },
          "subjectIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "canManageAccessRights": {
            "type": "boolean"
          },
          "canManageStudents": {
            "type": "boolean"
          },
          "canManagePerformanceAssessments": {
            "type": "boolean"
          },
          "canManageCompetences": {
            "type": "boolean"
          }
        },
        "required": [
          "schoolClassId"
        ]
      },
      "UpsertUserAccessRightsDto": {
        "type": "object",
        "properties": {
          "accessRights": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/UpsertUserAccessRightDto"
            }
          }
        },
        "required": [
          "accessRights"
        ]
      },
      "CurrentTenantResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/TenantDto"
              },
              {
                "nullable": true
              }
            ]
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "CurrentTenantOwnersAndAdminsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/UserDataDto"
            }
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateTenantDto": {
        "type": "object",
        "properties": {
          "templateSetSource": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/TemplateSetSource"
              }
            ]
          },
          "name": {
            "type": "string",
            "maxLength": 256
          },
          "slogan": {
            "type": "string"
          },
          "customSchoolTypeName": {
            "type": "string"
          },
          "contentLanguageId": {
            "type": "number",
            "description": "Content language for provisioned curricula/configs. Defaults to the country's primary content language."
          },
          "zipCode": {
            "type": "string",
            "maxLength": 5000
          },
          "city": {
            "type": "string",
            "maxLength": 5000
          },
          "street": {
            "type": "string",
            "maxLength": 5000
          },
          "email": {
            "type": "string",
            "nullable": true,
            "maxLength": 512
          },
          "telephone": {
            "type": "string",
            "nullable": true
          },
          "website": {
            "type": "string",
            "nullable": true
          },
          "nameOfSchoolAdministration": {
            "type": "string",
            "nullable": true,
            "maxLength": 250
          },
          "schoolId": {
            "type": "number"
          },
          "schoolLevels": {
            "type": "array",
            "items": {
              "type": "number",
              "maximum": 13,
              "minimum": 0
            }
          }
        },
        "required": [
          "name",
          "zipCode",
          "city",
          "street"
        ]
      },
      "UpdateTenantSchoolLevelsDto": {
        "type": "object",
        "properties": {
          "schoolLevels": {
            "minItems": 1,
            "type": "array",
            "items": {
              "type": "number",
              "maximum": 13,
              "minimum": 0
            }
          }
        },
        "required": [
          "schoolLevels"
        ]
      },
      "AddTenantUserClassAccessDto": {
        "type": "object",
        "properties": {
          "schoolClassId": {
            "type": "number"
          },
          "subjectIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "canManageAccessRights": {
            "type": "boolean"
          },
          "canManageStudents": {
            "type": "boolean"
          },
          "canManagePerformanceAssessments": {
            "type": "boolean"
          },
          "canManageCompetences": {
            "type": "boolean"
          }
        },
        "required": [
          "schoolClassId"
        ]
      },
      "AddTenantUserBulkDto": {
        "type": "object",
        "properties": {
          "userRoleType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserRoleType"
              }
            ]
          },
          "emails": {
            "minItems": 1,
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "classAccess": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/AddTenantUserClassAccessDto"
            }
          },
          "message": {
            "type": "string"
          }
        },
        "required": [
          "userRoleType",
          "emails"
        ]
      },
      "AddTenantUserBulkResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "invitedCount": {
            "type": "number"
          },
          "skippedDeactivatedEmails": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": [
          "success",
          "invitedCount",
          "skippedDeactivatedEmails"
        ]
      },
      "PaginatedSchoolSubjectResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolSubjectDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "PerformanceAssessmentDocumentationMode": {
        "type": "string",
        "enum": [
          "COMPETENCE_ONLY",
          "SCHOOL_GRADE",
          "VISUAL"
        ]
      },
      "PerformanceLevelV2Dto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "level": {
            "type": "number"
          },
          "isFrontendPicture": {
            "type": "boolean",
            "nullable": true
          },
          "picturePath": {
            "type": "string",
            "nullable": true
          },
          "pictureId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "id",
          "createdAt",
          "updatedAt",
          "level",
          "isFrontendPicture",
          "picturePath",
          "pictureId"
        ]
      },
      "PerformanceVisualDto": {
        "type": "object",
        "properties": {
          "isLinkedToAssessment": {
            "type": "boolean"
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "tenantId": {
            "type": "number",
            "nullable": true
          },
          "schoolClassId": {
            "type": "number",
            "nullable": true
          },
          "name": {
            "type": "string"
          },
          "key": {
            "type": "string",
            "nullable": true
          },
          "levels": {
            "type": "number"
          },
          "isTemplate": {
            "type": "boolean"
          },
          "performanceLevelsV2": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/PerformanceLevelV2Dto"
            }
          },
          "originId": {
            "type": "number"
          },
          "isOfficial": {
            "type": "boolean"
          },
          "countryId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "isLinkedToAssessment",
          "id",
          "createdAt",
          "updatedAt",
          "tenantId",
          "schoolClassId",
          "name",
          "key",
          "levels",
          "isTemplate",
          "performanceLevelsV2",
          "originId",
          "isOfficial",
          "countryId"
        ]
      },
      "PerformanceAssessmentDto": {
        "type": "object",
        "properties": {
          "documentationMode": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/PerformanceAssessmentDocumentationMode"
              }
            ]
          },
          "hasObservations": {
            "type": "boolean"
          },
          "entryCount": {
            "type": "number"
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "isOfficial": {
            "type": "boolean"
          },
          "isTemplate": {
            "type": "boolean"
          },
          "order": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "key": {
            "type": "string",
            "nullable": true
          },
          "isNameCustomized": {
            "type": "boolean"
          },
          "originId": {
            "type": "number"
          },
          "performanceVisual": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/PerformanceVisualDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "performanceVisualId": {
            "type": "number",
            "nullable": true
          },
          "schoolClassId": {
            "type": "number",
            "nullable": true
          },
          "schoolLevel": {
            "type": "number"
          },
          "schoolSubject": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BaseSchoolSubjectDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "schoolSubjectId": {
            "type": "number",
            "nullable": true
          },
          "symbol": {
            "type": "string"
          },
          "tenantId": {
            "type": "number",
            "nullable": true
          },
          "weighting": {
            "type": "number"
          },
          "countryId": {
            "type": "number",
            "nullable": true
          },
          "stateId": {
            "type": "number",
            "nullable": true
          },
          "schoolTypeId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "documentationMode",
          "hasObservations",
          "entryCount",
          "id",
          "createdAt",
          "updatedAt",
          "isOfficial",
          "isTemplate",
          "order",
          "name",
          "key",
          "isNameCustomized",
          "originId",
          "performanceVisual",
          "performanceVisualId",
          "schoolClassId",
          "schoolLevel",
          "schoolSubject",
          "schoolSubjectId",
          "symbol",
          "tenantId",
          "weighting",
          "countryId",
          "stateId",
          "schoolTypeId"
        ]
      },
      "PaginatedPerformanceAssessmentResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/PerformanceAssessmentDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "CopySchoolSubjectsWithSchoolLevelDto": {
        "type": "object",
        "properties": {
          "schoolSubjectIdsToCopy": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "targetSchoolLevel": {
            "type": "number"
          }
        },
        "required": [
          "schoolSubjectIdsToCopy"
        ]
      },
      "TemplateSetPreviewGroupDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "schoolLevel": {
            "type": "number"
          },
          "order": {
            "type": "number"
          }
        },
        "required": [
          "id",
          "name",
          "schoolLevel",
          "order"
        ]
      },
      "TemplateSetPreviewSubjectDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "abbreviation": {
            "type": "string"
          },
          "color": {
            "type": "string"
          },
          "schoolLevel": {
            "type": "number"
          },
          "groupId": {
            "type": "number",
            "nullable": true
          },
          "order": {
            "type": "number"
          }
        },
        "required": [
          "id",
          "name",
          "abbreviation",
          "color",
          "schoolLevel",
          "groupId",
          "order"
        ]
      },
      "TemplateSetPreviewCompetenceDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "description": {
            "type": "string"
          },
          "order": {
            "type": "number"
          }
        },
        "required": [
          "id",
          "description",
          "order"
        ]
      },
      "TemplateSetPreviewDomainDto": {
        "type": "object",
        "properties": {
          "competences": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/TemplateSetPreviewCompetenceDto"
            }
          },
          "id": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "schoolSubjectId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "competences",
          "id",
          "name",
          "schoolSubjectId"
        ]
      },
      "TemplateSetPreviewDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          },
          "schoolLevels": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "activeSchoolLevels": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "matchingSchoolLevels": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "hasSubjectSpecificAssessments": {
            "type": "boolean"
          },
          "groups": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/TemplateSetPreviewGroupDto"
            }
          },
          "subjects": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/TemplateSetPreviewSubjectDto"
            }
          },
          "domains": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/TemplateSetPreviewDomainDto"
            }
          }
        },
        "required": [
          "name",
          "schoolLevels",
          "activeSchoolLevels",
          "matchingSchoolLevels",
          "hasSubjectSpecificAssessments",
          "groups",
          "subjects",
          "domains"
        ]
      },
      "TemplateSetPreviewResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/TemplateSetPreviewDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "ImportPerformanceAssessmentDto": {
        "type": "object",
        "properties": {
          "schoolSubjectId": {
            "type": "number",
            "nullable": true
          }
        }
      },
      "TransferOwnershipDto": {
        "type": "object",
        "properties": {
          "email": {
            "type": "string"
          }
        },
        "required": [
          "email"
        ]
      },
      "DeleteCurrentTenantDto": {
        "type": "object",
        "properties": {
          "tenantId": {
            "type": "number"
          }
        },
        "required": [
          "tenantId"
        ]
      },
      "CreateStudentDto": {
        "type": "object",
        "properties": {
          "firstName": {
            "type": "string",
            "maxLength": 100
          },
          "lastName": {
            "type": "string",
            "maxLength": 100
          },
          "avatar": {
            "type": "string"
          },
          "schoolClassIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "firstName",
          "lastName"
        ]
      },
      "StudentDto": {
        "type": "object",
        "properties": {
          "schoolClasses": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolClassDto"
            }
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "firstName": {
            "type": "string"
          },
          "lastName": {
            "type": "string"
          },
          "avatar": {
            "type": "string",
            "nullable": true
          },
          "avatarPictureId": {
            "type": "number",
            "nullable": true,
            "description": "File id of the uploaded avatar picture; resolve the signed url via GET /files/:id/url"
          }
        },
        "required": [
          "schoolClasses",
          "id",
          "createdAt",
          "updatedAt",
          "firstName",
          "lastName",
          "avatarPictureId"
        ]
      },
      "StudentResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/StudentDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "CreateBulkStudentItemDto": {
        "type": "object",
        "properties": {
          "firstName": {
            "type": "string",
            "maxLength": 100
          },
          "lastName": {
            "type": "string",
            "maxLength": 100
          },
          "avatar": {
            "type": "string"
          },
          "schoolClassIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "clientKey": {
            "type": "string",
            "format": "uuid"
          }
        },
        "required": [
          "firstName",
          "lastName",
          "clientKey"
        ]
      },
      "CreateBulkStudentsDto": {
        "type": "object",
        "properties": {
          "students": {
            "uniqueItems": true,
            "minItems": 1,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CreateBulkStudentItemDto"
            }
          }
        },
        "required": [
          "students"
        ]
      },
      "CreatedStudentDto": {
        "type": "object",
        "properties": {
          "schoolClasses": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolClassDto"
            }
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "firstName": {
            "type": "string"
          },
          "lastName": {
            "type": "string"
          },
          "avatar": {
            "type": "string",
            "nullable": true
          },
          "avatarPictureId": {
            "type": "number",
            "nullable": true,
            "description": "File id of the uploaded avatar picture; resolve the signed url via GET /files/:id/url"
          },
          "clientKey": {
            "type": "string"
          }
        },
        "required": [
          "schoolClasses",
          "id",
          "createdAt",
          "updatedAt",
          "firstName",
          "lastName",
          "avatarPictureId"
        ]
      },
      "BulkStudentsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CreatedStudentDto"
            }
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateStudentDto": {
        "type": "object",
        "properties": {
          "clearAvatarPicture": {
            "type": "boolean"
          },
          "firstName": {
            "type": "string",
            "maxLength": 100
          },
          "lastName": {
            "type": "string",
            "maxLength": 100
          },
          "avatar": {
            "type": "string"
          },
          "schoolClassIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        }
      },
      "PaginatedStudentResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/StudentDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "StudentClassSubjectDto": {
        "type": "object",
        "properties": {
          "schoolSubjectId": {
            "type": "number"
          },
          "groupId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "schoolSubjectId",
          "groupId"
        ]
      },
      "StudentClassRelationDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "schoolClassId": {
            "type": "number"
          },
          "subjects": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/StudentClassSubjectDto"
            }
          }
        },
        "required": [
          "id",
          "schoolClassId",
          "subjects"
        ]
      },
      "StudentWithSubjectAccessDto": {
        "type": "object",
        "properties": {
          "schoolClassRelation": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/StudentClassRelationDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "firstName": {
            "type": "string"
          },
          "lastName": {
            "type": "string"
          },
          "avatar": {
            "type": "string",
            "nullable": true
          },
          "avatarPictureId": {
            "type": "number",
            "nullable": true,
            "description": "File id of the uploaded avatar picture; resolve the signed url via GET /files/:id/url"
          }
        },
        "required": [
          "id",
          "createdAt",
          "updatedAt",
          "firstName",
          "lastName",
          "avatarPictureId"
        ]
      },
      "PaginatedStudentWithSubjectAccessResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/StudentWithSubjectAccessDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "StudentImportRowDto": {
        "type": "object",
        "properties": {
          "firstName": {
            "type": "string",
            "description": "Empty when the list shows none.",
            "maxLength": 100
          },
          "lastName": {
            "type": "string",
            "description": "Empty when the list shows none.",
            "maxLength": 100
          }
        },
        "required": [
          "firstName",
          "lastName"
        ]
      },
      "StudentImportDto": {
        "type": "object",
        "properties": {
          "students": {
            "description": "In the list's order; a name the list doesn't show is empty.",
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/StudentImportRowDto"
            }
          }
        },
        "required": [
          "students"
        ]
      },
      "StudentImportResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/StudentImportDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "ReadStudentImportTextDto": {
        "type": "object",
        "properties": {
          "text": {
            "type": "string",
            "description": "Rows of a class list, e.g. copied from a spreadsheet or read from a CSV file; blank text is no list.",
            "maxLength": 20000
          }
        },
        "required": [
          "text"
        ]
      },
      "MatchStudentNamesDto": {
        "type": "object",
        "properties": {
          "schoolClassId": {
            "type": "number",
            "description": "The class the students go into; without one, the names are matched with the whole tenant."
          },
          "students": {
            "description": "The names as a list gave them, e.g. as /students/import/file read them.",
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/StudentImportRowDto"
            }
          }
        },
        "required": [
          "students"
        ]
      },
      "EStudentNameMatch": {
        "type": "string",
        "enum": [
          "inClass",
          "existing",
          "ambiguous",
          "new"
        ]
      },
      "StudentNameMatchDto": {
        "type": "object",
        "properties": {
          "match": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/EStudentNameMatch"
              }
            ]
          },
          "name": {
            "$ref": "#/components/schemas/StudentImportRowDto"
          },
          "students": {
            "description": "The tenant's students with the name outside the class: one for EXISTING, several for AMBIGUOUS, else none.",
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/StudentDto"
            }
          }
        },
        "required": [
          "match",
          "name",
          "students"
        ]
      },
      "StudentNameMatchesDto": {
        "type": "object",
        "properties": {
          "matches": {
            "description": "One per name, in the list's order.",
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/StudentNameMatchDto"
            }
          }
        },
        "required": [
          "matches"
        ]
      },
      "StudentNameMatchesResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/StudentNameMatchesDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "CreateSchoolClassDto": {
        "type": "object",
        "properties": {
          "type": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SchoolClassType"
              }
            ]
          },
          "schoolLevel": {
            "type": "number"
          },
          "name": {
            "type": "string",
            "maxLength": 4
          },
          "nickname": {
            "type": "string",
            "maxLength": 50
          },
          "isActive": {
            "type": "boolean"
          },
          "isOnboardingFinalized": {
            "type": "boolean"
          },
          "isAssessmentTypeOnboardingFinalized": {
            "type": "boolean"
          },
          "isStudentOnboardingFinalized": {
            "type": "boolean"
          },
          "isFullyOnboarded": {
            "type": "boolean"
          },
          "isTemplate": {
            "type": "boolean",
            "default": false
          },
          "schoolYearId": {
            "type": "number"
          },
          "baseClassId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "schoolLevel",
          "name",
          "isActive",
          "schoolYearId"
        ]
      },
      "SchoolClassResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/SchoolClassDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateEntityAppearanceDto": {
        "type": "object",
        "properties": {
          "type": {
            "type": "string",
            "enum": [
              "text",
              "emoji",
              "icon"
            ]
          },
          "backgroundColor": {
            "type": "string",
            "pattern": "/^#[0-9a-fA-F]{6}$/"
          },
          "key": {
            "type": "string",
            "maxLength": 255
          }
        },
        "required": [
          "type",
          "backgroundColor"
        ]
      },
      "AddAccessRightDto": {
        "type": "object",
        "properties": {
          "email": {
            "type": "string"
          },
          "subjectIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "canManageAccessRights": {
            "type": "boolean"
          },
          "canManageStudents": {
            "type": "boolean"
          },
          "canManagePerformanceAssessments": {
            "type": "boolean"
          },
          "canManageCompetences": {
            "type": "boolean"
          }
        },
        "required": [
          "email"
        ]
      },
      "AddInvitationAccessRightDto": {
        "type": "object",
        "properties": {
          "email": {
            "type": "string"
          },
          "subjectIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "canManageAccessRights": {
            "type": "boolean"
          },
          "canManageStudents": {
            "type": "boolean"
          },
          "canManagePerformanceAssessments": {
            "type": "boolean"
          },
          "canManageCompetences": {
            "type": "boolean"
          },
          "invitationId": {
            "type": "number"
          }
        },
        "required": [
          "email",
          "invitationId"
        ]
      },
      "CreateSetupStudentDto": {
        "type": "object",
        "properties": {
          "firstName": {
            "type": "string",
            "maxLength": 100
          },
          "lastName": {
            "type": "string",
            "maxLength": 100
          },
          "avatar": {
            "type": "string"
          },
          "schoolClassIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "clientKey": {
            "type": "string",
            "format": "uuid"
          }
        },
        "required": [
          "firstName",
          "lastName"
        ]
      },
      "CreateSchoolClassSetupDto": {
        "type": "object",
        "properties": {
          "appearance": {
            "$ref": "#/components/schemas/UpdateEntityAppearanceDto"
          },
          "schoolClass": {
            "$ref": "#/components/schemas/CreateSchoolClassDto"
          },
          "schoolSubjectIdsToCopy": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "accessRights": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/AddAccessRightDto"
            }
          },
          "invitationAccessRights": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/AddInvitationAccessRightDto"
            }
          },
          "studentsToCreate": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CreateSetupStudentDto"
            }
          },
          "existingStudentIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "appearanceImageFileId": {
            "type": "number",
            "description": "A completed direct upload of type entityAppearanceImage; exclusive with `appearance`.",
            "minimum": 1
          }
        },
        "required": [
          "schoolClass"
        ]
      },
      "SchoolClassSetupResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/SchoolClassDto"
          },
          "createdStudents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CreatedStudentDto"
            }
          }
        },
        "required": [
          "success",
          "data",
          "createdStudents"
        ]
      },
      "UpdateSchoolClassDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "maxLength": 4
          },
          "nickname": {
            "type": "string",
            "maxLength": 50
          },
          "isActive": {
            "type": "boolean"
          },
          "isOnboardingFinalized": {
            "type": "boolean"
          },
          "isAssessmentTypeOnboardingFinalized": {
            "type": "boolean"
          },
          "isStudentOnboardingFinalized": {
            "type": "boolean"
          },
          "isTemplate": {
            "type": "boolean",
            "default": false
          },
          "schoolYearId": {
            "type": "number"
          }
        }
      },
      "PaginatedSchoolClassResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolClassDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "ArchiveSchoolClassDto": {
        "type": "object",
        "properties": {
          "finalNote": {
            "type": "string",
            "maxLength": 5000
          }
        }
      },
      "SetBaseClassDto": {
        "type": "object",
        "properties": {
          "baseClassId": {
            "type": "number"
          }
        },
        "required": [
          "baseClassId"
        ]
      },
      "UpsertSchoolClassAccessDto": {
        "type": "object",
        "properties": {
          "accessRights": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/AddAccessRightDto"
            }
          }
        },
        "required": [
          "accessRights"
        ]
      },
      "AddInvitationSchoolClassAccessDto": {
        "type": "object",
        "properties": {
          "accessRights": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/AddInvitationAccessRightDto"
            }
          }
        },
        "required": [
          "accessRights"
        ]
      },
      "PaginatedSchoolClassAccessRightResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolClassAccessRightDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "InvitationAccessRightPermissionsDto": {
        "type": "object",
        "properties": {
          "canManageAccessRights": {
            "type": "boolean"
          },
          "canManageStudents": {
            "type": "boolean"
          },
          "canManagePerformanceAssessments": {
            "type": "boolean"
          },
          "canManageCompetences": {
            "type": "boolean"
          },
          "subjects": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/BaseSchoolSubjectDto"
            }
          }
        },
        "required": [
          "canManageAccessRights",
          "canManageStudents",
          "canManagePerformanceAssessments",
          "canManageCompetences"
        ]
      },
      "InvitationAccessRightDto": {
        "type": "object",
        "properties": {
          "userRoleType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserRoleType"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "invitationId": {
            "type": "number"
          },
          "email": {
            "type": "string",
            "nullable": true
          },
          "schoolClassId": {
            "type": "number"
          },
          "permissions": {
            "$ref": "#/components/schemas/InvitationAccessRightPermissionsDto"
          }
        },
        "required": [
          "userRoleType",
          "id",
          "createdAt",
          "updatedAt",
          "invitationId",
          "email",
          "schoolClassId",
          "permissions"
        ]
      },
      "PaginatedInvitationAccessRightResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/InvitationAccessRightDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "PaginatedPerformanceVisualResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/PerformanceVisualDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "PerformanceAssessmentLevelColumnDto": {
        "type": "object",
        "properties": {
          "performanceLevelV2Id": {
            "type": "number"
          },
          "level": {
            "type": "number"
          }
        },
        "required": [
          "performanceLevelV2Id",
          "level"
        ]
      },
      "SchoolGradeCountDto": {
        "type": "object",
        "properties": {
          "gradeValue": {
            "type": "number"
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "gradeValue",
          "count"
        ]
      },
      "PerformanceAssessmentStudentLevelCountDto": {
        "type": "object",
        "properties": {
          "countsByLevel": {
            "type": "object",
            "additionalProperties": {
              "type": "number"
            }
          },
          "studentId": {
            "type": "number"
          },
          "firstName": {
            "type": "string"
          },
          "lastName": {
            "type": "string"
          },
          "avatar": {
            "type": "string",
            "nullable": true
          },
          "total": {
            "type": "number"
          },
          "gradeCounts": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolGradeCountDto"
            }
          }
        },
        "required": [
          "countsByLevel",
          "studentId",
          "firstName",
          "lastName",
          "avatar",
          "total"
        ]
      },
      "PerformanceAssessmentStudentLevelCountsDto": {
        "type": "object",
        "properties": {
          "schoolClassId": {
            "type": "number"
          },
          "schoolSubjectId": {
            "type": "number"
          },
          "performanceAssessmentId": {
            "type": "number"
          },
          "entryCount": {
            "type": "number"
          },
          "columns": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/PerformanceAssessmentLevelColumnDto"
            }
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/PerformanceAssessmentStudentLevelCountDto"
            }
          }
        },
        "required": [
          "schoolClassId",
          "schoolSubjectId",
          "performanceAssessmentId",
          "entryCount",
          "columns",
          "rows"
        ]
      },
      "PerformanceAssessmentStudentLevelCountsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/PerformanceAssessmentStudentLevelCountsDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "PerformanceAssessmentEntryCountDto": {
        "type": "object",
        "properties": {
          "performanceAssessmentId": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "symbol": {
            "type": "string"
          },
          "order": {
            "type": "number"
          },
          "entryCount": {
            "type": "number"
          }
        },
        "required": [
          "performanceAssessmentId",
          "name",
          "symbol",
          "order",
          "entryCount"
        ]
      },
      "PerformanceAssessmentEntryCountsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/PerformanceAssessmentEntryCountDto"
            }
          }
        },
        "required": [
          "success",
          "rows"
        ]
      },
      "PerformanceAssessmentEntryCountTotalsByTermDto": {
        "type": "object",
        "properties": {
          "schoolTermId": {
            "type": "number",
            "nullable": true
          },
          "entryCount": {
            "type": "number"
          }
        },
        "required": [
          "schoolTermId",
          "entryCount"
        ]
      },
      "PerformanceAssessmentEntryCountTotalsByTermResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/PerformanceAssessmentEntryCountTotalsByTermDto"
            }
          }
        },
        "required": [
          "success",
          "rows"
        ]
      },
      "PerformanceAssessmentCountBySubjectDto": {
        "type": "object",
        "properties": {
          "schoolSubjectId": {
            "type": "number"
          },
          "abbreviation": {
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "color": {
            "type": "string"
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "schoolSubjectId",
          "abbreviation",
          "name",
          "color",
          "count"
        ]
      },
      "PerformanceAssessmentCountsBySubjectResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/PerformanceAssessmentCountBySubjectDto"
            }
          }
        },
        "required": [
          "success",
          "rows"
        ]
      },
      "PerformanceAssessmentEvaluationBucketDto": {
        "type": "object",
        "properties": {
          "gradeValue": {
            "type": "number"
          },
          "performanceLevelV2Id": {
            "type": "number",
            "nullable": true
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "performanceLevelV2Id",
          "count"
        ]
      },
      "PerformanceAssessmentEvaluationsByAssessmentDto": {
        "type": "object",
        "properties": {
          "performanceAssessmentId": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "symbol": {
            "type": "string"
          },
          "order": {
            "type": "number"
          },
          "buckets": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/PerformanceAssessmentEvaluationBucketDto"
            }
          },
          "total": {
            "type": "number"
          },
          "unratedEntryCount": {
            "type": "number"
          }
        },
        "required": [
          "performanceAssessmentId",
          "name",
          "symbol",
          "order",
          "buckets",
          "total",
          "unratedEntryCount"
        ]
      },
      "PerformanceAssessmentEvaluationsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/PerformanceAssessmentEvaluationsByAssessmentDto"
            }
          }
        },
        "required": [
          "success",
          "rows"
        ]
      },
      "StudentAndClassIds": {
        "type": "object",
        "properties": {
          "studentId": {
            "type": "number"
          },
          "schoolClassId": {
            "type": "number"
          }
        },
        "required": [
          "studentId",
          "schoolClassId"
        ]
      },
      "EditStudentClassRelationDto": {
        "type": "object",
        "properties": {
          "ids": {
            "minItems": 1,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/StudentAndClassIds"
            }
          }
        },
        "required": [
          "ids"
        ]
      },
      "DuplicateSchoolSubjectDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "maxLength": 100
          }
        },
        "required": [
          "name"
        ]
      },
      "SchoolSubjectResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/SchoolSubjectDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "CreateSchoolSubjectDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "maxLength": 100
          },
          "abbreviation": {
            "type": "string",
            "maxLength": 100
          },
          "color": {
            "type": "string",
            "minLength": 7,
            "maxLength": 7,
            "pattern": "^#[A-Fa-f0-9]{6}$"
          },
          "schoolLevel": {
            "type": "number"
          }
        },
        "required": [
          "name",
          "abbreviation",
          "color",
          "schoolLevel"
        ]
      },
      "CopySchoolSubjectsDto": {
        "type": "object",
        "properties": {
          "schoolSubjectIdsToCopy": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "schoolSubjectIdsToCopy"
        ]
      },
      "AssignStudentsToSubjectDto": {
        "type": "object",
        "properties": {
          "studentIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "studentIds"
        ]
      },
      "BaseStudentDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "firstName": {
            "type": "string"
          },
          "lastName": {
            "type": "string"
          },
          "avatar": {
            "type": "string",
            "nullable": true
          },
          "avatarPictureId": {
            "type": "number",
            "nullable": true,
            "description": "File id of the uploaded avatar picture; resolve the signed url via GET /files/:id/url"
          }
        },
        "required": [
          "id",
          "createdAt",
          "updatedAt",
          "firstName",
          "lastName",
          "avatarPictureId"
        ]
      },
      "PaginatedBaseStudentDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/BaseStudentDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "SchoolSubjectAccessAllResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "type": "boolean"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateSchoolSubjectDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "maxLength": 100
          },
          "abbreviation": {
            "type": "string",
            "maxLength": 100
          },
          "color": {
            "type": "string",
            "minLength": 7,
            "maxLength": 7,
            "pattern": "^#[A-Fa-f0-9]{6}$"
          },
          "schoolLevel": {
            "type": "number"
          }
        }
      },
      "SetSubjectSpecificAssessmentsDto": {
        "type": "object",
        "properties": {
          "value": {
            "type": "boolean"
          }
        },
        "required": [
          "value"
        ]
      },
      "SubjectSpecificAssessmentSetupPreviewDto": {
        "type": "object",
        "properties": {
          "entryCount": {
            "type": "number"
          }
        },
        "required": [
          "entryCount"
        ]
      },
      "SubjectSpecificAssessmentSetupPreviewResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/SubjectSpecificAssessmentSetupPreviewDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "CreateCompetenceDomainDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "maxLength": 250
          },
          "symbol": {
            "type": "string"
          }
        },
        "required": [
          "name",
          "symbol"
        ]
      },
      "CompetenceDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "domainId": {
            "type": "number"
          },
          "description": {
            "type": "string"
          },
          "order": {
            "type": "number"
          },
          "observationCount": {
            "type": "number"
          }
        },
        "required": [
          "id",
          "createdAt",
          "updatedAt",
          "domainId",
          "description",
          "order",
          "observationCount"
        ]
      },
      "CompetenceDomainDto": {
        "type": "object",
        "properties": {
          "competences": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CompetenceDto"
            }
          },
          "schoolSubjectGroupId": {
            "type": "number",
            "nullable": true
          },
          "observationCount": {
            "type": "number"
          },
          "id": {
            "type": "number"
          },
          "originId": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "tenantId": {
            "type": "number",
            "nullable": true
          },
          "schoolSubjectId": {
            "type": "number",
            "nullable": true
          },
          "name": {
            "type": "string"
          },
          "symbol": {
            "type": "string"
          },
          "isTemplate": {
            "type": "boolean"
          }
        },
        "required": [
          "competences",
          "schoolSubjectGroupId",
          "observationCount",
          "id",
          "originId",
          "createdAt",
          "updatedAt",
          "tenantId",
          "schoolSubjectId",
          "name",
          "symbol",
          "isTemplate"
        ]
      },
      "CompetenceDomainResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/CompetenceDomainDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateCompetenceDomainDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "maxLength": 250
          },
          "symbol": {
            "type": "string"
          }
        }
      },
      "PaginatedCompetenceDomainResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CompetenceDomainDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "CreateCompetenceDto": {
        "type": "object",
        "properties": {
          "description": {
            "type": "string"
          },
          "order": {
            "type": "number",
            "minimum": 0
          }
        },
        "required": [
          "description"
        ]
      },
      "CompetenceResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/CompetenceDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateCompetenceDto": {
        "type": "object",
        "properties": {
          "domainId": {
            "type": "number",
            "minimum": 0
          },
          "description": {
            "type": "string"
          },
          "order": {
            "type": "number",
            "minimum": 0
          }
        }
      },
      "UpdateUserDto": {
        "type": "object",
        "properties": {
          "language": {
            "type": "string",
            "pattern": "^[a-z]{2,3}$",
            "example": "de"
          },
          "firstName": {
            "type": "string",
            "maxLength": 1000
          },
          "lastName": {
            "type": "string",
            "maxLength": 1000
          },
          "isSetupCompleted": {
            "type": "boolean"
          },
          "classSetupTooltipSeen": {
            "type": "boolean"
          },
          "teamSetupTooltipSeen": {
            "type": "boolean"
          },
          "classSelectorTooltipSeen": {
            "type": "boolean"
          },
          "studentOverviewPerformanceAssessmentTooltipSeen": {
            "type": "boolean"
          },
          "avatar": {
            "type": "string"
          },
          "clearAvatarPicture": {
            "type": "boolean"
          },
          "countryId": {
            "type": "number",
            "nullable": true
          },
          "stateId": {
            "type": "number",
            "nullable": true
          },
          "demoClassWizardSeen": {
            "type": "boolean"
          },
          "ratingDialogSeenAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "newsletterActive": {
            "type": "boolean"
          },
          "weeklyReportActive": {
            "type": "boolean"
          }
        }
      },
      "UserDataResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/UserDataDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateUserSourceDto": {
        "type": "object",
        "properties": {
          "source": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserSource"
              }
            ]
          },
          "sourceOther": {
            "type": "string",
            "maxLength": 100
          }
        },
        "required": [
          "source"
        ]
      },
      "UserShouldTfaBeActivatedResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "shouldTfaBeActivated": {
            "type": "boolean"
          }
        },
        "required": [
          "success",
          "shouldTfaBeActivated"
        ]
      },
      "UserTotpStatusResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "totpEnabled": {
            "type": "boolean"
          }
        },
        "required": [
          "success",
          "totpEnabled"
        ]
      },
      "UserTfaStatusResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "tfaEnabled": {
            "type": "boolean"
          }
        },
        "required": [
          "success",
          "tfaEnabled"
        ]
      },
      "EnableTotpDto": {
        "type": "object",
        "properties": {
          "totpCode": {
            "type": "string"
          }
        },
        "required": [
          "totpCode"
        ]
      },
      "NameRepresentation": {
        "type": "string",
        "enum": [
          "firstNameBeforeLastName",
          "lastNameBeforeFirstName"
        ]
      },
      "NameSortation": {
        "type": "string",
        "enum": [
          "sortByFirstName",
          "sortByLastName"
        ]
      },
      "WeekRepresentation": {
        "type": "string",
        "enum": [
          "calendarWeek",
          "schoolWeek"
        ]
      },
      "UpdateUserSettingDto": {
        "type": "object",
        "properties": {
          "nameRepresentation": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/NameRepresentation"
              }
            ]
          },
          "nameSortation": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/NameSortation"
              }
            ]
          },
          "weekRepresentation": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/WeekRepresentation"
              }
            ]
          }
        }
      },
      "UserSettingDataDto": {
        "type": "object",
        "properties": {
          "nameRepresentation": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/NameRepresentation"
              }
            ]
          },
          "nameSortation": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/NameSortation"
              }
            ]
          },
          "weekRepresentation": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/WeekRepresentation"
              }
            ]
          }
        },
        "required": [
          "nameRepresentation",
          "nameSortation",
          "weekRepresentation"
        ]
      },
      "UserSettingResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/UserSettingDataDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "StateDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "countryId": {
            "type": "number"
          },
          "parentStateId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "id",
          "createdAt",
          "updatedAt",
          "name",
          "countryId",
          "parentStateId"
        ]
      },
      "SchoolYearDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "year": {
            "type": "number"
          },
          "schoolYearStart": {
            "format": "date-time",
            "type": "string"
          },
          "schoolYearEnd": {
            "format": "date-time",
            "type": "string"
          },
          "terms": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolTermDto"
            }
          },
          "states": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/StateDto"
            }
          },
          "schoolClassCount": {
            "type": "number"
          }
        },
        "required": [
          "id",
          "createdAt",
          "updatedAt",
          "year",
          "schoolYearStart",
          "schoolYearEnd",
          "terms",
          "states"
        ]
      },
      "PaginatedSchoolYearResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolYearDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "CurrentSchoolTermResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SchoolTermDto"
              },
              {
                "nullable": true
              }
            ]
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "CreateSchoolTermDto": {
        "type": "object",
        "properties": {
          "schoolTermSemester": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SchoolTermSemester"
              }
            ]
          },
          "name": {
            "type": "string",
            "maxLength": 255
          },
          "startDate": {
            "format": "date-time",
            "type": "string"
          },
          "endDate": {
            "format": "date-time",
            "type": "string"
          }
        },
        "required": [
          "schoolTermSemester",
          "name",
          "startDate",
          "endDate"
        ]
      },
      "CreateSchoolYearDto": {
        "type": "object",
        "properties": {
          "terms": {
            "minItems": 1,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CreateSchoolTermDto"
            }
          },
          "stateIds": {
            "minItems": 1,
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "terms",
          "stateIds"
        ]
      },
      "SchoolYearResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/SchoolYearDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateSchoolYearDto": {
        "type": "object",
        "properties": {
          "terms": {
            "minItems": 1,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CreateSchoolTermDto"
            }
          },
          "stateIds": {
            "minItems": 1,
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        }
      },
      "CreatePerformanceVisualDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "maxLength": 50
          },
          "levels": {
            "type": "number",
            "minimum": 1
          },
          "schoolClassId": {
            "type": "number"
          },
          "isTemplate": {
            "type": "boolean"
          }
        },
        "required": [
          "name",
          "levels"
        ]
      },
      "PerformanceVisualResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/PerformanceVisualDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdatePerformanceVisualDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "maxLength": 50
          },
          "levels": {
            "type": "number",
            "minimum": 1
          },
          "schoolClassId": {
            "type": "number"
          },
          "isTemplate": {
            "type": "boolean"
          }
        },
        "required": [
          "name",
          "levels"
        ]
      },
      "GlobalTemplateScopeDto": {
        "type": "object",
        "properties": {
          "countryId": {
            "type": "number",
            "nullable": true
          },
          "stateId": {
            "type": "number",
            "nullable": true
          },
          "schoolTypeId": {
            "type": "number",
            "nullable": true
          },
          "languageId": {
            "type": "number",
            "nullable": true
          }
        }
      },
      "CreatePerformanceLevelV2Dto": {
        "type": "object",
        "properties": {
          "level": {
            "type": "number",
            "minimum": 1
          },
          "pictureFileId": {
            "type": "number",
            "description": "A completed direct upload of type performanceLevelPicture.",
            "minimum": 1
          }
        },
        "required": [
          "level",
          "pictureFileId"
        ]
      },
      "PerformanceLevelV2ResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/PerformanceLevelV2Dto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdatePerformanceLevelV2Dto": {
        "type": "object",
        "properties": {
          "level": {
            "type": "number",
            "minimum": 1
          },
          "pictureFileId": {
            "type": "number",
            "minimum": 1
          }
        },
        "required": [
          "level"
        ]
      },
      "CreatePerformanceAssessmentDto": {
        "type": "object",
        "properties": {
          "documentationMode": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/PerformanceAssessmentDocumentationMode"
              }
            ]
          },
          "name": {
            "type": "string"
          },
          "weighting": {
            "type": "number",
            "minimum": 0,
            "maximum": 100
          },
          "schoolLevel": {
            "type": "number",
            "minimum": 0
          },
          "isTemplate": {
            "type": "boolean"
          },
          "performanceVisualId": {
            "type": "number",
            "nullable": true
          },
          "symbol": {
            "type": "string"
          },
          "schoolClassId": {
            "type": "number"
          },
          "schoolSubjectId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "name",
          "weighting",
          "schoolLevel",
          "performanceVisualId",
          "symbol",
          "schoolSubjectId"
        ]
      },
      "PerformanceAssessmentResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/PerformanceAssessmentDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdatePerformanceAssessmentDto": {
        "type": "object",
        "properties": {
          "documentationMode": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/PerformanceAssessmentDocumentationMode"
              }
            ]
          },
          "order": {
            "type": "number",
            "minimum": 0
          },
          "isNameCustomized": {
            "type": "boolean"
          },
          "name": {
            "type": "string"
          },
          "weighting": {
            "type": "number",
            "minimum": 0,
            "maximum": 100
          },
          "schoolLevel": {
            "type": "number",
            "minimum": 0
          },
          "isTemplate": {
            "type": "boolean"
          },
          "performanceVisualId": {
            "type": "number",
            "nullable": true
          },
          "symbol": {
            "type": "string"
          },
          "schoolClassId": {
            "type": "number"
          }
        },
        "required": [
          "name",
          "weighting",
          "schoolLevel",
          "performanceVisualId",
          "symbol"
        ]
      },
      "ProviderCreatePerformanceAssessmentDto": {
        "type": "object",
        "properties": {
          "documentationMode": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/PerformanceAssessmentDocumentationMode"
              }
            ]
          },
          "name": {
            "type": "string"
          },
          "weighting": {
            "type": "number",
            "minimum": 0,
            "maximum": 100
          },
          "schoolLevel": {
            "type": "number",
            "minimum": 0
          },
          "isTemplate": {
            "type": "boolean"
          },
          "performanceVisualId": {
            "type": "number",
            "nullable": true
          },
          "symbol": {
            "type": "string"
          },
          "schoolClassId": {
            "type": "number"
          },
          "schoolSubjectId": {
            "type": "number",
            "nullable": true
          },
          "countryId": {
            "type": "number",
            "nullable": true
          },
          "stateId": {
            "type": "number",
            "nullable": true
          },
          "schoolTypeId": {
            "type": "number",
            "nullable": true
          },
          "languageId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "name",
          "weighting",
          "schoolLevel",
          "performanceVisualId",
          "symbol",
          "schoolSubjectId"
        ]
      },
      "ProviderUpdatePerformanceAssessmentDto": {
        "type": "object",
        "properties": {
          "documentationMode": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/PerformanceAssessmentDocumentationMode"
              }
            ]
          },
          "order": {
            "type": "number",
            "minimum": 0
          },
          "isNameCustomized": {
            "type": "boolean"
          },
          "name": {
            "type": "string"
          },
          "weighting": {
            "type": "number",
            "minimum": 0,
            "maximum": 100
          },
          "schoolLevel": {
            "type": "number",
            "minimum": 0
          },
          "isTemplate": {
            "type": "boolean"
          },
          "performanceVisualId": {
            "type": "number",
            "nullable": true
          },
          "symbol": {
            "type": "string"
          },
          "schoolClassId": {
            "type": "number"
          }
        },
        "required": [
          "name",
          "weighting",
          "schoolLevel",
          "performanceVisualId",
          "symbol"
        ]
      },
      "ECompetenceTrendResolution": {
        "type": "string",
        "enum": [
          "week",
          "month"
        ]
      },
      "StudentCompetenceTrendPointDto": {
        "type": "object",
        "properties": {
          "bucketStart": {
            "format": "date-time",
            "type": "string"
          },
          "averageLevel": {
            "type": "number",
            "nullable": true
          },
          "entryCount": {
            "type": "number"
          }
        },
        "required": [
          "bucketStart",
          "averageLevel",
          "entryCount"
        ]
      },
      "StudentCompetenceTrendDto": {
        "type": "object",
        "properties": {
          "resolution": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ECompetenceTrendResolution"
              }
            ]
          },
          "totalEntryCount": {
            "type": "number"
          },
          "points": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/StudentCompetenceTrendPointDto"
            }
          }
        },
        "required": [
          "resolution",
          "totalEntryCount",
          "points"
        ]
      },
      "StudentCompetenceTrendResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/StudentCompetenceTrendDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "BulkUpdateCompetenceObservationLevelDto": {
        "type": "object",
        "properties": {
          "observationIds": {
            "minItems": 1,
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "performanceLevelV2Id": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "observationIds",
          "performanceLevelV2Id"
        ]
      },
      "UpdateCompetenceObservationDto": {
        "type": "object",
        "properties": {
          "performanceLevelV2Id": {
            "type": "number",
            "nullable": true
          },
          "description": {
            "type": "string"
          },
          "observedAt": {
            "format": "date-time",
            "type": "string"
          }
        }
      },
      "BasePerformanceAssessmentDto": {
        "type": "object",
        "properties": {
          "documentationMode": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/PerformanceAssessmentDocumentationMode"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "isOfficial": {
            "type": "boolean"
          },
          "isTemplate": {
            "type": "boolean"
          },
          "order": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "key": {
            "type": "string",
            "nullable": true
          },
          "isNameCustomized": {
            "type": "boolean"
          },
          "originId": {
            "type": "number"
          },
          "performanceVisual": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/PerformanceVisualDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "performanceVisualId": {
            "type": "number",
            "nullable": true
          },
          "schoolClassId": {
            "type": "number",
            "nullable": true
          },
          "schoolLevel": {
            "type": "number"
          },
          "schoolSubject": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BaseSchoolSubjectDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "schoolSubjectId": {
            "type": "number",
            "nullable": true
          },
          "symbol": {
            "type": "string"
          },
          "tenantId": {
            "type": "number",
            "nullable": true
          },
          "weighting": {
            "type": "number"
          },
          "countryId": {
            "type": "number",
            "nullable": true
          },
          "stateId": {
            "type": "number",
            "nullable": true
          },
          "schoolTypeId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "documentationMode",
          "id",
          "createdAt",
          "updatedAt",
          "isOfficial",
          "isTemplate",
          "order",
          "name",
          "key",
          "isNameCustomized",
          "originId",
          "performanceVisual",
          "performanceVisualId",
          "schoolClassId",
          "schoolLevel",
          "schoolSubject",
          "schoolSubjectId",
          "symbol",
          "tenantId",
          "weighting",
          "countryId",
          "stateId",
          "schoolTypeId"
        ]
      },
      "BasePerformanceAssessmentEntryDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "creator": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserDataDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "lastEditor": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserDataDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "label": {
            "type": "string"
          },
          "date": {
            "format": "date-time",
            "type": "string"
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "gradeCalculationTagId": {
            "type": "number",
            "nullable": true
          },
          "gradeCalculationTag": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/GradeCalculationTagDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "schoolSubject": {
            "$ref": "#/components/schemas/BaseSchoolSubjectDto"
          },
          "performanceAssessment": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BasePerformanceAssessmentDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "schoolClassId": {
            "type": "number"
          }
        },
        "required": [
          "id",
          "creator",
          "lastEditor",
          "createdAt",
          "updatedAt",
          "label",
          "date",
          "description",
          "gradeCalculationTagId",
          "gradeCalculationTag",
          "schoolSubject",
          "performanceAssessment",
          "schoolClassId"
        ]
      },
      "CompetenceObservationDto": {
        "type": "object",
        "properties": {
          "creator": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserDataDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "performanceLevelV2": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/PerformanceLevelV2Dto"
              },
              {
                "nullable": true
              }
            ]
          },
          "performanceAssessmentEntry": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BasePerformanceAssessmentEntryDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "competenceId": {
            "type": "number"
          },
          "schoolClassId": {
            "type": "number"
          },
          "studentId": {
            "type": "number"
          },
          "observedAt": {
            "format": "date-time",
            "type": "string"
          },
          "description": {
            "type": "string"
          },
          "competenceAssessmentId": {
            "type": "number"
          },
          "performanceLevelV2Id": {
            "type": "number",
            "nullable": true
          },
          "performanceAssessmentEntryId": {
            "type": "number",
            "nullable": true
          },
          "supportMeasureProtocolEntryId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "creator",
          "performanceLevelV2",
          "performanceAssessmentEntry",
          "id",
          "createdAt",
          "updatedAt",
          "competenceId",
          "schoolClassId",
          "studentId",
          "observedAt",
          "description",
          "competenceAssessmentId",
          "performanceLevelV2Id",
          "performanceAssessmentEntryId",
          "supportMeasureProtocolEntryId"
        ]
      },
      "CompetenceObservationResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/CompetenceObservationDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "PaginatedCompetenceObservationResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CompetenceObservationDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "ReportType": {
        "type": "string",
        "enum": [
          "standard",
          "notesReport"
        ]
      },
      "CalculationMethod": {
        "type": "string",
        "enum": [
          "latestEntries",
          "allEntries"
        ]
      },
      "ReportCoverSheet": {
        "type": "string",
        "enum": [
          "simple",
          "withChart",
          "withCustomImage",
          "withNote",
          "withFlower"
        ]
      },
      "ReportCompetenceType": {
        "type": "string",
        "enum": [
          "compact",
          "simple",
          "withNotes",
          "withPerformanceAssessments"
        ]
      },
      "ReportSummarySheet": {
        "type": "string",
        "enum": [
          "simple",
          "signature"
        ]
      },
      "CreateReportDto": {
        "type": "object",
        "properties": {
          "type": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReportType"
              }
            ]
          },
          "calculationMethod": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/CalculationMethod"
              },
              {
                "nullable": true
              }
            ]
          },
          "coverSheet": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReportCoverSheet"
              },
              {
                "nullable": true
              }
            ]
          },
          "competenceType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReportCompetenceType"
              },
              {
                "nullable": true
              }
            ]
          },
          "summarySheet": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReportSummarySheet"
              },
              {
                "nullable": true
              }
            ]
          },
          "name": {
            "type": "string",
            "maxLength": 100
          },
          "startDate": {
            "format": "date-time",
            "type": "string"
          },
          "endDate": {
            "format": "date-time",
            "type": "string"
          },
          "assessedCompetencesOnly": {
            "type": "boolean"
          },
          "showGradeRecommendation": {
            "type": "boolean"
          },
          "showCompetenceLevelDescriptions": {
            "type": "boolean"
          },
          "showNoteCompetences": {
            "type": "boolean"
          },
          "prefillData": {
            "type": "boolean"
          }
        },
        "required": [
          "calculationMethod",
          "coverSheet",
          "competenceType",
          "summarySheet",
          "name",
          "startDate",
          "endDate",
          "assessedCompetencesOnly",
          "showGradeRecommendation",
          "showCompetenceLevelDescriptions"
        ]
      },
      "CreateBulkReportsDto": {
        "type": "object",
        "properties": {
          "baseData": {
            "$ref": "#/components/schemas/CreateReportDto"
          },
          "studentIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "subjectIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "includeNotesWithoutSubject": {
            "type": "boolean",
            "description": "Notes reports only: also lists the notes that have no subject"
          },
          "reportGroupId": {
            "type": "number"
          }
        },
        "required": [
          "baseData",
          "studentIds",
          "subjectIds"
        ]
      },
      "ReportStatus": {
        "type": "string",
        "enum": [
          "inProgress",
          "completed"
        ]
      },
      "BaseReportDto": {
        "type": "object",
        "properties": {
          "status": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReportStatus"
              }
            ]
          },
          "type": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReportType"
              }
            ]
          },
          "calculationMethod": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/CalculationMethod"
              },
              {
                "nullable": true
              }
            ]
          },
          "summarySheet": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReportSummarySheet"
              },
              {
                "nullable": true
              }
            ]
          },
          "competenceType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReportCompetenceType"
              },
              {
                "nullable": true
              }
            ]
          },
          "coverSheet": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReportCoverSheet"
              },
              {
                "nullable": true
              }
            ]
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "tenantId": {
            "type": "number"
          },
          "id": {
            "type": "number"
          },
          "groupId": {
            "type": "number",
            "nullable": true
          },
          "name": {
            "type": "string"
          },
          "startDate": {
            "format": "date-time",
            "type": "string"
          },
          "endDate": {
            "format": "date-time",
            "type": "string"
          },
          "prefillData": {
            "type": "boolean"
          },
          "competenceAssessmentId": {
            "type": "number",
            "nullable": true
          },
          "originalStudentId": {
            "type": "number",
            "nullable": true
          },
          "studentFirstName": {
            "type": "string"
          },
          "studentLastName": {
            "type": "string"
          },
          "studentAvatar": {
            "type": "string",
            "nullable": true
          },
          "studentAvatarPictureId": {
            "type": "number",
            "nullable": true,
            "description": "File id of the snapshotted student avatar picture; resolve the signed url via GET /files/:id/url"
          },
          "completedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "accessibleSubjectCount": {
            "type": "number",
            "nullable": true
          },
          "assessedCompetencesOnly": {
            "type": "boolean"
          },
          "showGradeRecommendation": {
            "type": "boolean"
          },
          "showCompetenceLevelDescriptions": {
            "type": "boolean"
          },
          "showNoteCompetences": {
            "type": "boolean"
          }
        },
        "required": [
          "status",
          "type",
          "competenceType",
          "createdAt",
          "updatedAt",
          "tenantId",
          "id",
          "groupId",
          "name",
          "startDate",
          "endDate",
          "prefillData",
          "competenceAssessmentId",
          "originalStudentId",
          "studentFirstName",
          "studentLastName",
          "studentAvatar",
          "studentAvatarPictureId",
          "completedAt",
          "accessibleSubjectCount",
          "assessedCompetencesOnly",
          "showGradeRecommendation",
          "showCompetenceLevelDescriptions",
          "showNoteCompetences"
        ]
      },
      "ReportsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/BaseReportDto"
            }
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "AsyncOperationCreatedDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "uuid": {
            "type": "string"
          }
        },
        "required": [
          "id",
          "uuid"
        ]
      },
      "AsyncOperationCreatedResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/AsyncOperationCreatedDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateReportCompetenceDto": {
        "type": "object",
        "properties": {
          "performanceLevelV2Id": {
            "type": "number"
          }
        },
        "required": [
          "performanceLevelV2Id"
        ]
      },
      "ReportCompetenceDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "competenceDescription": {
            "type": "string"
          },
          "performanceLevel": {
            "type": "number",
            "nullable": true
          },
          "visualLevelLabel": {
            "type": "string",
            "nullable": true
          },
          "visualImagePath": {
            "type": "string",
            "nullable": true
          },
          "visualImageFileId": {
            "type": "number",
            "nullable": true
          },
          "overwrittenPerformanceLevel": {
            "type": "number",
            "nullable": true
          },
          "averagePerformanceLevel": {
            "type": "number",
            "nullable": true
          },
          "order": {
            "type": "number"
          }
        },
        "required": [
          "id",
          "competenceDescription",
          "performanceLevel",
          "visualLevelLabel",
          "visualImagePath",
          "visualImageFileId",
          "overwrittenPerformanceLevel",
          "averagePerformanceLevel",
          "order"
        ]
      },
      "ReportCompetenceResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/ReportCompetenceDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateReportDto": {
        "type": "object",
        "properties": {
          "calculationMethod": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/CalculationMethod"
              },
              {
                "nullable": true
              }
            ]
          },
          "coverSheet": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReportCoverSheet"
              },
              {
                "nullable": true
              }
            ]
          },
          "competenceType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReportCompetenceType"
              },
              {
                "nullable": true
              }
            ]
          },
          "summarySheet": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReportSummarySheet"
              },
              {
                "nullable": true
              }
            ]
          },
          "name": {
            "type": "string",
            "maxLength": 100
          },
          "startDate": {
            "format": "date-time",
            "type": "string"
          },
          "endDate": {
            "format": "date-time",
            "type": "string"
          },
          "assessedCompetencesOnly": {
            "type": "boolean"
          },
          "showGradeRecommendation": {
            "type": "boolean"
          },
          "showCompetenceLevelDescriptions": {
            "type": "boolean"
          },
          "showNoteCompetences": {
            "type": "boolean"
          },
          "prefillData": {
            "type": "boolean"
          }
        }
      },
      "BaseReportResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/BaseReportDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "ReportDomainDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "symbol": {
            "type": "string"
          },
          "competences": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ReportCompetenceDto"
            }
          }
        },
        "required": [
          "id",
          "name",
          "symbol",
          "competences"
        ]
      },
      "ReportPerformanceAssessmentEntryDto": {
        "type": "object",
        "properties": {
          "gradeValue": {
            "type": "number",
            "nullable": true
          },
          "gradeLabel": {
            "type": "string",
            "nullable": true
          },
          "gradeName": {
            "type": "string",
            "nullable": true
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "level": {
            "type": "number",
            "nullable": true
          },
          "originalPictureId": {
            "type": "number",
            "nullable": true
          },
          "count": {
            "type": "number"
          },
          "isFrontendPicture": {
            "type": "boolean",
            "nullable": true
          },
          "picturePath": {
            "type": "string",
            "nullable": true
          },
          "pictureId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "gradeValue",
          "gradeLabel",
          "gradeName",
          "id",
          "createdAt",
          "updatedAt",
          "level",
          "originalPictureId",
          "count",
          "isFrontendPicture",
          "picturePath",
          "pictureId"
        ]
      },
      "ReportPerformanceAssessmentDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "order": {
            "type": "number"
          },
          "symbol": {
            "type": "string"
          },
          "entries": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ReportPerformanceAssessmentEntryDto"
            }
          }
        },
        "required": [
          "id",
          "createdAt",
          "updatedAt",
          "name",
          "order",
          "symbol",
          "entries"
        ]
      },
      "ReportNoteCompetenceDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "competenceDescription": {
            "type": "string"
          },
          "competenceDomainSymbol": {
            "type": "string"
          }
        },
        "required": [
          "id",
          "competenceDescription",
          "competenceDomainSymbol"
        ]
      },
      "ReportNoteDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "date": {
            "format": "date-time",
            "type": "string"
          },
          "text": {
            "type": "string"
          },
          "competences": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ReportNoteCompetenceDto"
            }
          }
        },
        "required": [
          "id",
          "date",
          "text",
          "competences"
        ]
      },
      "ReportSubjectDto": {
        "type": "object",
        "properties": {
          "status": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReportStatus"
              }
            ]
          },
          "grade": {
            "type": "number",
            "nullable": true
          },
          "exactGrade": {
            "type": "number",
            "nullable": true
          },
          "gradeLabel": {
            "type": "string",
            "nullable": true
          },
          "id": {
            "type": "number"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "domains": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ReportDomainDto"
            }
          },
          "order": {
            "type": "number"
          },
          "subjectAbbreviation": {
            "type": "string"
          },
          "subjectColor": {
            "type": "string"
          },
          "subjectId": {
            "type": "number",
            "nullable": true
          },
          "subjectName": {
            "type": "string"
          },
          "performanceAssessments": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ReportPerformanceAssessmentDto"
            }
          },
          "notes": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ReportNoteDto"
            }
          },
          "completedBy": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserDataDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "originalSubjectId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "status",
          "grade",
          "exactGrade",
          "gradeLabel",
          "id",
          "comment",
          "domains",
          "order",
          "subjectAbbreviation",
          "subjectColor",
          "subjectId",
          "subjectName",
          "performanceAssessments",
          "notes",
          "completedBy",
          "originalSubjectId"
        ]
      },
      "BaseSchoolClassDto": {
        "type": "object",
        "properties": {
          "type": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SchoolClassType"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "creatorId": {
            "type": "number",
            "nullable": true
          },
          "isActive": {
            "type": "boolean"
          },
          "isOnboardingFinalized": {
            "type": "boolean"
          },
          "isAssessmentTypeOnboardingFinalized": {
            "type": "boolean"
          },
          "isStudentOnboardingFinalized": {
            "type": "boolean"
          },
          "isTemplate": {
            "type": "boolean"
          },
          "name": {
            "type": "string"
          },
          "nickname": {
            "type": "string",
            "nullable": true
          },
          "originId": {
            "type": "number"
          },
          "schoolLevel": {
            "type": "number"
          },
          "schoolYearId": {
            "type": "number",
            "nullable": true
          },
          "tenantId": {
            "type": "number",
            "nullable": true
          },
          "year": {
            "type": "number"
          },
          "archivedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "finalNote": {
            "type": "string",
            "nullable": true
          },
          "isSchoolYearOverBannerDismissed": {
            "type": "boolean"
          },
          "baseClassId": {
            "type": "number",
            "nullable": true
          },
          "isDemoClass": {
            "type": "boolean"
          },
          "schoolYear": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BaseSchoolYearDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "appearance": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/EntityAppearanceDto"
              },
              {
                "nullable": true
              }
            ]
          }
        },
        "required": [
          "type",
          "id",
          "createdAt",
          "updatedAt",
          "creatorId",
          "isActive",
          "isOnboardingFinalized",
          "isAssessmentTypeOnboardingFinalized",
          "isStudentOnboardingFinalized",
          "isTemplate",
          "name",
          "nickname",
          "originId",
          "schoolLevel",
          "schoolYearId",
          "tenantId",
          "year",
          "archivedAt",
          "finalNote",
          "isSchoolYearOverBannerDismissed",
          "baseClassId",
          "isDemoClass",
          "schoolYear",
          "appearance"
        ]
      },
      "CompetenceAssessmentLevelTextDto": {
        "type": "object",
        "properties": {
          "key": {
            "type": "string",
            "nullable": true
          },
          "title": {
            "type": "string",
            "nullable": true
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "level": {
            "type": "number"
          },
          "isCustomized": {
            "type": "boolean"
          }
        },
        "required": [
          "key",
          "title",
          "description",
          "level",
          "isCustomized"
        ]
      },
      "CompetenceAssessmentDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "originId": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "schoolLevel": {
            "type": "number"
          },
          "isTemplate": {
            "type": "boolean"
          },
          "tenantId": {
            "type": "number",
            "nullable": true
          },
          "schoolClassId": {
            "type": "number",
            "nullable": true
          },
          "performanceVisualId": {
            "type": "number"
          },
          "performanceVisual": {
            "$ref": "#/components/schemas/PerformanceVisualDto"
          },
          "isOfficial": {
            "type": "boolean"
          },
          "hasObservations": {
            "type": "boolean"
          },
          "performanceLevelTexts": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CompetenceAssessmentLevelTextDto"
            }
          }
        },
        "required": [
          "id",
          "originId",
          "createdAt",
          "updatedAt",
          "schoolLevel",
          "isTemplate",
          "tenantId",
          "schoolClassId",
          "performanceVisualId",
          "performanceVisual",
          "isOfficial",
          "hasObservations",
          "performanceLevelTexts"
        ]
      },
      "ReportCompetenceLevelTextDto": {
        "type": "object",
        "properties": {
          "key": {
            "type": "string",
            "nullable": true
          },
          "title": {
            "type": "string",
            "nullable": true
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "picturePath": {
            "type": "string",
            "nullable": true
          },
          "pictureId": {
            "type": "number",
            "nullable": true
          },
          "level": {
            "type": "number"
          },
          "isCustomized": {
            "type": "boolean"
          }
        },
        "required": [
          "key",
          "title",
          "description",
          "picturePath",
          "pictureId",
          "level",
          "isCustomized"
        ]
      },
      "ReportDto": {
        "type": "object",
        "properties": {
          "status": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReportStatus"
              }
            ]
          },
          "type": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReportType"
              }
            ]
          },
          "calculationMethod": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/CalculationMethod"
              },
              {
                "nullable": true
              }
            ]
          },
          "summarySheet": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReportSummarySheet"
              },
              {
                "nullable": true
              }
            ]
          },
          "competenceType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReportCompetenceType"
              },
              {
                "nullable": true
              }
            ]
          },
          "coverSheet": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReportCoverSheet"
              },
              {
                "nullable": true
              }
            ]
          },
          "schoolTerm": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SchoolTermSemester"
              },
              {
                "nullable": true
              }
            ]
          },
          "performanceVisualName": {
            "type": "string"
          },
          "performanceVisualLevel": {
            "type": "number"
          },
          "summaryComment": {
            "type": "string",
            "nullable": true
          },
          "subjects": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ReportSubjectDto"
            }
          },
          "notesWithoutSubject": {
            "description": "Notes reports only: the notes without a subject",
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ReportNoteDto"
            }
          },
          "createdBy": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserDataDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "schoolClassId": {
            "type": "number"
          },
          "schoolClass": {
            "$ref": "#/components/schemas/BaseSchoolClassDto"
          },
          "competenceAssessment": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/CompetenceAssessmentDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "competenceLevelTexts": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ReportCompetenceLevelTextDto"
            }
          },
          "tenantStreet": {
            "type": "string",
            "nullable": true
          },
          "tenantZipCode": {
            "type": "string",
            "nullable": true
          },
          "tenantCity": {
            "type": "string",
            "nullable": true
          },
          "tenantName": {
            "type": "string",
            "nullable": true
          },
          "tenantSlogan": {
            "type": "string",
            "nullable": true
          },
          "tenantNameOfSchoolAdministration": {
            "type": "string",
            "nullable": true
          },
          "createdByFirstName": {
            "type": "string",
            "nullable": true
          },
          "createdByLastName": {
            "type": "string",
            "nullable": true
          },
          "coverLogoId": {
            "type": "number",
            "nullable": true
          },
          "coverImageId": {
            "type": "number",
            "nullable": true,
            "description": "Uploaded cover picture, resolved through the generic file endpoint."
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "tenantId": {
            "type": "number"
          },
          "id": {
            "type": "number"
          },
          "groupId": {
            "type": "number",
            "nullable": true
          },
          "name": {
            "type": "string"
          },
          "startDate": {
            "format": "date-time",
            "type": "string"
          },
          "endDate": {
            "format": "date-time",
            "type": "string"
          },
          "prefillData": {
            "type": "boolean"
          },
          "competenceAssessmentId": {
            "type": "number",
            "nullable": true
          },
          "originalStudentId": {
            "type": "number",
            "nullable": true
          },
          "studentFirstName": {
            "type": "string"
          },
          "studentLastName": {
            "type": "string"
          },
          "studentAvatar": {
            "type": "string",
            "nullable": true
          },
          "studentAvatarPictureId": {
            "type": "number",
            "nullable": true,
            "description": "File id of the snapshotted student avatar picture; resolve the signed url via GET /files/:id/url"
          },
          "completedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "accessibleSubjectCount": {
            "type": "number",
            "nullable": true
          },
          "assessedCompetencesOnly": {
            "type": "boolean"
          },
          "showGradeRecommendation": {
            "type": "boolean"
          },
          "showCompetenceLevelDescriptions": {
            "type": "boolean"
          },
          "showNoteCompetences": {
            "type": "boolean"
          }
        },
        "required": [
          "status",
          "type",
          "competenceType",
          "performanceVisualName",
          "performanceVisualLevel",
          "summaryComment",
          "subjects",
          "notesWithoutSubject",
          "createdBy",
          "schoolClassId",
          "schoolClass",
          "competenceAssessment",
          "competenceLevelTexts",
          "createdAt",
          "updatedAt",
          "tenantId",
          "id",
          "groupId",
          "name",
          "startDate",
          "endDate",
          "prefillData",
          "competenceAssessmentId",
          "originalStudentId",
          "studentFirstName",
          "studentLastName",
          "studentAvatar",
          "studentAvatarPictureId",
          "completedAt",
          "accessibleSubjectCount",
          "assessedCompetencesOnly",
          "showGradeRecommendation",
          "showCompetenceLevelDescriptions",
          "showNoteCompetences"
        ]
      },
      "ReportResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/ReportDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "PaginatedReportResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/BaseReportDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "UpdateReportGeneralCommentDto": {
        "type": "object",
        "properties": {
          "comment": {
            "type": "string",
            "maxLength": 1200
          }
        },
        "required": [
          "comment"
        ]
      },
      "UpdateReportSubjectDto": {
        "type": "object",
        "properties": {
          "status": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReportStatus"
              }
            ]
          },
          "comment": {
            "type": "string",
            "maxLength": 1000
          },
          "order": {
            "type": "number",
            "minimum": 0
          }
        }
      },
      "EPdfActionMode": {
        "type": "string",
        "enum": [
          "print",
          "download"
        ]
      },
      "BulkPdfGenerationDto": {
        "type": "object",
        "properties": {
          "mode": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/EPdfActionMode"
              }
            ]
          },
          "reportIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "mode",
          "reportIds"
        ]
      },
      "GetObservedSubjectIdsDto": {
        "type": "object",
        "properties": {
          "startDate": {
            "type": "string",
            "nullable": true
          },
          "endDate": {
            "type": "string",
            "nullable": true
          },
          "studentIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "schoolClassId": {
            "type": "number"
          }
        },
        "required": [
          "studentIds",
          "schoolClassId"
        ]
      },
      "ObservedSubjectIdsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "NoteSubjectIdsDto": {
        "type": "object",
        "properties": {
          "subjectIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "hasNotesWithoutSubject": {
            "type": "boolean"
          }
        },
        "required": [
          "subjectIds",
          "hasNotesWithoutSubject"
        ]
      },
      "NoteSubjectIdsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/NoteSubjectIdsDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "EReportDataStatus": {
        "type": "string",
        "enum": [
          "reportable",
          "unratedOnly",
          "noEntries",
          "noStudentsInClass",
          "noSubjectsInClass"
        ]
      },
      "ReportDataStatusResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/EReportDataStatus"
              }
            ]
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "ReportCreationIntervalDto": {
        "type": "object",
        "properties": {
          "from": {
            "type": "string",
            "format": "date",
            "example": "2024-11-01"
          },
          "to": {
            "type": "string",
            "format": "date",
            "example": "2026-07-22"
          }
        },
        "required": [
          "from",
          "to"
        ]
      },
      "ReportCreationIntervalResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/ReportCreationIntervalDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "CreateReportGroupDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          }
        },
        "required": [
          "name"
        ]
      },
      "ReportGroupDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "createdById": {
            "type": "number",
            "nullable": true
          },
          "tenantId": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "schoolClassId": {
            "type": "number"
          }
        },
        "required": [
          "id",
          "createdAt",
          "updatedAt",
          "createdById",
          "tenantId",
          "name",
          "schoolClassId"
        ]
      },
      "ReportGroupResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/ReportGroupDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "AssignReportsToGroupDto": {
        "type": "object",
        "properties": {
          "reportIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "reportIds"
        ]
      },
      "PaginatedReportGroupResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ReportGroupDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "PaginatedStateResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/StateDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "CreateStateDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          },
          "countryId": {
            "type": "number"
          },
          "parentStateId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "name",
          "countryId"
        ]
      },
      "StateResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/StateDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateStateDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          },
          "parentStateId": {
            "type": "number",
            "nullable": true
          }
        }
      },
      "SchoolSubjectTypeDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "key": {
            "type": "string"
          },
          "label": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "id",
          "createdAt",
          "updatedAt",
          "key",
          "label",
          "description"
        ]
      },
      "PaginatedSchoolSubjectTypeResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolSubjectTypeDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "CreateSchoolSubjectTypeDto": {
        "type": "object",
        "properties": {
          "key": {
            "type": "string"
          },
          "label": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "key",
          "label"
        ]
      },
      "SchoolSubjectTypeResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/SchoolSubjectTypeDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateSchoolSubjectTypeDto": {
        "type": "object",
        "properties": {
          "key": {
            "type": "string"
          },
          "label": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "nullable": true
          }
        }
      },
      "ClassifySchoolSubjectsDto": {
        "type": "object",
        "properties": {
          "schoolSubjectIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "schoolSubjectIds"
        ]
      },
      "ClassifyMaterialsResultDto": {
        "type": "object",
        "properties": {
          "total": {
            "type": "number"
          }
        },
        "required": [
          "total"
        ]
      },
      "ClassifyMaterialsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/ClassifyMaterialsResultDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "ClassifyExternalMaterialsDto": {
        "type": "object",
        "properties": {
          "externalMaterialIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "externalMaterialIds"
        ]
      },
      "CreateCustomExternalMaterialDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "maxLength": 255
          }
        },
        "required": [
          "name"
        ]
      },
      "ExternalMaterialSubjectTypeRefDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "key": {
            "type": "string"
          },
          "label": {
            "type": "string"
          }
        },
        "required": [
          "id",
          "key",
          "label"
        ]
      },
      "RecommendedExternalMaterialDto": {
        "type": "object",
        "properties": {
          "previouslyUsed": {
            "type": "boolean"
          },
          "matchesSchoolLevel": {
            "type": "boolean"
          },
          "lastUsedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "externalId": {
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "logoId": {
            "type": "number",
            "nullable": true
          },
          "logoUrl": {
            "type": "string",
            "nullable": true
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "subjectSource": {
            "type": "string",
            "nullable": true
          },
          "schoolLevels": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "countryIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "languageIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "isFree": {
            "type": "boolean"
          },
          "licenseInfo": {
            "type": "string",
            "nullable": true
          },
          "isVerified": {
            "type": "boolean"
          },
          "source": {
            "type": "string",
            "nullable": true
          },
          "sourceUrl": {
            "type": "string",
            "nullable": true
          },
          "searchTerms": {
            "type": "string",
            "nullable": true
          },
          "isVisible": {
            "type": "boolean"
          },
          "premium": {
            "type": "boolean"
          },
          "usageCount": {
            "type": "number"
          },
          "isOfficial": {
            "type": "boolean"
          },
          "types": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ExternalMaterialSubjectTypeRefDto"
            }
          }
        },
        "required": [
          "previouslyUsed",
          "matchesSchoolLevel",
          "lastUsedAt",
          "id",
          "createdAt",
          "updatedAt",
          "externalId",
          "name",
          "logoId",
          "logoUrl",
          "description",
          "subjectSource",
          "schoolLevels",
          "countryIds",
          "languageIds",
          "isFree",
          "licenseInfo",
          "isVerified",
          "source",
          "sourceUrl",
          "searchTerms",
          "isVisible",
          "premium",
          "usageCount",
          "isOfficial",
          "types"
        ]
      },
      "CustomExternalMaterialResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/RecommendedExternalMaterialDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "ExternalMaterialDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "externalId": {
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "logoId": {
            "type": "number",
            "nullable": true
          },
          "logoUrl": {
            "type": "string",
            "nullable": true
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "subjectSource": {
            "type": "string",
            "nullable": true
          },
          "schoolLevels": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "countryIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "languageIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "isFree": {
            "type": "boolean"
          },
          "licenseInfo": {
            "type": "string",
            "nullable": true
          },
          "isVerified": {
            "type": "boolean"
          },
          "source": {
            "type": "string",
            "nullable": true
          },
          "sourceUrl": {
            "type": "string",
            "nullable": true
          },
          "searchTerms": {
            "type": "string",
            "nullable": true
          },
          "isVisible": {
            "type": "boolean"
          },
          "premium": {
            "type": "boolean"
          },
          "usageCount": {
            "type": "number"
          },
          "isOfficial": {
            "type": "boolean"
          },
          "types": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ExternalMaterialSubjectTypeRefDto"
            }
          }
        },
        "required": [
          "id",
          "createdAt",
          "updatedAt",
          "externalId",
          "name",
          "logoId",
          "logoUrl",
          "description",
          "subjectSource",
          "schoolLevels",
          "countryIds",
          "languageIds",
          "isFree",
          "licenseInfo",
          "isVerified",
          "source",
          "sourceUrl",
          "searchTerms",
          "isVisible",
          "premium",
          "usageCount",
          "isOfficial",
          "types"
        ]
      },
      "PaginatedExternalMaterialResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ExternalMaterialDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "CreateExternalMaterialDto": {
        "type": "object",
        "properties": {
          "externalId": {
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "logoUrl": {
            "type": "string",
            "nullable": true
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "subjectSource": {
            "type": "string",
            "nullable": true
          },
          "schoolLevels": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "countryIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "languageIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "isFree": {
            "type": "boolean"
          },
          "licenseInfo": {
            "type": "string",
            "nullable": true
          },
          "isVerified": {
            "type": "boolean"
          },
          "source": {
            "type": "string",
            "nullable": true
          },
          "sourceUrl": {
            "type": "string",
            "nullable": true,
            "format": "uri"
          },
          "searchTerms": {
            "type": "string",
            "nullable": true
          },
          "isVisible": {
            "type": "boolean"
          },
          "premium": {
            "type": "boolean"
          },
          "schoolSubjectTypeIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "externalId",
          "name"
        ]
      },
      "ExternalMaterialResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/ExternalMaterialDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateExternalMaterialDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          },
          "logoUrl": {
            "type": "string",
            "nullable": true
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "subjectSource": {
            "type": "string",
            "nullable": true
          },
          "schoolLevels": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "countryIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "languageIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "isFree": {
            "type": "boolean"
          },
          "licenseInfo": {
            "type": "string",
            "nullable": true
          },
          "isVerified": {
            "type": "boolean"
          },
          "source": {
            "type": "string",
            "nullable": true
          },
          "sourceUrl": {
            "type": "string",
            "nullable": true,
            "format": "uri"
          },
          "searchTerms": {
            "type": "string",
            "nullable": true
          },
          "isVisible": {
            "type": "boolean"
          },
          "premium": {
            "type": "boolean"
          },
          "schoolSubjectTypeIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        }
      },
      "ExternalMaterialImportResultDto": {
        "type": "object",
        "properties": {
          "total": {
            "type": "number"
          }
        },
        "required": [
          "total"
        ]
      },
      "ExternalMaterialImportResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/ExternalMaterialImportResultDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "ExternalMaterialRecommendationsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/RecommendedExternalMaterialDto"
            }
          }
        },
        "required": [
          "success",
          "rows"
        ]
      },
      "SchoolTypeTranslationDto": {
        "type": "object",
        "properties": {
          "languageId": {
            "type": "number"
          },
          "name": {
            "type": "string"
          }
        },
        "required": [
          "languageId",
          "name"
        ]
      },
      "SchoolTypeDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "abbreviation": {
            "type": "string",
            "nullable": true
          },
          "symbol": {
            "type": "string"
          },
          "color": {
            "type": "string"
          },
          "countryId": {
            "type": "number"
          },
          "schoolLevels": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "isOfficial": {
            "type": "boolean"
          },
          "translations": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolTypeTranslationDto"
            }
          }
        },
        "required": [
          "id",
          "createdAt",
          "updatedAt",
          "name",
          "abbreviation",
          "symbol",
          "color",
          "countryId",
          "schoolLevels",
          "isOfficial",
          "translations"
        ]
      },
      "PaginatedSchoolTypeResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolTypeDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "SchoolTypeTranslationInputDto": {
        "type": "object",
        "properties": {
          "languageId": {
            "type": "number"
          },
          "name": {
            "type": "string"
          }
        },
        "required": [
          "languageId",
          "name"
        ]
      },
      "CreateSchoolTypeDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          },
          "abbreviation": {
            "type": "string",
            "nullable": true
          },
          "countryId": {
            "type": "number"
          },
          "schoolLevels": {
            "uniqueItems": true,
            "type": "array",
            "items": {
              "type": "number",
              "minimum": 0
            }
          },
          "symbol": {
            "type": "string"
          },
          "color": {
            "type": "string",
            "pattern": "^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$"
          },
          "translations": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolTypeTranslationInputDto"
            }
          }
        },
        "required": [
          "name",
          "countryId",
          "schoolLevels"
        ]
      },
      "SchoolTypeResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/SchoolTypeDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateSchoolTypeDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          },
          "abbreviation": {
            "type": "string",
            "nullable": true
          },
          "schoolLevels": {
            "uniqueItems": true,
            "type": "array",
            "items": {
              "type": "number",
              "minimum": 0
            }
          },
          "symbol": {
            "type": "string"
          },
          "color": {
            "type": "string",
            "pattern": "^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$"
          },
          "translations": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolTypeTranslationInputDto"
            }
          }
        }
      },
      "MoveSchoolSubjectTemplatesDto": {
        "type": "object",
        "properties": {
          "schoolSubjectIds": {
            "minItems": 1,
            "uniqueItems": true,
            "type": "array",
            "items": {
              "type": "number",
              "minimum": 1
            }
          },
          "targetSchoolLevel": {
            "type": "number"
          },
          "targetGroupId": {
            "type": "number",
            "nullable": true,
            "minimum": 1
          },
          "targetOrder": {
            "type": "number",
            "description": "Places the subjects before the first destination subject with this order or a higher one; without it they are appended.",
            "minimum": 0
          }
        },
        "required": [
          "schoolSubjectIds",
          "targetSchoolLevel",
          "targetGroupId"
        ]
      },
      "CreateSchoolSubjectGroupDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          },
          "schoolLevel": {
            "type": "number"
          }
        },
        "required": [
          "name",
          "schoolLevel"
        ]
      },
      "SchoolSubjectGroupResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/SchoolSubjectGroupDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "PaginatedSchoolSubjectGroupResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolSubjectGroupDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "UpdateSchoolSubjectGroupDto": {
        "type": "object",
        "properties": {
          "order": {
            "type": "number"
          },
          "name": {
            "type": "string"
          }
        },
        "required": [
          "name"
        ]
      },
      "AssignSubjectDto": {
        "type": "object",
        "properties": {
          "subjectId": {
            "type": "number"
          },
          "order": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "subjectId"
        ]
      },
      "UnassignSubjectDto": {
        "type": "object",
        "properties": {
          "subjectId": {
            "type": "number"
          },
          "order": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "subjectId"
        ]
      },
      "ReorderUnassignedSubjectDto": {
        "type": "object",
        "properties": {
          "subjectId": {
            "type": "number"
          },
          "order": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "subjectId"
        ]
      },
      "CreateSchoolSubjectGroupProviderDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          },
          "schoolLevel": {
            "type": "number"
          },
          "templateSetId": {
            "type": "number"
          },
          "order": {
            "type": "number"
          }
        },
        "required": [
          "name",
          "schoolLevel",
          "templateSetId",
          "order"
        ]
      },
      "PaginatedCompetenceAssessmentResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CompetenceAssessmentDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "ChangeCompetenceAssessmentVisualDto": {
        "type": "object",
        "properties": {
          "performanceVisualId": {
            "type": "number"
          }
        },
        "required": [
          "performanceVisualId"
        ]
      },
      "CompetenceAssessmentResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/CompetenceAssessmentDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateCompetenceAssessmentLevelTextDto": {
        "type": "object",
        "properties": {
          "title": {
            "type": "string",
            "nullable": true,
            "maxLength": 50
          },
          "description": {
            "type": "string",
            "nullable": true,
            "maxLength": 150
          },
          "level": {
            "type": "number",
            "minimum": 1
          },
          "isCustomized": {
            "type": "boolean"
          }
        },
        "required": [
          "title",
          "description",
          "level",
          "isCustomized"
        ]
      },
      "UpdateCompetenceAssessmentConfigurationDto": {
        "type": "object",
        "properties": {
          "performanceVisualId": {
            "type": "number"
          },
          "performanceLevelTexts": {
            "uniqueItems": true,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/UpdateCompetenceAssessmentLevelTextDto"
            }
          }
        },
        "required": [
          "performanceVisualId",
          "performanceLevelTexts"
        ]
      },
      "CreateCompetenceAssessmentDto": {
        "type": "object",
        "properties": {
          "schoolLevel": {
            "type": "number",
            "minimum": 0
          },
          "performanceVisualId": {
            "type": "number"
          },
          "isTemplate": {
            "type": "boolean"
          }
        },
        "required": [
          "schoolLevel",
          "performanceVisualId"
        ]
      },
      "UpdateCompetenceAssessmentDto": {
        "type": "object",
        "properties": {
          "schoolLevel": {
            "type": "number",
            "minimum": 0
          },
          "performanceVisualId": {
            "type": "number"
          }
        },
        "required": [
          "schoolLevel",
          "performanceVisualId"
        ]
      },
      "ExternalMaterialLinkDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "externalMaterialId": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "logoId": {
            "type": "number",
            "nullable": true
          },
          "logoUrl": {
            "type": "string",
            "nullable": true
          },
          "subjectSource": {
            "type": "string",
            "nullable": true
          },
          "sourceUrl": {
            "type": "string",
            "nullable": true
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "isVerified": {
            "type": "boolean"
          },
          "schoolLevels": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "isFree": {
            "type": "boolean"
          },
          "licenseInfo": {
            "type": "string",
            "nullable": true
          },
          "premium": {
            "type": "boolean"
          },
          "isOfficial": {
            "type": "boolean"
          }
        },
        "required": [
          "id",
          "createdAt",
          "externalMaterialId",
          "name",
          "logoId",
          "logoUrl",
          "subjectSource",
          "sourceUrl",
          "description",
          "isVerified",
          "schoolLevels",
          "isFree",
          "licenseInfo",
          "premium",
          "isOfficial"
        ]
      },
      "PerformanceAssessmentStudentEntryDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "creatorId": {
            "type": "number",
            "nullable": true
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "gradeValue": {
            "type": "number",
            "nullable": true
          },
          "performanceLevelV2Id": {
            "type": "number",
            "nullable": true
          },
          "studentId": {
            "type": "number"
          },
          "student": {
            "$ref": "#/components/schemas/BaseStudentDto"
          },
          "attachmentCount": {
            "type": "number"
          }
        },
        "required": [
          "id",
          "creatorId",
          "description",
          "gradeValue",
          "performanceLevelV2Id",
          "studentId",
          "student",
          "attachmentCount"
        ]
      },
      "PerformanceAssessmentEntryDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "creator": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserDataDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "lastEditor": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserDataDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "label": {
            "type": "string"
          },
          "date": {
            "format": "date-time",
            "type": "string"
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "gradeCalculationTagId": {
            "type": "number",
            "nullable": true
          },
          "gradeCalculationTag": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/GradeCalculationTagDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "schoolSubject": {
            "$ref": "#/components/schemas/BaseSchoolSubjectDto"
          },
          "performanceAssessment": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BasePerformanceAssessmentDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "schoolClassId": {
            "type": "number"
          },
          "materials": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ExternalMaterialLinkDto"
            }
          },
          "attachmentCount": {
            "type": "number"
          },
          "studentEntries": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/PerformanceAssessmentStudentEntryDto"
            }
          },
          "competenceObservations": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CompetenceObservationDto"
            }
          },
          "isCompleted": {
            "type": "boolean"
          },
          "ratedEntriesCount": {
            "type": "number"
          },
          "totalEntriesCount": {
            "type": "number"
          }
        },
        "required": [
          "id",
          "creator",
          "lastEditor",
          "createdAt",
          "updatedAt",
          "label",
          "date",
          "description",
          "gradeCalculationTagId",
          "gradeCalculationTag",
          "schoolSubject",
          "performanceAssessment",
          "schoolClassId",
          "materials",
          "attachmentCount",
          "studentEntries",
          "competenceObservations",
          "isCompleted",
          "ratedEntriesCount",
          "totalEntriesCount"
        ]
      },
      "PerformanceAssessmentEntryResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean"
          },
          "data": {
            "$ref": "#/components/schemas/PerformanceAssessmentEntryDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "CreatePerformanceAssessmentEntryCompetenceDetailDto": {
        "type": "object",
        "properties": {
          "competenceId": {
            "type": "number"
          },
          "description": {
            "type": "string",
            "maxLength": 2500
          },
          "performanceLevelV2Id": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "competenceId"
        ]
      },
      "CreatePerformanceAssessmentEntryStudentDetailDto": {
        "type": "object",
        "properties": {
          "gradeValue": {
            "type": "number",
            "nullable": true
          },
          "studentId": {
            "type": "number"
          },
          "description": {
            "type": "string",
            "maxLength": 2500
          },
          "performanceLevelV2Id": {
            "type": "number",
            "nullable": true
          },
          "competenceDetails": {
            "uniqueItems": true,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CreatePerformanceAssessmentEntryCompetenceDetailDto"
            }
          }
        },
        "required": [
          "studentId"
        ]
      },
      "CreatePerformanceAssessmentEntryDto": {
        "type": "object",
        "properties": {
          "studentToCompetenceMap": {
            "type": "object",
            "additionalProperties": {
              "type": "array",
              "items": {
                "type": "number"
              }
            }
          },
          "competenceIdToPerformanceLevelV2Id": {
            "type": "object",
            "additionalProperties": {
              "type": "number"
            }
          },
          "gradeValue": {
            "type": "number",
            "nullable": true
          },
          "schoolClassId": {
            "type": "number"
          },
          "label": {
            "type": "string"
          },
          "date": {
            "format": "date-time",
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 2500
          },
          "schoolSubjectId": {
            "type": "number"
          },
          "studentIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "competenceIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "performanceAssessmentId": {
            "type": "number"
          },
          "competenceAssessmentId": {
            "type": "number"
          },
          "gradeCalculationTagId": {
            "type": "number",
            "nullable": true
          },
          "performanceLevelV2Id": {
            "type": "number"
          },
          "studentDetails": {
            "uniqueItems": true,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CreatePerformanceAssessmentEntryStudentDetailDto"
            }
          }
        },
        "required": [
          "schoolClassId",
          "label",
          "date",
          "schoolSubjectId",
          "studentIds",
          "competenceIds",
          "performanceAssessmentId",
          "competenceAssessmentId"
        ]
      },
      "UpdatePerformanceAssessmentEntryDto": {
        "type": "object",
        "properties": {
          "externalMaterialIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "label": {
            "type": "string"
          },
          "date": {
            "format": "date-time",
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 2500
          },
          "gradeCalculationTagId": {
            "type": "number",
            "nullable": true
          }
        }
      },
      "AddCompetencesToEntryDto": {
        "type": "object",
        "properties": {
          "competenceIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "competenceAssessmentId": {
            "type": "number"
          },
          "studentIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "competenceIds",
          "competenceAssessmentId"
        ]
      },
      "SetPerformanceAssessmentEntryCompetencesDto": {
        "type": "object",
        "properties": {
          "competenceIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "competenceAssessmentId": {
            "type": "number"
          }
        },
        "required": [
          "competenceIds",
          "competenceAssessmentId"
        ]
      },
      "DuplicatePerformanceAssessmentEntryDto": {
        "type": "object",
        "properties": {
          "entryId": {
            "type": "number"
          },
          "studentIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "includeGradings": {
            "type": "boolean"
          }
        },
        "required": [
          "entryId",
          "studentIds"
        ]
      },
      "StartPerformanceAssessmentEntryPdfDto": {
        "type": "object",
        "properties": {
          "studentIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        }
      },
      "PerformanceAssessmentStudentEntryOverviewRowDto": {
        "type": "object",
        "properties": {
          "performanceAssessmentEntryId": {
            "type": "number"
          },
          "performanceAssessmentId": {
            "type": "number"
          },
          "studentId": {
            "type": "number"
          },
          "gradeValue": {
            "type": "number",
            "nullable": true
          },
          "performanceLevelV2Id": {
            "type": "number",
            "nullable": true
          },
          "competenceObservationPerformanceLevelV2Ids": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "date": {
            "format": "date-time",
            "type": "string"
          }
        },
        "required": [
          "performanceAssessmentEntryId",
          "performanceAssessmentId",
          "studentId",
          "gradeValue",
          "performanceLevelV2Id",
          "competenceObservationPerformanceLevelV2Ids",
          "date"
        ]
      },
      "PerformanceAssessmentStudentEntryOverviewResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/PerformanceAssessmentStudentEntryOverviewRowDto"
            }
          }
        },
        "required": [
          "success",
          "rows"
        ]
      },
      "CreatePerformanceAssessmentStudentEntryDto": {
        "type": "object",
        "properties": {
          "performanceAssessmentEntryId": {
            "type": "number"
          },
          "studentIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "performanceAssessmentEntryId",
          "studentIds"
        ]
      },
      "UpdatePerformanceAssessmentStudentEntryDto": {
        "type": "object",
        "properties": {
          "gradeValue": {
            "type": "number",
            "nullable": true
          },
          "description": {
            "type": "string",
            "maxLength": 2500
          },
          "performanceLevelV2Id": {
            "type": "number",
            "nullable": true
          }
        }
      },
      "PerformanceAssessmentStudentEntryWithObservationsDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "creatorId": {
            "type": "number",
            "nullable": true
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "gradeValue": {
            "type": "number",
            "nullable": true
          },
          "performanceLevelV2Id": {
            "type": "number",
            "nullable": true
          },
          "studentId": {
            "type": "number"
          },
          "student": {
            "$ref": "#/components/schemas/BaseStudentDto"
          },
          "attachmentCount": {
            "type": "number"
          },
          "competenceObservations": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CompetenceObservationDto"
            }
          }
        },
        "required": [
          "id",
          "creatorId",
          "description",
          "gradeValue",
          "performanceLevelV2Id",
          "studentId",
          "student",
          "attachmentCount",
          "competenceObservations"
        ]
      },
      "PerformanceAssessmentStudentEntryResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/PerformanceAssessmentStudentEntryWithObservationsDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "CreateNoteDto": {
        "type": "object",
        "properties": {
          "schoolClassId": {
            "type": "number"
          },
          "schoolSubjectId": {
            "type": "number"
          },
          "text": {
            "type": "string",
            "maxLength": 2500
          },
          "date": {
            "format": "date-time",
            "type": "string"
          },
          "studentIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "competenceIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "schoolClassId",
          "text",
          "studentIds",
          "competenceIds"
        ]
      },
      "NoteCompetenceDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "competenceId": {
            "type": "number"
          },
          "competenceDomainId": {
            "type": "number"
          },
          "description": {
            "type": "string"
          }
        },
        "required": [
          "id",
          "competenceId",
          "competenceDomainId",
          "description"
        ]
      },
      "NoteDto": {
        "type": "object",
        "properties": {
          "materials": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ExternalMaterialLinkDto"
            }
          },
          "attachmentCount": {
            "type": "number"
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "date": {
            "format": "date-time",
            "type": "string"
          },
          "text": {
            "type": "string"
          },
          "schoolClassId": {
            "type": "number"
          },
          "schoolSubject": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BaseSchoolSubjectDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "creator": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserDataDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "lastEditor": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserDataDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "students": {
            "description": "recipient snapshot; empty = standalone class note, the \"whole class\" label is derived in the UI",
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/BaseStudentDto"
            }
          },
          "competences": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/NoteCompetenceDto"
            }
          }
        },
        "required": [
          "materials",
          "attachmentCount",
          "id",
          "createdAt",
          "updatedAt",
          "date",
          "text",
          "schoolClassId",
          "schoolSubject",
          "creator",
          "lastEditor",
          "students",
          "competences"
        ]
      },
      "NoteResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/NoteDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateNoteDto": {
        "type": "object",
        "properties": {
          "externalMaterialIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "schoolSubjectId": {
            "type": "number",
            "nullable": true
          },
          "text": {
            "type": "string",
            "maxLength": 2500
          },
          "date": {
            "format": "date-time",
            "type": "string"
          },
          "studentIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "competenceIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        }
      },
      "ObservationTimelineEntryType": {
        "type": "string",
        "enum": [
          "performanceAssessmentEntry",
          "note",
          "supportMeasureEntry"
        ]
      },
      "ObservationTimelineStatsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "performanceAssessmentIdToCountMap": {
            "type": "object",
            "additionalProperties": {
              "type": "number"
            }
          },
          "totalCount": {
            "type": "number"
          },
          "noteCount": {
            "type": "number"
          },
          "performanceAssessmentEntryCount": {
            "type": "number"
          },
          "incompleteCount": {
            "type": "number"
          },
          "supportMeasureEntryCount": {
            "type": "number"
          },
          "activeSupportMeasureEntryCount": {
            "type": "number"
          },
          "filteredIncompleteCount": {
            "type": "number"
          },
          "filteredActiveSupportMeasureEntryCount": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "performanceAssessmentIdToCountMap",
          "totalCount",
          "noteCount",
          "performanceAssessmentEntryCount",
          "incompleteCount",
          "supportMeasureEntryCount",
          "activeSupportMeasureEntryCount",
          "filteredIncompleteCount",
          "filteredActiveSupportMeasureEntryCount"
        ]
      },
      "TimelineSchoolSubjectDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "abbreviation": {
            "type": "string"
          },
          "color": {
            "type": "string"
          }
        },
        "required": [
          "id",
          "name",
          "abbreviation",
          "color"
        ]
      },
      "TimelineStudentDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "firstName": {
            "type": "string"
          },
          "lastName": {
            "type": "string"
          },
          "avatar": {
            "type": "string",
            "nullable": true
          },
          "avatarPictureId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "id",
          "firstName",
          "lastName",
          "avatar",
          "avatarPictureId"
        ]
      },
      "TimelineCompetenceDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "description": {
            "type": "string"
          },
          "domainSymbol": {
            "type": "string"
          },
          "performanceLevel": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/PerformanceLevelV2Dto"
              },
              {
                "nullable": true
              }
            ]
          }
        },
        "required": [
          "id",
          "description",
          "domainSymbol",
          "performanceLevel"
        ]
      },
      "TimelineAssessmentSummaryDto": {
        "type": "object",
        "properties": {
          "documentationMode": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/PerformanceAssessmentDocumentationMode"
              }
            ]
          },
          "attachmentCount": {
            "type": "number"
          },
          "materials": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ExternalMaterialLinkDto"
            }
          },
          "studentEntryId": {
            "type": "number",
            "nullable": true
          },
          "studentAttachmentCount": {
            "type": "number"
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "date": {
            "format": "date-time",
            "type": "string"
          },
          "label": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "schoolClassId": {
            "type": "number"
          },
          "schoolSubject": {
            "$ref": "#/components/schemas/TimelineSchoolSubjectDto"
          },
          "performanceAssessmentId": {
            "type": "number",
            "nullable": true
          },
          "students": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/TimelineStudentDto"
            }
          },
          "competences": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/TimelineCompetenceDto"
            }
          },
          "openCount": {
            "type": "number"
          },
          "totalCount": {
            "type": "number"
          },
          "hasOverallVisual": {
            "type": "boolean"
          },
          "gradeValue": {
            "type": "number",
            "nullable": true
          },
          "studentDescription": {
            "type": "string",
            "nullable": true
          },
          "performanceLevel": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/PerformanceLevelV2Dto"
              },
              {
                "nullable": true
              }
            ]
          }
        },
        "required": [
          "documentationMode",
          "attachmentCount",
          "materials",
          "studentEntryId",
          "studentAttachmentCount",
          "id",
          "createdAt",
          "date",
          "label",
          "description",
          "schoolClassId",
          "schoolSubject",
          "performanceAssessmentId",
          "students",
          "competences",
          "openCount",
          "totalCount",
          "hasOverallVisual",
          "gradeValue",
          "studentDescription",
          "performanceLevel"
        ]
      },
      "SupportMeasureEntryCompetenceDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "competenceId": {
            "type": "number"
          },
          "competenceDomainId": {
            "type": "number"
          },
          "description": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "id",
          "competenceId",
          "competenceDomainId",
          "description"
        ]
      },
      "SupportMeasureEntryMaterialDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "externalMaterialId": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "logoId": {
            "type": "number",
            "nullable": true
          },
          "logoUrl": {
            "type": "string",
            "nullable": true
          },
          "subjectSource": {
            "type": "string",
            "nullable": true
          },
          "sourceUrl": {
            "type": "string",
            "nullable": true
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "isVerified": {
            "type": "boolean"
          },
          "schoolLevels": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "isFree": {
            "type": "boolean"
          },
          "licenseInfo": {
            "type": "string",
            "nullable": true
          },
          "premium": {
            "type": "boolean"
          },
          "isOfficial": {
            "type": "boolean"
          }
        },
        "required": [
          "id",
          "createdAt",
          "externalMaterialId",
          "name",
          "logoId",
          "logoUrl",
          "subjectSource",
          "sourceUrl",
          "description",
          "isVerified",
          "schoolLevels",
          "isFree",
          "licenseInfo",
          "premium",
          "isOfficial"
        ]
      },
      "SupportMeasureTimelineEntryDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "completedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "schoolClassId": {
            "type": "number"
          },
          "schoolSubjectId": {
            "type": "number"
          },
          "schoolSubject": {
            "$ref": "#/components/schemas/BaseSchoolSubjectDto"
          },
          "students": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/BaseStudentDto"
            }
          },
          "competences": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SupportMeasureEntryCompetenceDto"
            }
          },
          "materials": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SupportMeasureEntryMaterialDto"
            }
          },
          "attachmentCount": {
            "type": "number"
          }
        },
        "required": [
          "id",
          "createdAt",
          "updatedAt",
          "description",
          "completedAt",
          "schoolClassId",
          "schoolSubjectId",
          "schoolSubject",
          "students",
          "competences",
          "materials",
          "attachmentCount"
        ]
      },
      "ObservationTimelineSummaryDto": {
        "type": "object",
        "properties": {
          "type": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ObservationTimelineEntryType"
              }
            ]
          },
          "performanceAssessmentEntry": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/TimelineAssessmentSummaryDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "note": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/NoteDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "supportMeasureEntry": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SupportMeasureTimelineEntryDto"
              },
              {
                "nullable": true
              }
            ]
          }
        },
        "required": [
          "type",
          "performanceAssessmentEntry",
          "note",
          "supportMeasureEntry"
        ]
      },
      "PaginatedObservationTimelineSummaryResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "count": {
            "type": "number"
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ObservationTimelineSummaryDto"
            }
          }
        },
        "required": [
          "success",
          "count",
          "rows"
        ]
      },
      "ObservationTimelineEntryResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/ObservationTimelineSummaryDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "CreateSupportMeasureEntryDto": {
        "type": "object",
        "properties": {
          "schoolClassId": {
            "type": "number"
          },
          "schoolSubjectId": {
            "type": "number"
          },
          "description": {
            "type": "string",
            "maxLength": 2000
          },
          "studentIds": {
            "minItems": 1,
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "competenceIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "externalMaterialIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "schoolClassId",
          "schoolSubjectId",
          "studentIds",
          "competenceIds"
        ]
      },
      "SupportMeasureProtocolEntryRating": {
        "type": "string",
        "enum": [
          "positive",
          "negative"
        ]
      },
      "SupportMeasureProtocolEntryCompetenceDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "competenceId": {
            "type": "number"
          },
          "competenceDomainId": {
            "type": "number"
          },
          "description": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "id",
          "competenceId",
          "competenceDomainId",
          "description"
        ]
      },
      "BaseCompetenceObservationDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "competenceId": {
            "type": "number"
          },
          "schoolClassId": {
            "type": "number"
          },
          "studentId": {
            "type": "number"
          },
          "observedAt": {
            "format": "date-time",
            "type": "string"
          },
          "description": {
            "type": "string"
          },
          "competenceAssessmentId": {
            "type": "number"
          },
          "performanceLevelV2Id": {
            "type": "number",
            "nullable": true
          },
          "performanceAssessmentEntryId": {
            "type": "number",
            "nullable": true
          },
          "supportMeasureProtocolEntryId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "id",
          "createdAt",
          "updatedAt",
          "competenceId",
          "schoolClassId",
          "studentId",
          "observedAt",
          "description",
          "competenceAssessmentId",
          "performanceLevelV2Id",
          "performanceAssessmentEntryId",
          "supportMeasureProtocolEntryId"
        ]
      },
      "SupportMeasureProtocolEntryDto": {
        "type": "object",
        "properties": {
          "rating": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SupportMeasureProtocolEntryRating"
              },
              {
                "nullable": true
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "date": {
            "format": "date-time",
            "type": "string"
          },
          "text": {
            "type": "string"
          },
          "creator": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserDataDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "students": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/BaseStudentDto"
            }
          },
          "competences": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SupportMeasureProtocolEntryCompetenceDto"
            }
          },
          "materials": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SupportMeasureEntryMaterialDto"
            }
          },
          "attachmentCount": {
            "type": "number"
          },
          "competenceObservations": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/BaseCompetenceObservationDto"
            }
          }
        },
        "required": [
          "rating",
          "id",
          "createdAt",
          "updatedAt",
          "date",
          "text",
          "creator",
          "students",
          "competences",
          "materials",
          "attachmentCount",
          "competenceObservations"
        ]
      },
      "SupportMeasureActivityType": {
        "type": "string",
        "enum": [
          "studentAdded",
          "studentRemoved",
          "studentEntriesRemoved",
          "competenceAdded",
          "competenceRemoved",
          "protocolEntryAdded",
          "protocolEntryRemoved",
          "materialAdded",
          "materialRemoved"
        ]
      },
      "SupportMeasureEntryActivityDto": {
        "type": "object",
        "properties": {
          "type": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SupportMeasureActivityType"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "date": {
            "format": "date-time",
            "type": "string"
          },
          "studentId": {
            "type": "number",
            "nullable": true
          },
          "student": {
            "description": "The targeted student — sent along because they may no longer be a member of the class or the entry.",
            "oneOf": [
              {
                "$ref": "#/components/schemas/BaseStudentDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "competenceId": {
            "type": "number",
            "nullable": true
          },
          "protocolEntryId": {
            "type": "number",
            "nullable": true
          },
          "groupId": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "type",
          "id",
          "createdAt",
          "date",
          "studentId",
          "student",
          "competenceId",
          "protocolEntryId",
          "groupId"
        ]
      },
      "SupportMeasureEntryDto": {
        "type": "object",
        "properties": {
          "students": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/BaseStudentDto"
            }
          },
          "competences": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SupportMeasureEntryCompetenceDto"
            }
          },
          "materials": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SupportMeasureEntryMaterialDto"
            }
          },
          "attachmentCount": {
            "type": "number"
          },
          "protocol": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SupportMeasureProtocolEntryDto"
            }
          },
          "activities": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SupportMeasureEntryActivityDto"
            }
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "completedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "completionNote": {
            "type": "string",
            "nullable": true
          },
          "completionRating": {
            "type": "number",
            "nullable": true
          },
          "completedBy": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserDataDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "creator": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserDataDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "lastEditedBy": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserDataDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "schoolClassId": {
            "type": "number"
          },
          "schoolSubjectId": {
            "type": "number"
          },
          "schoolSubject": {
            "$ref": "#/components/schemas/BaseSchoolSubjectDto"
          }
        },
        "required": [
          "students",
          "competences",
          "materials",
          "attachmentCount",
          "protocol",
          "activities",
          "id",
          "createdAt",
          "updatedAt",
          "description",
          "completedAt",
          "completionNote",
          "completionRating",
          "completedBy",
          "creator",
          "lastEditedBy",
          "schoolClassId",
          "schoolSubjectId",
          "schoolSubject"
        ]
      },
      "SupportMeasureEntryResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/SupportMeasureEntryDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "SupportMeasureFilterStudentDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "firstName": {
            "type": "string"
          },
          "lastName": {
            "type": "string"
          },
          "avatar": {
            "type": "string",
            "nullable": true
          },
          "avatarPictureId": {
            "type": "number",
            "nullable": true,
            "description": "File id of the uploaded avatar picture; resolve the signed url via GET /files/:id/url"
          },
          "isRemoved": {
            "type": "boolean"
          }
        },
        "required": [
          "id",
          "createdAt",
          "updatedAt",
          "firstName",
          "lastName",
          "avatarPictureId",
          "isRemoved"
        ]
      },
      "SupportMeasureFilterStudentsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SupportMeasureFilterStudentDto"
            }
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateSupportMeasureEntryDto": {
        "type": "object",
        "properties": {
          "description": {
            "type": "string",
            "nullable": true,
            "maxLength": 2000
          },
          "completedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "completionNote": {
            "type": "string",
            "nullable": true,
            "maxLength": 1000
          },
          "completionRating": {
            "type": "number",
            "nullable": true,
            "minimum": 1,
            "maximum": 3
          }
        }
      },
      "AddCompetencesToSupportMeasureEntryDto": {
        "type": "object",
        "properties": {
          "competenceIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "competenceIds"
        ]
      },
      "SetSupportMeasureEntryCompetencesDto": {
        "type": "object",
        "properties": {
          "competenceIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "competenceIds"
        ]
      },
      "AddStudentsToSupportMeasureEntryDto": {
        "type": "object",
        "properties": {
          "studentIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "studentIds"
        ]
      },
      "SetSupportMeasureEntryStudentsDto": {
        "type": "object",
        "properties": {
          "studentIds": {
            "minItems": 1,
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "studentIds"
        ]
      },
      "AddMaterialsToSupportMeasureEntryDto": {
        "type": "object",
        "properties": {
          "externalMaterialIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "externalMaterialIds"
        ]
      },
      "SetSupportMeasureEntryMaterialsDto": {
        "type": "object",
        "properties": {
          "externalMaterialIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "externalMaterialIds"
        ]
      },
      "ProtocolCompetenceObservationInputDto": {
        "type": "object",
        "properties": {
          "studentId": {
            "type": "number"
          },
          "competenceId": {
            "type": "number"
          },
          "competenceAssessmentId": {
            "type": "number"
          },
          "performanceLevelV2Id": {
            "type": "number"
          },
          "description": {
            "type": "string",
            "maxLength": 1000
          }
        },
        "required": [
          "studentId",
          "competenceId",
          "competenceAssessmentId",
          "performanceLevelV2Id"
        ]
      },
      "CreateSupportMeasureProtocolEntryDto": {
        "type": "object",
        "properties": {
          "text": {
            "type": "string",
            "maxLength": 1000
          },
          "date": {
            "format": "date-time",
            "type": "string"
          },
          "studentIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "externalMaterialIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "competenceObservations": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ProtocolCompetenceObservationInputDto"
            }
          }
        },
        "required": [
          "text"
        ]
      },
      "CreatedSupportMeasureProtocolEntryResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/SupportMeasureEntryDto"
          },
          "protocolEntryId": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "data",
          "protocolEntryId"
        ]
      },
      "UpdateSupportMeasureProtocolEntryDto": {
        "type": "object",
        "properties": {
          "text": {
            "type": "string",
            "maxLength": 1000
          },
          "date": {
            "format": "date-time",
            "type": "string"
          },
          "studentIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "externalMaterialIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "competenceObservations": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ProtocolCompetenceObservationInputDto"
            }
          }
        }
      },
      "SetSupportMeasureProtocolEntryRatingDto": {
        "type": "object",
        "properties": {
          "rating": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SupportMeasureProtocolEntryRating"
              },
              {
                "nullable": true
              }
            ]
          }
        },
        "required": [
          "rating"
        ]
      },
      "SupportMeasureReportPdfTenantDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          },
          "slogan": {
            "type": "string",
            "nullable": true
          },
          "street": {
            "type": "string"
          },
          "zipCode": {
            "type": "string"
          },
          "city": {
            "type": "string"
          },
          "nameOfSchoolAdministration": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "name",
          "slogan",
          "street",
          "zipCode",
          "city",
          "nameOfSchoolAdministration"
        ]
      },
      "SupportMeasureReportPdfCompetenceDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "description": {
            "type": "string"
          }
        },
        "required": [
          "id",
          "description"
        ]
      },
      "SupportMeasureReportPdfCompetenceDomainDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "symbol": {
            "type": "string"
          },
          "competences": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SupportMeasureReportPdfCompetenceDto"
            }
          }
        },
        "required": [
          "id",
          "name",
          "symbol",
          "competences"
        ]
      },
      "SupportMeasureReportPdfProtocolRatingDto": {
        "type": "object",
        "properties": {
          "competenceId": {
            "type": "number"
          },
          "performanceLevelV2Id": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "competenceId",
          "performanceLevelV2Id"
        ]
      },
      "SupportMeasureReportPdfProtocolEntryDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "date": {
            "format": "date-time",
            "type": "string"
          },
          "text": {
            "type": "string"
          },
          "ratings": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SupportMeasureReportPdfProtocolRatingDto"
            }
          }
        },
        "required": [
          "id",
          "date",
          "text",
          "ratings"
        ]
      },
      "SupportMeasureReportPdfCompetenceDevelopmentDto": {
        "type": "object",
        "properties": {
          "competenceId": {
            "type": "number"
          },
          "firstPerformanceLevelV2Id": {
            "type": "number",
            "nullable": true
          },
          "latestPerformanceLevelV2Id": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "competenceId",
          "firstPerformanceLevelV2Id",
          "latestPerformanceLevelV2Id"
        ]
      },
      "SupportMeasureReportPdfStudentDto": {
        "type": "object",
        "properties": {
          "student": {
            "$ref": "#/components/schemas/BaseStudentDto"
          },
          "protocolEntries": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SupportMeasureReportPdfProtocolEntryDto"
            }
          },
          "competenceDevelopment": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SupportMeasureReportPdfCompetenceDevelopmentDto"
            }
          },
          "materialIds": {
            "description": "externalMaterialIds of the apps in this student's report, in the order of the report's materials.",
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "student",
          "protocolEntries",
          "competenceDevelopment",
          "materialIds"
        ]
      },
      "SupportMeasureReportPdfDataDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "supportPeriodStart": {
            "format": "date-time",
            "type": "string"
          },
          "completedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "completionNote": {
            "type": "string",
            "nullable": true
          },
          "completedBy": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserDataDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "creator": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserDataDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "schoolSubject": {
            "$ref": "#/components/schemas/BaseSchoolSubjectDto"
          },
          "schoolClass": {
            "$ref": "#/components/schemas/BaseSchoolClassDto"
          },
          "tenant": {
            "$ref": "#/components/schemas/SupportMeasureReportPdfTenantDto"
          },
          "competenceDomains": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SupportMeasureReportPdfCompetenceDomainDto"
            }
          },
          "performanceLevels": {
            "description": "Levels of the class's competence assessment, highest first.",
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/PerformanceLevelV2Dto"
            }
          },
          "materials": {
            "description": "Apps of the measure and of its protocol entries, one per externalMaterialId (link ids come from both tables).",
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ExternalMaterialLinkDto"
            }
          },
          "students": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SupportMeasureReportPdfStudentDto"
            }
          }
        },
        "required": [
          "id",
          "description",
          "supportPeriodStart",
          "completedAt",
          "completionNote",
          "completedBy",
          "creator",
          "schoolSubject",
          "schoolClass",
          "tenant",
          "competenceDomains",
          "performanceLevels",
          "materials",
          "students"
        ]
      },
      "SupportMeasureReportPdfDataResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/SupportMeasureReportPdfDataDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "ESupportMeasureReportCoverSheet": {
        "type": "string",
        "enum": [
          "simple",
          "plant"
        ]
      },
      "ESupportMeasureReportSignatory": {
        "type": "string",
        "enum": [
          "teacher",
          "parents",
          "schoolAdministration"
        ]
      },
      "StartSupportMeasureReportPdfDto": {
        "type": "object",
        "properties": {
          "coverSheet": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ESupportMeasureReportCoverSheet"
              }
            ]
          },
          "signatories": {
            "uniqueItems": true,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ESupportMeasureReportSignatory"
            }
          },
          "studentIds": {
            "description": "Defaults to the current members of the measure.",
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "includeCompetenceDevelopment": {
            "type": "boolean"
          },
          "includeCompletionNote": {
            "type": "boolean"
          },
          "includeMaterials": {
            "type": "boolean"
          }
        },
        "required": [
          "coverSheet",
          "signatories",
          "includeCompetenceDevelopment",
          "includeCompletionNote",
          "includeMaterials"
        ]
      },
      "CountryWithMetaDataDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "isoCode": {
            "type": "string"
          },
          "isSupported": {
            "type": "boolean"
          },
          "currencyCode": {
            "type": "string"
          },
          "languages": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CountryLanguageDto"
            }
          },
          "searchableSchoolCount": {
            "type": "number"
          }
        },
        "required": [
          "id",
          "createdAt",
          "updatedAt",
          "name",
          "isoCode",
          "isSupported",
          "currencyCode",
          "languages",
          "searchableSchoolCount"
        ]
      },
      "PaginatedCountryResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CountryWithMetaDataDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "CreateCountryDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          },
          "isoCode": {
            "type": "string",
            "pattern": "^[A-Za-z]{2,3}$"
          },
          "isSupported": {
            "type": "boolean"
          },
          "languageIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "primaryLanguageId": {
            "type": "number"
          }
        },
        "required": [
          "name",
          "isoCode"
        ]
      },
      "CountryResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/CountryDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateCountryDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          },
          "isSupported": {
            "type": "boolean"
          },
          "languageIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "primaryLanguageId": {
            "type": "number"
          }
        }
      },
      "LanguageDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "code": {
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "isActive": {
            "type": "boolean"
          },
          "isUserSelectable": {
            "type": "boolean"
          }
        },
        "required": [
          "id",
          "createdAt",
          "updatedAt",
          "code",
          "name",
          "isActive",
          "isUserSelectable"
        ]
      },
      "LanguageListResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/LanguageDto"
            }
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "CreateLanguageDto": {
        "type": "object",
        "properties": {
          "code": {
            "type": "string",
            "pattern": "^[a-z]{2,3}$",
            "example": "de"
          },
          "name": {
            "type": "string",
            "maxLength": 64
          },
          "isActive": {
            "type": "boolean"
          },
          "isUserSelectable": {
            "type": "boolean"
          }
        },
        "required": [
          "code",
          "name"
        ]
      },
      "LanguageResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/LanguageDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateLanguageDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "maxLength": 64
          },
          "isActive": {
            "type": "boolean"
          },
          "isUserSelectable": {
            "type": "boolean"
          }
        }
      },
      "QueueJobCategory": {
        "type": "string",
        "enum": [
          "active",
          "failed"
        ]
      },
      "QueueJobStatus": {
        "type": "string",
        "enum": [
          "queued",
          "scheduled",
          "running",
          "retrying",
          "failed"
        ]
      },
      "QueuePriority": {
        "type": "string",
        "enum": [
          "high",
          "normal",
          "low"
        ]
      },
      "QueueJobDto": {
        "type": "object",
        "properties": {
          "status": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/QueueJobStatus"
              }
            ]
          },
          "priority": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/QueuePriority"
              }
            ]
          },
          "id": {
            "type": "string"
          },
          "taskName": {
            "type": "string"
          },
          "queue": {
            "type": "string",
            "nullable": true
          },
          "attempts": {
            "type": "number"
          },
          "maxAttempts": {
            "type": "number"
          },
          "payload": {
            "type": "object"
          },
          "error": {
            "type": "string",
            "nullable": true
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "scheduledAt": {
            "format": "date-time",
            "type": "string"
          },
          "lockedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "status",
          "priority",
          "id",
          "taskName",
          "queue",
          "attempts",
          "maxAttempts",
          "payload",
          "error",
          "createdAt",
          "scheduledAt",
          "lockedAt"
        ]
      },
      "QueueJobsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/QueueJobDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "QueueExecutionOutcome": {
        "type": "string",
        "enum": [
          "completed",
          "failed",
          "cancelled"
        ]
      },
      "QueueExecutionDto": {
        "type": "object",
        "properties": {
          "priority": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/QueuePriority"
              }
            ]
          },
          "outcome": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/QueueExecutionOutcome"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "graphileJobId": {
            "type": "string"
          },
          "operationUuid": {
            "type": "string",
            "nullable": true
          },
          "taskName": {
            "type": "string"
          },
          "queue": {
            "type": "string",
            "nullable": true
          },
          "attempts": {
            "type": "number"
          },
          "queuedAt": {
            "format": "date-time",
            "type": "string"
          },
          "scheduledAt": {
            "format": "date-time",
            "type": "string"
          },
          "startedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "finishedAt": {
            "format": "date-time",
            "type": "string"
          },
          "error": {
            "type": "string",
            "nullable": true
          },
          "result": {
            "type": "object",
            "nullable": true
          },
          "pickupDurationMs": {
            "type": "number",
            "nullable": true
          },
          "executionDurationMs": {
            "type": "number",
            "nullable": true
          },
          "totalDurationMs": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "priority",
          "outcome",
          "id",
          "graphileJobId",
          "operationUuid",
          "taskName",
          "queue",
          "attempts",
          "queuedAt",
          "scheduledAt",
          "startedAt",
          "finishedAt",
          "error",
          "result",
          "pickupDurationMs",
          "executionDurationMs",
          "totalDurationMs"
        ]
      },
      "QueueStatsDto": {
        "type": "object",
        "properties": {
          "averagePickupDurationMs": {
            "type": "number",
            "nullable": true
          },
          "averageExecutionDurationMs": {
            "type": "number",
            "nullable": true
          },
          "averageTotalDurationMs": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "averagePickupDurationMs",
          "averageExecutionDurationMs",
          "averageTotalDurationMs"
        ]
      },
      "QueueExecutionsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/QueueExecutionDto"
            }
          },
          "stats": {
            "$ref": "#/components/schemas/QueueStatsDto"
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "stats",
          "count"
        ]
      },
      "QueueResetResultDto": {
        "type": "object",
        "properties": {
          "removedCount": {
            "type": "number"
          },
          "runningCount": {
            "type": "number"
          }
        },
        "required": [
          "removedCount",
          "runningCount"
        ]
      },
      "QueueResetResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/QueueResetResultDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "QueueJobActionResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          }
        },
        "required": [
          "success"
        ]
      },
      "CronJobStatus": {
        "type": "string",
        "enum": [
          "ok",
          "failed",
          "running",
          "never-run"
        ]
      },
      "CronJobStatusDto": {
        "type": "object",
        "properties": {
          "status": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/CronJobStatus"
              }
            ]
          },
          "name": {
            "type": "string"
          },
          "schedule": {
            "type": "string",
            "nullable": true
          },
          "lastStartedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "lastSucceededAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "lastFailedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "lastError": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "status",
          "name",
          "schedule",
          "lastStartedAt",
          "lastSucceededAt",
          "lastFailedAt",
          "lastError"
        ]
      },
      "CronJobsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CronJobStatusDto"
            }
          }
        },
        "required": [
          "success",
          "rows"
        ]
      },
      "AssignedSchoolSubjectTypeDto": {
        "type": "object",
        "properties": {
          "typeId": {
            "type": "number"
          },
          "key": {
            "type": "string"
          },
          "label": {
            "type": "string"
          }
        },
        "required": [
          "typeId",
          "key",
          "label"
        ]
      },
      "ProviderSchoolSubjectDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "abbreviation": {
            "type": "string"
          },
          "schoolLevel": {
            "type": "number"
          },
          "templateSetId": {
            "type": "number",
            "nullable": true
          },
          "isTemplate": {
            "type": "boolean"
          },
          "schoolTypeId": {
            "type": "number",
            "nullable": true
          },
          "schoolTypeName": {
            "type": "string",
            "nullable": true
          },
          "tenantId": {
            "type": "number",
            "nullable": true
          },
          "tenantName": {
            "type": "string",
            "nullable": true
          },
          "schoolClassId": {
            "type": "number",
            "nullable": true
          },
          "schoolClassName": {
            "type": "string",
            "nullable": true
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "competenceDomainCount": {
            "type": "number"
          },
          "types": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/AssignedSchoolSubjectTypeDto"
            }
          }
        },
        "required": [
          "id",
          "name",
          "abbreviation",
          "schoolLevel",
          "templateSetId",
          "isTemplate",
          "schoolTypeId",
          "schoolTypeName",
          "tenantId",
          "tenantName",
          "schoolClassId",
          "schoolClassName",
          "createdAt",
          "updatedAt",
          "competenceDomainCount",
          "types"
        ]
      },
      "PaginatedProviderSchoolSubjectResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ProviderSchoolSubjectDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "SetSchoolSubjectTypesDto": {
        "type": "object",
        "properties": {
          "schoolSubjectTypeIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "schoolSubjectTypeIds"
        ]
      },
      "ProviderSchoolSubjectResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/ProviderSchoolSubjectDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "CreateSchoolSubjectProviderDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "maxLength": 100
          },
          "abbreviation": {
            "type": "string",
            "maxLength": 100
          },
          "color": {
            "type": "string",
            "minLength": 7,
            "maxLength": 7,
            "pattern": "^#[A-Fa-f0-9]{6}$"
          },
          "schoolLevel": {
            "type": "number"
          },
          "templateSetId": {
            "type": "number"
          },
          "isPreselected": {
            "type": "boolean"
          }
        },
        "required": [
          "name",
          "abbreviation",
          "color",
          "schoolLevel",
          "templateSetId"
        ]
      },
      "UpdateSchoolSubjectProviderDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "maxLength": 100
          },
          "abbreviation": {
            "type": "string",
            "maxLength": 100
          },
          "color": {
            "type": "string",
            "minLength": 7,
            "maxLength": 7,
            "pattern": "^#[A-Fa-f0-9]{6}$"
          },
          "schoolLevel": {
            "type": "number"
          },
          "isPreselected": {
            "type": "boolean"
          }
        }
      },
      "ProviderUserSortField": {
        "type": "string",
        "enum": [
          "firstName",
          "lastName",
          "email",
          "createdAt",
          "deactivatedAt",
          "isSetupCompleted",
          "isApproved",
          "competenceObservationsCount",
          "performanceAssessmentEntryCount",
          "performanceAssessmentStudentEntryCount"
        ]
      },
      "TenantShortDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "isDisabled": {
            "type": "boolean"
          }
        },
        "required": [
          "id",
          "name",
          "isDisabled"
        ]
      },
      "UserRoleWithShortTenantDto": {
        "type": "object",
        "properties": {
          "roleType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserRoleType"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "status": {
            "type": "string"
          },
          "tenant": {
            "$ref": "#/components/schemas/TenantShortDto"
          }
        },
        "required": [
          "roleType",
          "id",
          "status",
          "tenant"
        ]
      },
      "UserDataWithCountsDto": {
        "type": "object",
        "properties": {
          "source": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserSource"
              },
              {
                "nullable": true
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "email": {
            "type": "string"
          },
          "firstName": {
            "type": "string",
            "nullable": true
          },
          "lastName": {
            "type": "string",
            "nullable": true
          },
          "avatar": {
            "type": "string",
            "nullable": true
          },
          "avatarPictureId": {
            "type": "number",
            "nullable": true,
            "description": "File id of the uploaded avatar picture; resolve the signed url via GET /files/:id/url"
          },
          "sourceOther": {
            "type": "string",
            "nullable": true
          },
          "isSetupCompleted": {
            "type": "boolean"
          },
          "isApproved": {
            "type": "boolean"
          },
          "countryId": {
            "type": "number",
            "nullable": true
          },
          "stateId": {
            "type": "number",
            "nullable": true
          },
          "demoClassWizardSeen": {
            "type": "boolean"
          },
          "ratingDialogSeenAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "weeklyReportActive": {
            "type": "boolean"
          },
          "deactivatedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "language": {
            "type": "string",
            "nullable": true
          },
          "storageUsage": {
            "$ref": "#/components/schemas/FileStorageUsageDto"
          },
          "competenceObservationsCount": {
            "type": "number"
          },
          "performanceAssessmentEntryCount": {
            "type": "number"
          },
          "performanceAssessmentStudentEntryCount": {
            "type": "number"
          },
          "userRoles": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/UserRoleWithShortTenantDto"
            }
          },
          "loginProviders": {
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "hasLocalLoginEntity": {
            "type": "boolean"
          },
          "tfaEnabled": {
            "type": "boolean"
          },
          "totpEnabled": {
            "type": "boolean"
          }
        },
        "required": [
          "source",
          "id",
          "createdAt",
          "updatedAt",
          "email",
          "firstName",
          "lastName",
          "avatar",
          "avatarPictureId",
          "sourceOther",
          "isSetupCompleted",
          "isApproved",
          "countryId",
          "stateId",
          "demoClassWizardSeen",
          "ratingDialogSeenAt",
          "weeklyReportActive",
          "deactivatedAt",
          "language",
          "storageUsage",
          "competenceObservationsCount",
          "performanceAssessmentEntryCount",
          "performanceAssessmentStudentEntryCount",
          "userRoles",
          "loginProviders",
          "hasLocalLoginEntity",
          "tfaEnabled",
          "totpEnabled"
        ]
      },
      "UserDataWithCountsPaginatedResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/UserDataWithCountsDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "UserEmailChangeDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "oldEmail": {
            "type": "string"
          },
          "newEmail": {
            "type": "string"
          }
        },
        "required": [
          "id",
          "createdAt",
          "oldEmail",
          "newEmail"
        ]
      },
      "UserEmailChangesResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/UserEmailChangeDto"
            }
          }
        },
        "required": [
          "success",
          "rows"
        ]
      },
      "ClickIdKey": {
        "type": "string",
        "enum": [
          "gclid",
          "gbraid",
          "wbraid",
          "fbclid",
          "msclkid",
          "ttclid"
        ]
      },
      "UserFirstTouchDto": {
        "type": "object",
        "properties": {
          "clickIdKeys": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ClickIdKey"
            }
          },
          "capturedAt": {
            "format": "date-time",
            "type": "string"
          },
          "landingHostname": {
            "type": "string"
          },
          "landingPathname": {
            "type": "string"
          },
          "referrerHostname": {
            "type": "string",
            "nullable": true
          },
          "utmSource": {
            "type": "string",
            "nullable": true
          },
          "utmMedium": {
            "type": "string",
            "nullable": true
          },
          "utmCampaign": {
            "type": "string",
            "nullable": true
          },
          "utmTerm": {
            "type": "string",
            "nullable": true
          },
          "utmContent": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "clickIdKeys",
          "capturedAt",
          "landingHostname",
          "landingPathname",
          "referrerHostname",
          "utmSource",
          "utmMedium",
          "utmCampaign",
          "utmTerm",
          "utmContent"
        ]
      },
      "UserClickIdDto": {
        "type": "object",
        "properties": {
          "key": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ClickIdKey"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "value": {
            "type": "string"
          },
          "capturedAt": {
            "format": "date-time",
            "type": "string"
          }
        },
        "required": [
          "key",
          "id",
          "value",
          "capturedAt"
        ]
      },
      "UserAttributionDto": {
        "type": "object",
        "properties": {
          "firstTouch": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserFirstTouchDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "clickIds": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/UserClickIdDto"
            }
          }
        },
        "required": [
          "firstTouch",
          "clickIds"
        ]
      },
      "UserAttributionResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/UserAttributionDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "SchoolWithTenantCountAndRelationsDto": {
        "type": "object",
        "properties": {
          "isPublicOrPrivate": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SchoolPublicOrPrivate"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "skz": {
            "type": "string"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "title": {
            "type": "string"
          },
          "address": {
            "type": "string"
          },
          "zipCode": {
            "type": "string"
          },
          "city": {
            "type": "string"
          },
          "maintainer": {
            "type": "string",
            "nullable": true
          },
          "supervisoryAuthority": {
            "type": "string",
            "nullable": true
          },
          "hasChildCare": {
            "type": "boolean",
            "nullable": true
          },
          "telephone": {
            "type": "string",
            "nullable": true
          },
          "fax": {
            "type": "string",
            "nullable": true
          },
          "email": {
            "type": "string",
            "nullable": true
          },
          "website": {
            "type": "string",
            "nullable": true
          },
          "countryId": {
            "type": "number"
          },
          "stateId": {
            "type": "number"
          },
          "schoolTypeId": {
            "type": "number",
            "nullable": true
          },
          "tenantCount": {
            "type": "number"
          },
          "country": {
            "$ref": "#/components/schemas/CountryDto"
          },
          "state": {
            "$ref": "#/components/schemas/StateDto"
          },
          "schoolType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SchoolTypeDto"
              },
              {
                "nullable": true
              }
            ]
          }
        },
        "required": [
          "isPublicOrPrivate",
          "id",
          "skz",
          "createdAt",
          "updatedAt",
          "title",
          "address",
          "zipCode",
          "city",
          "countryId",
          "stateId",
          "tenantCount",
          "country",
          "state"
        ]
      },
      "SchoolWithTenantCountAndRelationsPaginatedResponse": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolWithTenantCountAndRelationsDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "SchoolWithTenantCountAndRelationsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/SchoolWithTenantCountAndRelationsDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "CreateSchoolImportResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "message": {
            "type": "string"
          }
        },
        "required": [
          "success",
          "message"
        ]
      },
      "CreateSchoolDto": {
        "type": "object",
        "properties": {
          "skz": {
            "type": "string"
          },
          "title": {
            "type": "string"
          },
          "isPublicOrPrivate": {
            "type": "string"
          },
          "address": {
            "type": "string"
          },
          "zipCode": {
            "type": "string"
          },
          "city": {
            "type": "string"
          },
          "stateId": {
            "type": "number"
          },
          "countryId": {
            "type": "number"
          },
          "maintainer": {
            "type": "string"
          },
          "supervisoryAuthority": {
            "type": "string"
          },
          "hasChildCare": {
            "type": "boolean"
          },
          "telephone": {
            "type": "string"
          },
          "fax": {
            "type": "string"
          },
          "email": {
            "type": "string"
          },
          "website": {
            "type": "string"
          },
          "schoolTypeId": {
            "type": "number"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          }
        },
        "required": [
          "skz",
          "title",
          "isPublicOrPrivate",
          "address",
          "zipCode",
          "city",
          "stateId",
          "countryId",
          "maintainer",
          "supervisoryAuthority",
          "hasChildCare",
          "telephone",
          "fax",
          "email",
          "website",
          "schoolTypeId",
          "updatedAt",
          "createdAt"
        ]
      },
      "SchoolResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/SchoolDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateSchoolDto": {
        "type": "object",
        "properties": {
          "skz": {
            "type": "string"
          },
          "title": {
            "type": "string"
          },
          "isPublicOrPrivate": {
            "type": "string"
          },
          "address": {
            "type": "string"
          },
          "zipCode": {
            "type": "string"
          },
          "city": {
            "type": "string"
          },
          "stateId": {
            "type": "number"
          },
          "countryId": {
            "type": "number"
          },
          "maintainer": {
            "type": "string"
          },
          "supervisoryAuthority": {
            "type": "string"
          },
          "hasChildCare": {
            "type": "boolean"
          },
          "telephone": {
            "type": "string"
          },
          "fax": {
            "type": "string"
          },
          "email": {
            "type": "string"
          },
          "website": {
            "type": "string"
          },
          "schoolTypeId": {
            "type": "number"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          }
        }
      },
      "ReleaseActionTarget": {
        "type": "string",
        "enum": [
          "gradeCalculationSettings"
        ]
      },
      "ReleaseContentType": {
        "type": "string",
        "enum": [
          "title",
          "text",
          "bulletPoint",
          "image"
        ]
      },
      "ReleaseContentDto": {
        "type": "object",
        "properties": {
          "type": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReleaseContentType"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "releaseId": {
            "type": "number"
          },
          "content": {
            "type": "string"
          },
          "position": {
            "type": "number"
          },
          "fileId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "type",
          "id",
          "releaseId",
          "content",
          "position"
        ]
      },
      "ReleaseWithContentDto": {
        "type": "object",
        "properties": {
          "actionTarget": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReleaseActionTarget"
              },
              {
                "nullable": true
              }
            ]
          },
          "content": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ReleaseContentDto"
            }
          },
          "id": {
            "type": "number"
          },
          "releaseId": {
            "type": "string"
          },
          "title": {
            "type": "string"
          },
          "releasedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "bannerImageId": {
            "type": "number",
            "nullable": true
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          }
        },
        "required": [
          "content",
          "id",
          "releaseId",
          "title",
          "bannerImageId",
          "createdAt",
          "updatedAt"
        ]
      },
      "ReleaseWithContentResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/ReleaseWithContentDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "ReleaseDto": {
        "type": "object",
        "properties": {
          "actionTarget": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReleaseActionTarget"
              },
              {
                "nullable": true
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "releaseId": {
            "type": "string"
          },
          "title": {
            "type": "string"
          },
          "releasedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "bannerImageId": {
            "type": "number",
            "nullable": true
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          }
        },
        "required": [
          "id",
          "releaseId",
          "title",
          "bannerImageId",
          "createdAt",
          "updatedAt"
        ]
      },
      "ReleasePaginatedResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ReleaseDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "CreateReleaseContentDto": {
        "type": "object",
        "properties": {
          "type": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReleaseContentType"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "releaseId": {
            "type": "number"
          },
          "content": {
            "type": "string"
          },
          "position": {
            "type": "number"
          }
        },
        "required": [
          "type",
          "releaseId",
          "content",
          "position"
        ]
      },
      "CreateReleaseDto": {
        "type": "object",
        "properties": {
          "actionTarget": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReleaseActionTarget"
              },
              {
                "nullable": true
              }
            ]
          },
          "releaseId": {
            "type": "string"
          },
          "title": {
            "type": "string"
          },
          "releaseContent": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CreateReleaseContentDto"
            }
          }
        },
        "required": [
          "releaseId",
          "title"
        ]
      },
      "ReleaseResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/ReleaseDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateReleaseDto": {
        "type": "object",
        "properties": {
          "actionTarget": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ReleaseActionTarget"
              },
              {
                "nullable": true
              }
            ]
          },
          "releaseId": {
            "type": "string"
          },
          "title": {
            "type": "string"
          },
          "releaseContent": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CreateReleaseContentDto"
            }
          }
        }
      },
      "SendReleaseTestEmailDto": {
        "type": "object",
        "properties": {
          "userIds": {
            "minItems": 1,
            "uniqueItems": true,
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "userIds"
        ]
      },
      "ReleaseContentResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/ReleaseContentDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "FaqDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "uid": {
            "type": "string"
          },
          "question": {
            "type": "string"
          },
          "answer": {
            "type": "array",
            "items": {
              "type": "object"
            }
          },
          "mostRelevant": {
            "type": "boolean"
          },
          "relevanceOrder": {
            "type": "number"
          }
        },
        "required": [
          "id",
          "uid",
          "question",
          "answer"
        ]
      },
      "FaqCategoryWithArticlesDto": {
        "type": "object",
        "properties": {
          "articles": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/FaqDto"
            }
          },
          "id": {
            "type": "string"
          },
          "slug": {
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "order": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "id",
          "slug",
          "name"
        ]
      },
      "FaqCategoryWithArticlesPaginatedResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/FaqCategoryWithArticlesDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "HelpVideoDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "uid": {
            "type": "string"
          },
          "videoIdentifier": {
            "type": "string"
          },
          "order": {
            "type": "number"
          },
          "title": {
            "type": "string"
          },
          "durationInSeconds": {
            "type": "number"
          },
          "backgroundImageUrl": {
            "type": "string"
          }
        },
        "required": [
          "id",
          "uid",
          "videoIdentifier",
          "order",
          "title",
          "durationInSeconds",
          "backgroundImageUrl"
        ]
      },
      "HelpVideoPaginatedResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/HelpVideoDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "ApiCreateTokenResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "token": {
            "type": "string"
          }
        },
        "required": [
          "success",
          "token"
        ]
      },
      "ApiTokenDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "token": {
            "type": "string"
          }
        },
        "required": [
          "id",
          "createdAt",
          "updatedAt",
          "name",
          "token"
        ]
      },
      "PaginatedApiTokenResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ApiTokenDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "CreateApiTokenDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          },
          "token": {
            "type": "string"
          }
        },
        "required": [
          "name",
          "token"
        ]
      },
      "ApiTokenResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/ApiTokenDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateApiTokenDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          },
          "token": {
            "type": "string"
          }
        }
      },
      "BaseStatisticsDto": {
        "type": "object",
        "properties": {
          "observationCount": {
            "type": "number"
          },
          "studentCount": {
            "type": "number"
          },
          "userCount": {
            "type": "number"
          },
          "twoFactorEnabledUserCount": {
            "type": "number"
          },
          "tenantCount": {
            "type": "number"
          },
          "classCount": {
            "type": "number"
          },
          "groupCount": {
            "type": "number"
          },
          "performanceAssessmentCount": {
            "type": "number"
          },
          "reportCount": {
            "type": "number"
          }
        },
        "required": [
          "observationCount",
          "studentCount",
          "userCount",
          "twoFactorEnabledUserCount",
          "tenantCount",
          "classCount",
          "groupCount",
          "performanceAssessmentCount",
          "reportCount"
        ]
      },
      "BaseStatisticsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/BaseStatisticsDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "StatisticsRoleType": {
        "type": "string",
        "enum": [
          "all",
          "owner",
          "admin",
          "user",
          "external"
        ]
      },
      "UserTypeStatisticsDto": {
        "type": "object",
        "properties": {
          "roleType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/StatisticsRoleType"
              }
            ]
          },
          "startDate": {
            "format": "date-time",
            "type": "string"
          },
          "endDate": {
            "format": "date-time",
            "type": "string"
          },
          "totalUsers": {
            "type": "number"
          },
          "type_0": {
            "type": "number"
          },
          "type_1": {
            "type": "number"
          },
          "type_2": {
            "type": "number"
          },
          "type_3": {
            "type": "number"
          },
          "type_4": {
            "type": "number"
          }
        },
        "required": [
          "roleType",
          "startDate",
          "endDate",
          "totalUsers",
          "type_0",
          "type_1",
          "type_2",
          "type_3",
          "type_4"
        ]
      },
      "UserTypeStatisticsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/UserTypeStatisticsDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "JoinedUsageStatisticsDto": {
        "type": "object",
        "properties": {
          "roleType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/StatisticsRoleType"
              }
            ]
          },
          "totalJoinedUsers": {
            "type": "number"
          },
          "usersWithOnlyClasses": {
            "type": "number"
          },
          "usersWithOnlyPerformanceEntries": {
            "type": "number"
          },
          "usersWithClassesAndPerformanceEntries": {
            "type": "number"
          },
          "usersWithEntries": {
            "type": "number"
          },
          "usersWithDemoClassEntries": {
            "type": "number"
          }
        },
        "required": [
          "roleType",
          "totalJoinedUsers",
          "usersWithOnlyClasses",
          "usersWithOnlyPerformanceEntries",
          "usersWithClassesAndPerformanceEntries",
          "usersWithEntries",
          "usersWithDemoClassEntries"
        ]
      },
      "JoinedUsageStatisticsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/JoinedUsageStatisticsDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "ProductStatusStatisticsDto": {
        "type": "object",
        "properties": {
          "totalTenants": {
            "type": "number"
          },
          "tenantsInFreeTrial": {
            "type": "number"
          },
          "tenantsWithActiveProduct": {
            "type": "number"
          },
          "tenantsWithoutProductAfterTrial": {
            "type": "number"
          },
          "tenantsDowngradedAfterTrial": {
            "type": "number"
          },
          "tenantsExpiredWithoutAction": {
            "type": "number"
          },
          "activeSchoolProductTenants": {
            "type": "number"
          },
          "activeTeamProductTenants": {
            "type": "number"
          },
          "activeProUserProductTenants": {
            "type": "number"
          }
        },
        "required": [
          "totalTenants",
          "tenantsInFreeTrial",
          "tenantsWithActiveProduct",
          "tenantsWithoutProductAfterTrial",
          "tenantsDowngradedAfterTrial",
          "tenantsExpiredWithoutAction",
          "activeSchoolProductTenants",
          "activeTeamProductTenants",
          "activeProUserProductTenants"
        ]
      },
      "ProductStatusStatisticsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/ProductStatusStatisticsDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "AcquisitionSourceStatisticsDto": {
        "type": "object",
        "properties": {
          "googleSearch": {
            "type": "number"
          },
          "colleagueReferral": {
            "type": "number"
          },
          "schoolAdmin": {
            "type": "number"
          },
          "socialMedia": {
            "type": "number"
          },
          "eventTraining": {
            "type": "number"
          },
          "other": {
            "type": "number"
          },
          "unknown": {
            "type": "number"
          }
        },
        "required": [
          "googleSearch",
          "colleagueReferral",
          "schoolAdmin",
          "socialMedia",
          "eventTraining",
          "other",
          "unknown"
        ]
      },
      "AcquisitionSourceStatisticsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/AcquisitionSourceStatisticsDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "StarRatingStatisticsDto": {
        "type": "object",
        "properties": {
          "totalCount": {
            "type": "number"
          },
          "averageRating": {
            "type": "number"
          },
          "stars1": {
            "type": "number"
          },
          "stars2": {
            "type": "number"
          },
          "stars3": {
            "type": "number"
          },
          "stars4": {
            "type": "number"
          },
          "stars5": {
            "type": "number"
          }
        },
        "required": [
          "totalCount",
          "averageRating",
          "stars1",
          "stars2",
          "stars3",
          "stars4",
          "stars5"
        ]
      },
      "StarRatingStatisticsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/StarRatingStatisticsDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "RoleDistributionStatisticsDto": {
        "type": "object",
        "properties": {
          "roleType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/StatisticsRoleType"
              }
            ]
          },
          "ownerCount": {
            "type": "number"
          },
          "adminCount": {
            "type": "number"
          },
          "userCount": {
            "type": "number"
          },
          "totalCount": {
            "type": "number"
          }
        },
        "required": [
          "roleType",
          "ownerCount",
          "adminCount",
          "userCount",
          "totalCount"
        ]
      },
      "RoleDistributionStatisticsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/RoleDistributionStatisticsDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "EntryActivityResolution": {
        "type": "string",
        "enum": [
          "day",
          "week",
          "month"
        ]
      },
      "EntryActivityStatisticsPointDto": {
        "type": "object",
        "properties": {
          "bucketStart": {
            "format": "date-time",
            "type": "string"
          },
          "performanceAssessmentStudentEntryCount": {
            "type": "number"
          },
          "competenceObservationCount": {
            "type": "number"
          },
          "totalCount": {
            "type": "number"
          }
        },
        "required": [
          "bucketStart",
          "performanceAssessmentStudentEntryCount",
          "competenceObservationCount",
          "totalCount"
        ]
      },
      "EntryActivityStatisticsDto": {
        "type": "object",
        "properties": {
          "resolution": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/EntryActivityResolution"
              }
            ]
          },
          "roleType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/StatisticsRoleType"
              }
            ]
          },
          "totalCount": {
            "type": "number"
          },
          "performanceAssessmentStudentEntryCount": {
            "type": "number"
          },
          "competenceObservationCount": {
            "type": "number"
          },
          "points": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/EntryActivityStatisticsPointDto"
            }
          }
        },
        "required": [
          "resolution",
          "roleType",
          "totalCount",
          "performanceAssessmentStudentEntryCount",
          "competenceObservationCount",
          "points"
        ]
      },
      "EntryActivityStatisticsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/EntryActivityStatisticsDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "NewUsersStatisticsPointDto": {
        "type": "object",
        "properties": {
          "bucketStart": {
            "format": "date-time",
            "type": "string"
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "bucketStart",
          "count"
        ]
      },
      "NewUsersStatisticsDto": {
        "type": "object",
        "properties": {
          "resolution": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/EntryActivityResolution"
              }
            ]
          },
          "roleType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/StatisticsRoleType"
              }
            ]
          },
          "totalCount": {
            "type": "number"
          },
          "points": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/NewUsersStatisticsPointDto"
            }
          }
        },
        "required": [
          "resolution",
          "roleType",
          "totalCount",
          "points"
        ]
      },
      "NewUsersStatisticsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/NewUsersStatisticsDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "TimelineActivityStatisticsPointDto": {
        "type": "object",
        "properties": {
          "bucketStart": {
            "format": "date-time",
            "type": "string"
          },
          "noteCount": {
            "type": "number"
          },
          "performanceAssessmentEntryCount": {
            "type": "number"
          },
          "supportMeasureEntryCount": {
            "type": "number"
          },
          "totalCount": {
            "type": "number"
          }
        },
        "required": [
          "bucketStart",
          "noteCount",
          "performanceAssessmentEntryCount",
          "supportMeasureEntryCount",
          "totalCount"
        ]
      },
      "TimelineActivityStatisticsDto": {
        "type": "object",
        "properties": {
          "resolution": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/EntryActivityResolution"
              }
            ]
          },
          "roleType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/StatisticsRoleType"
              }
            ]
          },
          "totalCount": {
            "type": "number"
          },
          "noteCount": {
            "type": "number"
          },
          "performanceAssessmentEntryCount": {
            "type": "number"
          },
          "supportMeasureEntryCount": {
            "type": "number"
          },
          "points": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/TimelineActivityStatisticsPointDto"
            }
          }
        },
        "required": [
          "resolution",
          "roleType",
          "totalCount",
          "noteCount",
          "performanceAssessmentEntryCount",
          "supportMeasureEntryCount",
          "points"
        ]
      },
      "TimelineActivityStatisticsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/TimelineActivityStatisticsDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "ReportDistributionStatisticsDto": {
        "type": "object",
        "properties": {
          "totalReports": {
            "type": "number"
          },
          "coverSheet_none": {
            "type": "number"
          },
          "coverSheet_simple": {
            "type": "number"
          },
          "coverSheet_withChart": {
            "type": "number"
          },
          "coverSheet_withCustomImage": {
            "type": "number"
          },
          "coverSheet_withNote": {
            "type": "number"
          },
          "coverSheet_withFlower": {
            "type": "number"
          },
          "competenceType_compact": {
            "type": "number"
          },
          "competenceType_simple": {
            "type": "number"
          },
          "competenceType_withNotes": {
            "type": "number"
          },
          "competenceType_withPerformanceAssessments": {
            "type": "number"
          },
          "type_notesReport": {
            "type": "number"
          },
          "summarySheet_none": {
            "type": "number"
          },
          "summarySheet_simple": {
            "type": "number"
          },
          "summarySheet_signature": {
            "type": "number"
          }
        },
        "required": [
          "totalReports",
          "coverSheet_none",
          "coverSheet_simple",
          "coverSheet_withChart",
          "coverSheet_withCustomImage",
          "coverSheet_withNote",
          "coverSheet_withFlower",
          "competenceType_compact",
          "competenceType_simple",
          "competenceType_withNotes",
          "competenceType_withPerformanceAssessments",
          "type_notesReport",
          "summarySheet_none",
          "summarySheet_simple",
          "summarySheet_signature"
        ]
      },
      "ReportDistributionStatisticsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/ReportDistributionStatisticsDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "SchoolTypeDistributionPointDto": {
        "type": "object",
        "properties": {
          "schoolTypeId": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "abbreviation": {
            "type": "string",
            "nullable": true
          },
          "color": {
            "type": "string"
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "schoolTypeId",
          "name",
          "abbreviation",
          "color",
          "count"
        ]
      },
      "SchoolTypeDistributionStatisticsDto": {
        "type": "object",
        "properties": {
          "countryIsoCode": {
            "type": "string",
            "nullable": true
          },
          "totalTenants": {
            "type": "number"
          },
          "points": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolTypeDistributionPointDto"
            }
          }
        },
        "required": [
          "countryIsoCode",
          "totalTenants",
          "points"
        ]
      },
      "SchoolTypeDistributionStatisticsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/SchoolTypeDistributionStatisticsDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "TenantLocationDistributionPointDto": {
        "type": "object",
        "properties": {
          "key": {
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "key",
          "name",
          "count"
        ]
      },
      "TenantLocationDistributionStatisticsDto": {
        "type": "object",
        "properties": {
          "countryIsoCode": {
            "type": "string",
            "nullable": true
          },
          "totalTenants": {
            "type": "number"
          },
          "points": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/TenantLocationDistributionPointDto"
            }
          }
        },
        "required": [
          "countryIsoCode",
          "totalTenants",
          "points"
        ]
      },
      "TenantLocationDistributionStatisticsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/TenantLocationDistributionStatisticsDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "LoginProviderDistributionPointDto": {
        "type": "object",
        "properties": {
          "providerId": {
            "type": "string"
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "providerId",
          "count"
        ]
      },
      "LoginProviderDistributionStatisticsDto": {
        "type": "object",
        "properties": {
          "totalCount": {
            "type": "number"
          },
          "points": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/LoginProviderDistributionPointDto"
            }
          }
        },
        "required": [
          "totalCount",
          "points"
        ]
      },
      "LoginProviderDistributionStatisticsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/LoginProviderDistributionStatisticsDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "TrialExpiredFeedbackStatisticsDto": {
        "type": "object",
        "properties": {
          "totalCount": {
            "type": "number"
          },
          "subscriptionTooExpensive": {
            "type": "number"
          },
          "missingFeatures": {
            "type": "number"
          },
          "underUsed": {
            "type": "number"
          },
          "preferFreeVersion": {
            "type": "number"
          }
        },
        "required": [
          "totalCount",
          "subscriptionTooExpensive",
          "missingFeatures",
          "underUsed",
          "preferFreeVersion"
        ]
      },
      "TrialExpiredFeedbackStatisticsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/TrialExpiredFeedbackStatisticsDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "OnboardingFunnelPointDto": {
        "type": "object",
        "properties": {
          "key": {
            "type": "string"
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "key",
          "count"
        ]
      },
      "OnboardingFunnelStatisticsDto": {
        "type": "object",
        "properties": {
          "roleType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/StatisticsRoleType"
              }
            ]
          },
          "points": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/OnboardingFunnelPointDto"
            }
          }
        },
        "required": [
          "roleType",
          "points"
        ]
      },
      "OnboardingFunnelStatisticsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/OnboardingFunnelStatisticsDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "CreateTenantDto": {
        "type": "object",
        "properties": {
          "templateSetSource": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/TemplateSetSource"
              }
            ]
          },
          "name": {
            "type": "string",
            "maxLength": 256
          },
          "slogan": {
            "type": "string"
          },
          "countryId": {
            "type": "number"
          },
          "stateId": {
            "type": "number"
          },
          "schoolTypeId": {
            "type": "number"
          },
          "customSchoolTypeName": {
            "type": "string"
          },
          "contentLanguageId": {
            "type": "number",
            "description": "Content language for provisioned curricula/configs. Defaults to the country's primary content language."
          },
          "zipCode": {
            "type": "string",
            "maxLength": 5000
          },
          "city": {
            "type": "string",
            "maxLength": 5000
          },
          "street": {
            "type": "string",
            "maxLength": 5000
          },
          "email": {
            "type": "string",
            "nullable": true,
            "maxLength": 512
          },
          "telephone": {
            "type": "string",
            "nullable": true
          },
          "website": {
            "type": "string",
            "nullable": true
          },
          "nameOfSchoolAdministration": {
            "type": "string",
            "nullable": true,
            "maxLength": 250
          },
          "schoolId": {
            "type": "number"
          },
          "schoolLevels": {
            "type": "array",
            "items": {
              "type": "number",
              "maximum": 13,
              "minimum": 0
            }
          }
        },
        "required": [
          "name",
          "countryId",
          "stateId",
          "zipCode",
          "city",
          "street"
        ]
      },
      "TenantWithDemoClassDto": {
        "type": "object",
        "properties": {
          "templateSetSource": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/TemplateSetSource"
              }
            ]
          },
          "billingMode": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingMode"
              }
            ]
          },
          "schoolLevelLabelMode": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SchoolLevelLabelMode"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "slogan": {
            "type": "string",
            "nullable": true
          },
          "isDisabled": {
            "type": "boolean"
          },
          "deactivatedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "isProvider": {
            "type": "boolean"
          },
          "isWizardFinalized": {
            "type": "boolean"
          },
          "isAdministrationSetupCompleted": {
            "type": "boolean"
          },
          "hasSeenCompetenceSetupChoiceDialog": {
            "type": "boolean"
          },
          "requiresTwoFactorAuth": {
            "type": "boolean"
          },
          "countryId": {
            "type": "number",
            "nullable": true
          },
          "countryIsoCode": {
            "type": "string",
            "nullable": true,
            "description": "ISO alpha-2 of the tenant country; populated only on whoami"
          },
          "stateId": {
            "type": "number",
            "nullable": true
          },
          "schoolTypeId": {
            "type": "number",
            "nullable": true
          },
          "contentLanguageId": {
            "type": "number",
            "nullable": true
          },
          "schoolTypeAbbr": {
            "type": "string",
            "nullable": true
          },
          "schoolTypeName": {
            "type": "string",
            "nullable": true
          },
          "zipCode": {
            "type": "string"
          },
          "city": {
            "type": "string"
          },
          "street": {
            "type": "string"
          },
          "email": {
            "type": "string",
            "nullable": true
          },
          "telephone": {
            "type": "string",
            "nullable": true
          },
          "website": {
            "type": "string",
            "nullable": true
          },
          "nameOfSchoolAdministration": {
            "type": "string",
            "nullable": true
          },
          "schoolId": {
            "type": "number",
            "nullable": true
          },
          "schoolLevels": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "logoId": {
            "type": "number",
            "nullable": true
          },
          "school": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SchoolDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "gradeCalculation": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/GradeCalculationSettingsDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "gradeCalculationTags": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/GradeCalculationTagDto"
            }
          },
          "demoClass": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SchoolClassDto"
              },
              {
                "nullable": true
              }
            ]
          }
        },
        "required": [
          "templateSetSource",
          "billingMode",
          "schoolLevelLabelMode",
          "id",
          "createdAt",
          "updatedAt",
          "name",
          "isDisabled",
          "deactivatedAt",
          "isProvider",
          "isWizardFinalized",
          "isAdministrationSetupCompleted",
          "hasSeenCompetenceSetupChoiceDialog",
          "requiresTwoFactorAuth",
          "zipCode",
          "city",
          "street",
          "email",
          "telephone",
          "website",
          "nameOfSchoolAdministration",
          "schoolLevels",
          "logoId",
          "gradeCalculation",
          "gradeCalculationTags",
          "demoClass"
        ]
      },
      "TenantWithDemoClassResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/TenantWithDemoClassDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "AcceptInvitationDto": {
        "type": "object",
        "properties": {
          "code": {
            "type": "string",
            "maxLength": 100
          }
        },
        "required": [
          "code"
        ]
      },
      "BillingOnboardingCheckoutOptionDto": {
        "type": "object",
        "properties": {
          "discountPercent": {
            "type": "number"
          },
          "stripePublishableKey": {
            "type": "string"
          },
          "trialDays": {
            "type": "number"
          },
          "walletPaymentMethodTypes": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": [
          "discountPercent",
          "stripePublishableKey",
          "trialDays",
          "walletPaymentMethodTypes"
        ]
      },
      "BillingOnboardingCheckoutInfoResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingOnboardingCheckoutOptionDto"
              },
              {
                "nullable": true
              }
            ]
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "OnboardingCheckoutPreviewDto": {
        "type": "object",
        "properties": {
          "productTypeId": {
            "type": "number",
            "description": "The product type id to preview (yearly billing only)"
          },
          "quantity": {
            "type": "number",
            "minimum": 1,
            "maximum": 10000
          },
          "countryId": {
            "type": "number",
            "description": "The country of the school being created — the tenant does not exist yet, VAT is derived from this."
          }
        },
        "required": [
          "productTypeId",
          "countryId"
        ]
      },
      "BillingCheckoutTaxBreakdownDto": {
        "type": "object",
        "properties": {
          "subtotalCents": {
            "type": "number"
          },
          "discountCents": {
            "type": "number"
          },
          "taxCents": {
            "type": "number"
          },
          "totalCents": {
            "type": "number"
          },
          "taxPercent": {
            "type": "number",
            "nullable": true,
            "default": null
          },
          "currency": {
            "type": "string"
          }
        },
        "required": [
          "subtotalCents",
          "discountCents",
          "taxCents",
          "totalCents",
          "taxPercent",
          "currency"
        ]
      },
      "OnboardingCheckoutPreviewDtoData": {
        "type": "object",
        "properties": {
          "discountPercent": {
            "type": "number"
          },
          "breakdown": {
            "default": null,
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingCheckoutTaxBreakdownDto"
              },
              {
                "nullable": true
              }
            ]
          }
        },
        "required": [
          "discountPercent",
          "breakdown"
        ]
      },
      "OnboardingCheckoutPreviewResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/OnboardingCheckoutPreviewDtoData"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "OnboardingCheckoutSessionDto": {
        "type": "object",
        "properties": {
          "referralCode": {
            "type": "string",
            "description": "Referral code captured before payment and attributed after successful onboarding.",
            "pattern": "^[A-Z0-9]{6,64}$",
            "example": "ABC123"
          },
          "tenantConfig": {
            "description": "The school configuration that will be used to create the tenant AFTER a successful payment.\nFully validated here, before any money moves; snapshotted on the server-side checkout draft.\nIsDefined + IsNotEmptyObject are required: ValidateNested alone silently skips a missing value.",
            "oneOf": [
              {
                "$ref": "#/components/schemas/CreateTenantDto"
              }
            ]
          },
          "productTypeId": {
            "type": "number",
            "description": "The product type id to buy (yearly billing only)"
          },
          "quantity": {
            "type": "number",
            "minimum": 1,
            "maximum": 10000
          },
          "draftId": {
            "type": "string",
            "description": "Draft to retry/update after a failed payment attempt; omitted on the first buy click.",
            "format": "uuid"
          },
          "expectedTotalCents": {
            "type": "number",
            "description": "The gross total the client displayed at the buy click. When the subscription's real invoice total\ndiffers, the response carries no client secret — displayed = charged is enforced server-side.",
            "minimum": 0
          },
          "expectedCurrency": {
            "type": "string",
            "description": "The currency the client displayed (lowercase ISO 4217). Guards the drift check's denomination:\nan equal cents number in a different currency must not pass."
          }
        },
        "required": [
          "tenantConfig",
          "productTypeId",
          "quantity"
        ]
      },
      "OnboardingCheckoutSessionDtoData": {
        "type": "object",
        "properties": {
          "draftId": {
            "type": "string"
          },
          "billingSubscriptionId": {
            "type": "string"
          },
          "clientSecret": {
            "type": "string",
            "nullable": true
          },
          "discountPercent": {
            "type": "number"
          },
          "breakdown": {
            "description": "The REAL totals of the subscription's first invoice — what the confirmed payment will charge.",
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingCheckoutTaxBreakdownDto"
              }
            ]
          }
        },
        "required": [
          "draftId",
          "billingSubscriptionId",
          "clientSecret",
          "discountPercent",
          "breakdown"
        ]
      },
      "OnboardingCheckoutSessionResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/OnboardingCheckoutSessionDtoData"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "OnboardingCheckoutCompleteDto": {
        "type": "object",
        "properties": {
          "draftId": {
            "type": "string",
            "format": "uuid"
          }
        },
        "required": [
          "draftId"
        ]
      },
      "OnboardingCheckoutCompletionState": {
        "type": "string",
        "enum": [
          "provisioned",
          "processing",
          "paymentFailed",
          "provisioningFailed"
        ]
      },
      "OnboardingCheckoutCompleteDtoData": {
        "type": "object",
        "properties": {
          "state": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/OnboardingCheckoutCompletionState"
              }
            ]
          },
          "tenant": {
            "default": null,
            "oneOf": [
              {
                "$ref": "#/components/schemas/TenantWithDemoClassDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "billingSubscriptionId": {
            "type": "string",
            "nullable": true,
            "default": null
          }
        },
        "required": [
          "state",
          "tenant",
          "billingSubscriptionId"
        ]
      },
      "OnboardingCheckoutCompleteResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/OnboardingCheckoutCompleteDtoData"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "OnboardingCheckoutPendingDtoData": {
        "type": "object",
        "properties": {
          "draftId": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "draftId"
        ]
      },
      "OnboardingCheckoutPendingResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/OnboardingCheckoutPendingDtoData"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "OnboardingCheckoutDraftStatus": {
        "type": "string",
        "enum": [
          "pendingPayment",
          "provisioned",
          "provisioningFailed"
        ]
      },
      "OnboardingCheckoutStatusDtoData": {
        "type": "object",
        "properties": {
          "status": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/OnboardingCheckoutDraftStatus"
              }
            ]
          },
          "tenantConfig": {
            "description": "The school configuration snapshot — used to restore the checkout UI after a 3DS redirect.",
            "oneOf": [
              {
                "$ref": "#/components/schemas/CreateTenantDto"
              }
            ]
          },
          "productTypeId": {
            "type": "number"
          },
          "quantity": {
            "type": "number"
          }
        },
        "required": [
          "status",
          "tenantConfig",
          "productTypeId",
          "quantity"
        ]
      },
      "OnboardingCheckoutStatusResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/OnboardingCheckoutStatusDtoData"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "OnboardingCheckoutDraftDto": {
        "type": "object",
        "properties": {
          "status": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/OnboardingCheckoutDraftStatus"
              }
            ]
          },
          "product": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/Product"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "uuid": {
            "type": "string"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "schoolName": {
            "type": "string",
            "nullable": true
          },
          "countryId": {
            "type": "number",
            "nullable": true
          },
          "quantity": {
            "type": "number"
          },
          "discountPercent": {
            "type": "number"
          },
          "userId": {
            "type": "number"
          },
          "userEmail": {
            "type": "string"
          },
          "tenantId": {
            "type": "number",
            "nullable": true
          },
          "lastError": {
            "type": "string",
            "nullable": true
          },
          "stripeCustomerId": {
            "type": "string",
            "nullable": true
          },
          "stripeSubscriptionId": {
            "type": "string",
            "nullable": true
          },
          "stripeCustomerUrl": {
            "type": "string",
            "nullable": true
          },
          "stripeSubscriptionUrl": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "status",
          "product",
          "id",
          "uuid",
          "createdAt",
          "updatedAt",
          "schoolName",
          "countryId",
          "quantity",
          "discountPercent",
          "userId",
          "userEmail",
          "tenantId",
          "lastError",
          "stripeCustomerId",
          "stripeSubscriptionId",
          "stripeCustomerUrl",
          "stripeSubscriptionUrl"
        ]
      },
      "OnboardingCheckoutDraftPaginatedResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/OnboardingCheckoutDraftDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "OnboardingCheckoutDraftResolutionOutcome": {
        "type": "string",
        "enum": [
          "provisioned",
          "notPaid",
          "failed",
          "discarded",
          "refused"
        ]
      },
      "OnboardingCheckoutDraftResolutionDtoData": {
        "type": "object",
        "properties": {
          "outcome": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/OnboardingCheckoutDraftResolutionOutcome"
              }
            ]
          },
          "reason": {
            "type": "string",
            "nullable": true
          },
          "tenantId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "outcome",
          "reason",
          "tenantId"
        ]
      },
      "OnboardingCheckoutDraftResolutionResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/OnboardingCheckoutDraftResolutionDtoData"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "EReferralEventType": {
        "type": "string",
        "enum": [
          "REFERRAL_ACCEPTED",
          "REFERRER_REWARDED",
          "REFERRED_TENANT_REGISTERED",
          "REFERRED_TENANT_SUBSCRIBED",
          "DISCOUNT_REDEEMED",
          "DISCOUNT_GRANTED"
        ]
      },
      "ProviderReferralUserDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "email": {
            "type": "string"
          },
          "firstName": {
            "type": "string",
            "nullable": true
          },
          "lastName": {
            "type": "string",
            "nullable": true
          },
          "avatar": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "id",
          "email",
          "firstName",
          "lastName",
          "avatar"
        ]
      },
      "ProviderReferralEventDto": {
        "type": "object",
        "properties": {
          "type": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/EReferralEventType"
              }
            ]
          },
          "tenant": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/TenantShortDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "person": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ProviderReferralUserDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "id": {
            "type": "string"
          },
          "happenedAt": {
            "format": "date-time",
            "type": "string"
          },
          "percentDelta": {
            "type": "number",
            "nullable": true,
            "description": "How much the event changed the referrer's balance; 0 for a reward while the balance was at the maximum."
          },
          "note": {
            "type": "string",
            "nullable": true,
            "description": "Support's reason for a granted discount."
          }
        },
        "required": [
          "type",
          "tenant",
          "person",
          "id",
          "happenedAt",
          "percentDelta",
          "note"
        ]
      },
      "ProviderTenantReferralDto": {
        "type": "object",
        "properties": {
          "availablePercent": {
            "type": "number"
          },
          "events": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ProviderReferralEventDto"
            }
          }
        },
        "required": [
          "availablePercent",
          "events"
        ]
      },
      "ProviderTenantReferralResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/ProviderTenantReferralDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "ProviderGrantReferralDiscountDto": {
        "type": "object",
        "properties": {
          "percent": {
            "type": "number",
            "minimum": 10,
            "maximum": 50
          },
          "note": {
            "type": "string",
            "maxLength": 200
          }
        },
        "required": [
          "percent"
        ]
      },
      "CompetenceScoreDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "description": {
            "type": "string"
          },
          "avgScore": {
            "type": "number"
          },
          "avgLevel": {
            "type": "number"
          },
          "performanceLevelLevel": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "id",
          "description",
          "avgScore",
          "avgLevel"
        ]
      },
      "CompetenceDomainScoreDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "symbol": {
            "type": "string"
          },
          "avgScore": {
            "type": "number"
          },
          "avgLevel": {
            "type": "number"
          },
          "schoolSubjectId": {
            "type": "number",
            "nullable": true
          },
          "competences": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CompetenceScoreDto"
            }
          },
          "performanceLevelLevel": {
            "type": "number"
          }
        },
        "required": [
          "id",
          "name",
          "symbol",
          "avgScore",
          "avgLevel",
          "schoolSubjectId",
          "competences"
        ]
      },
      "SubjectScoreDto": {
        "type": "object",
        "properties": {
          "subjectId": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "abbreviation": {
            "type": "string"
          },
          "color": {
            "type": "string"
          },
          "avgScore": {
            "type": "number"
          },
          "avgLevel": {
            "type": "number"
          },
          "competenceDomains": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CompetenceDomainScoreDto"
            }
          }
        },
        "required": [
          "subjectId",
          "name",
          "abbreviation",
          "color",
          "avgScore",
          "avgLevel",
          "competenceDomains"
        ]
      },
      "StudentSubjectScoreDto": {
        "type": "object",
        "properties": {
          "studentId": {
            "type": "number"
          },
          "firstName": {
            "type": "string"
          },
          "lastName": {
            "type": "string"
          },
          "avatar": {
            "type": "string",
            "nullable": true
          },
          "avatarPictureId": {
            "type": "number",
            "nullable": true,
            "description": "File id of the uploaded avatar picture; resolve the signed url via GET /files/:id/url"
          },
          "subjectScores": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SubjectScoreDto"
            }
          }
        },
        "required": [
          "studentId",
          "firstName",
          "lastName",
          "avatar",
          "avatarPictureId",
          "subjectScores"
        ]
      },
      "ClassSubjectScoresResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/StudentSubjectScoreDto"
            }
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "StatisticsCountCalculationTypeDto": {
        "type": "object",
        "properties": {
          "allHistoricalEntries": {
            "type": "number"
          },
          "lastHistoricalEntry": {
            "type": "number"
          }
        },
        "required": [
          "allHistoricalEntries",
          "lastHistoricalEntry"
        ]
      },
      "ClassSubjectScoresCountDto": {
        "type": "object",
        "properties": {
          "firstSemester": {
            "$ref": "#/components/schemas/StatisticsCountCalculationTypeDto"
          },
          "secondSemester": {
            "$ref": "#/components/schemas/StatisticsCountCalculationTypeDto"
          },
          "schoolYear": {
            "$ref": "#/components/schemas/StatisticsCountCalculationTypeDto"
          }
        },
        "required": [
          "firstSemester",
          "secondSemester",
          "schoolYear"
        ]
      },
      "ClassSubjectScoresCountResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/ClassSubjectScoresCountDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "AccountDeactivationFeedbackStatusResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "hasSubmitted": {
            "type": "boolean"
          }
        },
        "required": [
          "success",
          "hasSubmitted"
        ]
      },
      "UserFeedbackCategory": {
        "type": "string",
        "enum": [
          "starRating",
          "subscriptionTooExpensive",
          "missingFeatures",
          "underUsed",
          "preferFreeVersion",
          "accountDeactivation"
        ]
      },
      "UserFeedbackEntity": {
        "type": "string",
        "enum": [
          "performanceAssessmentEntry",
          "competenceEntry",
          "report"
        ]
      },
      "CreateUserFeedbackDto": {
        "type": "object",
        "properties": {
          "category": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserFeedbackCategory"
              }
            ]
          },
          "entity": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserFeedbackEntity"
              }
            ]
          },
          "rating": {
            "type": "number",
            "minimum": 1,
            "maximum": 5
          },
          "message": {
            "type": "string",
            "maxLength": 2000
          },
          "userAgent": {
            "type": "string",
            "maxLength": 1000
          },
          "appVersion": {
            "type": "string",
            "maxLength": 50
          },
          "source": {
            "type": "string",
            "maxLength": 255
          },
          "entityCount": {
            "type": "number",
            "minimum": 1
          }
        },
        "required": [
          "category",
          "source"
        ]
      },
      "UserFeedbackDto": {
        "type": "object",
        "properties": {
          "category": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserFeedbackCategory"
              }
            ]
          },
          "entity": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserFeedbackEntity"
              },
              {
                "nullable": true
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "rating": {
            "type": "number",
            "nullable": true
          },
          "message": {
            "type": "string",
            "nullable": true
          },
          "userAgent": {
            "type": "string",
            "nullable": true
          },
          "appVersion": {
            "type": "string",
            "nullable": true
          },
          "source": {
            "type": "string"
          },
          "entityCount": {
            "type": "number",
            "nullable": true
          },
          "handledAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "category",
          "entity",
          "id",
          "createdAt",
          "updatedAt",
          "rating",
          "message",
          "userAgent",
          "appVersion",
          "source",
          "entityCount",
          "handledAt"
        ]
      },
      "UserFeedbackResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/UserFeedbackDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateUserFeedbackDto": {
        "type": "object",
        "properties": {
          "category": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserFeedbackCategory"
              }
            ]
          },
          "entity": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserFeedbackEntity"
              }
            ]
          },
          "rating": {
            "type": "number",
            "minimum": 1,
            "maximum": 5
          },
          "message": {
            "type": "string",
            "maxLength": 2000
          },
          "userAgent": {
            "type": "string",
            "maxLength": 1000
          },
          "appVersion": {
            "type": "string",
            "maxLength": 50
          },
          "source": {
            "type": "string",
            "maxLength": 255
          },
          "entityCount": {
            "type": "number",
            "minimum": 1
          }
        }
      },
      "DetailedUserFeedbackDto": {
        "type": "object",
        "properties": {
          "category": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserFeedbackCategory"
              }
            ]
          },
          "entity": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserFeedbackEntity"
              },
              {
                "nullable": true
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "rating": {
            "type": "number",
            "nullable": true
          },
          "message": {
            "type": "string",
            "nullable": true
          },
          "userAgent": {
            "type": "string",
            "nullable": true
          },
          "appVersion": {
            "type": "string",
            "nullable": true
          },
          "source": {
            "type": "string"
          },
          "entityCount": {
            "type": "number",
            "nullable": true
          },
          "handledAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "createdBy": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserDataDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "currentTenant": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/TenantDto"
              },
              {
                "nullable": true
              }
            ]
          }
        },
        "required": [
          "category",
          "entity",
          "id",
          "createdAt",
          "updatedAt",
          "rating",
          "message",
          "userAgent",
          "appVersion",
          "source",
          "entityCount",
          "handledAt",
          "createdBy",
          "currentTenant"
        ]
      },
      "UserFeedbackDetailedResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/DetailedUserFeedbackDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "ShouldUserSeeRatingPromptEligibleEntityDto": {
        "type": "object",
        "properties": {
          "entity": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserFeedbackEntity"
              }
            ]
          },
          "entityCount": {
            "type": "number"
          }
        }
      },
      "UserShouldSeeRatingPromptResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "showPrompt": {
            "type": "boolean"
          },
          "eligibleEntities": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ShouldUserSeeRatingPromptEligibleEntityDto"
            }
          }
        },
        "required": [
          "success",
          "showPrompt"
        ]
      },
      "PaginatedUserFeedbackResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/UserFeedbackDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "SetUserFeedbackHandledDto": {
        "type": "object",
        "properties": {
          "handled": {
            "type": "boolean"
          }
        },
        "required": [
          "handled"
        ]
      },
      "FileMalwareScanStatus": {
        "type": "string",
        "enum": [
          "pending",
          "clean",
          "threatsFound",
          "unsupported",
          "accessDenied",
          "failed",
          "unavailable",
          "legacy",
          "notRequired"
        ]
      },
      "FileUrlDto": {
        "type": "object",
        "properties": {
          "url": {
            "type": "string",
            "nullable": true,
            "description": "Signed bucket URL or authenticated uploader preview; null until delivery is permitted."
          },
          "malwareScanStatus": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/FileMalwareScanStatus"
              }
            ]
          },
          "expiresAt": {
            "format": "date-time",
            "type": "string"
          },
          "retryAfterSeconds": {
            "type": "number"
          }
        },
        "required": [
          "url",
          "malwareScanStatus",
          "expiresAt"
        ]
      },
      "FileUrlResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/FileUrlDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "FileMonitoringAttemptDto": {
        "type": "object",
        "properties": {
          "delaySeconds": {
            "type": "number",
            "nullable": true,
            "description": "Current wait before this check; null identifies hourly recovery."
          },
          "attempt": {
            "type": "number"
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "delaySeconds",
          "attempt",
          "count"
        ]
      },
      "FileMonitoringCountDto": {
        "type": "object",
        "properties": {
          "key": {
            "type": "string"
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "key",
          "count"
        ]
      },
      "FileMonitoringSizeDto": {
        "type": "object",
        "properties": {
          "lowerBytes": {
            "type": "number",
            "nullable": true,
            "description": "Exclusive lower bound; null for the zero-byte bucket."
          },
          "upperBytes": {
            "type": "number",
            "nullable": true,
            "description": "Inclusive upper bound; null for the final, open-ended bucket."
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "lowerBytes",
          "upperBytes",
          "count"
        ]
      },
      "FileMonitoringDto": {
        "type": "object",
        "properties": {
          "generatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "totalCount": {
            "type": "number"
          },
          "totalBytes": {
            "type": "number"
          },
          "scanAttempts": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/FileMonitoringAttemptDto"
            }
          },
          "scanStatuses": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/FileMonitoringCountDto"
            }
          },
          "storageCategories": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/FileMonitoringCountDto"
            }
          },
          "purposes": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/FileMonitoringCountDto"
            }
          },
          "contentTypes": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/FileMonitoringCountDto"
            }
          },
          "sizes": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/FileMonitoringSizeDto"
            }
          }
        },
        "required": [
          "generatedAt",
          "totalCount",
          "totalBytes",
          "scanAttempts",
          "scanStatuses",
          "storageCategories",
          "purposes",
          "contentTypes",
          "sizes"
        ]
      },
      "FileMonitoringResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/FileMonitoringDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "FileUploadType": {
        "type": "string",
        "enum": [
          "userAvatar",
          "studentAvatar",
          "tenantLogo",
          "externalMaterialLogo",
          "performanceLevelPicture",
          "reportCoverImage",
          "releaseImage",
          "entityAppearanceImage",
          "entryAttachment",
          "thumbnail"
        ]
      },
      "InitiateFileUploadDto": {
        "type": "object",
        "properties": {
          "type": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/FileUploadType"
              }
            ]
          },
          "checksumSha256": {
            "type": "string",
            "pattern": "^[A-Za-z0-9+/]{43}=$"
          },
          "filename": {
            "type": "string",
            "minLength": 1,
            "maxLength": 255
          },
          "byteSize": {
            "type": "number",
            "minimum": 1
          }
        },
        "required": [
          "type",
          "checksumSha256",
          "filename",
          "byteSize"
        ]
      },
      "FileUploadPermitDto": {
        "type": "object",
        "properties": {
          "fields": {
            "type": "object",
            "additionalProperties": {
              "type": "string"
            }
          },
          "uploadId": {
            "type": "number"
          },
          "url": {
            "type": "string"
          },
          "postExpiresAt": {
            "format": "date-time",
            "type": "string"
          },
          "expiresAt": {
            "format": "date-time",
            "type": "string"
          }
        },
        "required": [
          "fields",
          "uploadId",
          "url",
          "postExpiresAt",
          "expiresAt"
        ]
      },
      "FileUploadPermitResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/FileUploadPermitDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "CompleteFileUploadDto": {
        "type": "object",
        "properties": {
          "thumbnailFileId": {
            "type": "number",
            "description": "A completed, unlinked upload of type thumbnail; an unusable thumbnail is ignored.",
            "minimum": 1
          }
        }
      },
      "UploadedFileDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "contentType": {
            "type": "string"
          },
          "byteSize": {
            "type": "number"
          },
          "thumbnailFileId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "id",
          "name",
          "contentType",
          "byteSize",
          "thumbnailFileId"
        ]
      },
      "FileUploadResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/UploadedFileDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "AsyncOperationStatus": {
        "type": "string",
        "enum": [
          "queued",
          "running",
          "failed",
          "completed",
          "cancelled"
        ]
      },
      "ErrorTypes": {
        "type": "string",
        "enum": [
          "UNKNOWN",
          "NOT_IMPLEMENTED",
          "INVALID_TOKEN",
          "INVALID_LOGIN",
          "INVALID_PARAMETERS",
          "TOO_MANY_REQUESTS",
          "FILE_SIZE_LIMIT_EXCEEDED",
          "FILE_TYPE_INVALID",
          "VALIDATION_FAILED",
          "FILE_VALIDATION_FAILED",
          "FILE_EMPTY",
          "FILE_NAME_INVALID",
          "STORAGE_LIMIT_EXCEEDED",
          "IMPORT_FAILED",
          "EMPTY_DTO",
          "NO_PERMISSION",
          "FEATURE_DISABLED",
          "PERFORMANCE_ASSESSMENT_SUBJECT_ACCESS_DENIED",
          "COMPETENCE_ASSESSMENT_SUBJECT_ACCESS_DENIED",
          "NOT_FOUND",
          "INVALID_PASSWORD_RESET_CODE",
          "PASSWORD_RESET_MAIL_ALREADY_SENT",
          "USER_ALREADY_EXISTS",
          "SCHOOL_YEAR_ALREADY_EXISTS",
          "SCHOOL_CLASS_ALREADY_ASSIGNED_TO_YEAR",
          "INVALID_SCHOOL_YEAR",
          "UNKNOWN_REGISTRATION",
          "INVALID_IMPLICIT_DELETION",
          "INVALID_USER_INVITATION",
          "INVITATION_RECIPIENT_DEACTIVATED",
          "TENANT_ALREADY_EXISTS",
          "TEMPLATE_SET_ALREADY_EXISTS",
          "TOO_MANY_LEVELS",
          "EMAIL_COOLDOWN_ACTIVE",
          "INVALID_INVITATION_CODE",
          "GET_FILE_ERROR",
          "FILE_ALREADY_EXISTS",
          "STUDENT_NO_SUBJECT_RELATION",
          "EMAIL_CHANGE_MAIL_ALREADY_SENT",
          "INVALID_EMAIL_CHANGE_CODE",
          "PASSWORD_MISMATCH",
          "FOREIGN_KEY_CONSTRAINT",
          "CLASS_HAS_STILL_STUDENTS",
          "REPORT_ALREADY_COMPLETED",
          "REPORT_COVER_IMAGE_MISSING",
          "REPORT_NO_CLASS_ASSOCIATION",
          "TENANT_NOT_CONNECTED_TO_STATE",
          "SCHOOL_YEAR_IN_USE",
          "CLASS_ALREADY_ARCHIVED",
          "RELEASE_ID_ALREADY_EXISTS",
          "PLAN_UPGRADE_REQUIRED",
          "CONTACT_OWNER_TO_UPGRADE",
          "MISSING_TENANT_ID",
          "BILLING_PRODUCT_ALREADY_EXISTS",
          "BILLING_CHECKOUT_BLOCKED",
          "DEMO_CLASS_COPY_FAILED",
          "PDFGEN_TIMEOUT_ERROR",
          "PDFGEN_FAILED_REQUEST",
          "PDFGEN_GENERIC_ERROR",
          "PDFGEN_FILE_SCAN_PENDING",
          "PDFGEN_FILES_BLOCKED",
          "INVALID_REFERRAL_CODE",
          "REFERRAL_ALREADY_ATTRIBUTED",
          "REFERRAL_GRANT_EXCEEDS_MAXIMUM",
          "REFERRAL_NOT_ELIGIBLE",
          "REFERRAL_SELF_REFERRAL",
          "WEEKLY_REPORT_FAILED",
          "USER_DEACTIVATED",
          "LOCAL_AUTH_PROVIDER_NEEDED"
        ]
      },
      "AsyncOperationStatusDto": {
        "type": "object",
        "properties": {
          "status": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/AsyncOperationStatus"
              }
            ]
          },
          "errorType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ErrorTypes"
              },
              {
                "nullable": true
              }
            ]
          },
          "uuid": {
            "type": "string"
          },
          "attempts": {
            "type": "number"
          },
          "result": {
            "type": "object",
            "nullable": true
          },
          "error": {
            "type": "string",
            "nullable": true
          },
          "failedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          }
        },
        "required": [
          "status",
          "errorType",
          "uuid",
          "attempts",
          "result",
          "error",
          "failedAt",
          "createdAt"
        ]
      },
      "AsyncOperationStatusResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/AsyncOperationStatusDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "EMailType": {
        "type": "string",
        "enum": [
          "PasswordReset",
          "NoLocalLoginInfo",
          "UserAlreadyExists",
          "SetPassword",
          "StartTrial",
          "UserInvitation",
          "NonExistingUserInvitation",
          "UserAssignedToClass",
          "UserAssignedToGroup",
          "EmailChangeRequest",
          "LoginVerification",
          "TwoFactorReminder",
          "ReleaseNote",
          "UserApproved",
          "TransferOwnershipInvitation",
          "TrialEnding",
          "TrialEnded",
          "BasePlanDowngrade",
          "SubscriptionWelcome",
          "TrialFirstEntryOverdue",
          "TrialCreateClassOverdue",
          "TrialSchoolSetupOverdue",
          "TrialFirstEntryDone",
          "TrialDecision",
          "WeeklyReport",
          "TeamMemberDeactivated",
          "OnboardingReminder",
          "OfferExpiring"
        ]
      },
      "EmailStatus": {
        "type": "string",
        "enum": [
          "sending",
          "success",
          "error"
        ]
      },
      "DeliveryState": {
        "type": "string",
        "enum": [
          "delivered",
          "bounced",
          "complained",
          "delayed",
          "rejected"
        ]
      },
      "ProviderEmailDto": {
        "type": "object",
        "properties": {
          "status": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/EmailStatus"
              }
            ]
          },
          "deliveryState": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/DeliveryState"
              },
              {
                "nullable": true
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "email": {
            "type": "string"
          },
          "type": {
            "type": "string",
            "nullable": true
          },
          "deliveryStateAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "status",
          "deliveryState",
          "id",
          "createdAt",
          "email",
          "type",
          "deliveryStateAt"
        ]
      },
      "ProviderEmailRecipientDto": {
        "type": "object",
        "properties": {
          "emails": {
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "id": {
            "type": "number"
          },
          "email": {
            "type": "string"
          },
          "firstName": {
            "type": "string",
            "nullable": true
          },
          "lastName": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "emails",
          "id",
          "email",
          "firstName",
          "lastName"
        ]
      },
      "ProviderEmailsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ProviderEmailDto"
            }
          },
          "user": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ProviderEmailRecipientDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "user",
          "count"
        ]
      },
      "EmailAuditMetadataKey": {
        "type": "string",
        "enum": [
          "userId",
          "targetUserId",
          "invitedById",
          "targetClassId",
          "tenantId",
          "billingSubscriptionId"
        ]
      },
      "ProviderEmailMetadataDto": {
        "type": "object",
        "properties": {
          "key": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/EmailAuditMetadataKey"
              }
            ]
          },
          "value": {
            "type": "string"
          }
        },
        "required": [
          "key",
          "value"
        ]
      },
      "ProviderEmailUserDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "email": {
            "type": "string"
          },
          "firstName": {
            "type": "string",
            "nullable": true
          },
          "lastName": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "id",
          "email",
          "firstName",
          "lastName"
        ]
      },
      "ProviderEmailDetailDto": {
        "type": "object",
        "properties": {
          "status": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/EmailStatus"
              }
            ]
          },
          "deliveryState": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/DeliveryState"
              },
              {
                "nullable": true
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "email": {
            "type": "string"
          },
          "type": {
            "type": "string",
            "nullable": true
          },
          "deliveryStateAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "messageId": {
            "type": "string",
            "nullable": true
          },
          "providerMessageId": {
            "type": "string",
            "nullable": true
          },
          "error": {
            "type": "string",
            "nullable": true
          },
          "deliveryDetail": {
            "type": "string",
            "nullable": true
          },
          "metadata": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ProviderEmailMetadataDto"
            }
          },
          "recipientId": {
            "type": "number",
            "nullable": true
          },
          "senderId": {
            "type": "number",
            "nullable": true
          },
          "deactivatedMemberId": {
            "type": "number",
            "nullable": true
          },
          "recipient": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ProviderEmailUserDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "sender": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ProviderEmailUserDto"
              },
              {
                "nullable": true
              }
            ]
          }
        },
        "required": [
          "status",
          "deliveryState",
          "id",
          "createdAt",
          "email",
          "type",
          "deliveryStateAt",
          "messageId",
          "providerMessageId",
          "error",
          "deliveryDetail",
          "metadata",
          "recipientId",
          "senderId",
          "deactivatedMemberId",
          "recipient",
          "sender"
        ]
      },
      "ProviderEmailResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/ProviderEmailDetailDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "GetAuthAttemptStatusDto": {
        "type": "object",
        "properties": {
          "secret": {
            "type": "string"
          }
        },
        "required": [
          "secret"
        ]
      },
      "RedeemAuthAttemptDto": {
        "type": "object",
        "properties": {
          "secret": {
            "type": "string"
          },
          "sameDeviceVerificationCode": {
            "type": "string"
          }
        },
        "required": [
          "secret",
          "sameDeviceVerificationCode"
        ]
      },
      "LocalLoginDto": {
        "type": "object",
        "properties": {
          "userIdentifier": {
            "type": "string"
          },
          "password": {
            "type": "string"
          },
          "redirectUri": {
            "type": "object"
          }
        },
        "required": [
          "userIdentifier",
          "password",
          "redirectUri"
        ]
      },
      "AuthAttemptStatus": {
        "type": "string",
        "enum": [
          "init",
          "tfaRequired",
          "successForSameDevice",
          "successForAllDevices",
          "failed",
          "used",
          "expired"
        ]
      },
      "TfaOption": {
        "type": "string",
        "enum": [
          "totp",
          "webauthn",
          "email-otp"
        ]
      },
      "AuthAttemptDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string"
          },
          "secret": {
            "type": "string"
          }
        },
        "required": [
          "id",
          "secret"
        ]
      },
      "LocalLoginResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean"
          },
          "status": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/AuthAttemptStatus"
              }
            ]
          },
          "tfaOptions": {
            "type": "array",
            "example": [
              "totp"
            ],
            "items": {
              "$ref": "#/components/schemas/TfaOption"
            }
          },
          "webauthnAuthenticationOptions": {
            "type": "object"
          },
          "csrfToken": {
            "type": "string"
          },
          "redirectUri": {
            "type": "string"
          },
          "authAttempt": {
            "$ref": "#/components/schemas/AuthAttemptDto"
          }
        },
        "required": [
          "success",
          "status",
          "tfaOptions",
          "webauthnAuthenticationOptions",
          "csrfToken",
          "redirectUri",
          "authAttempt"
        ]
      },
      "TfaLoginDto": {
        "type": "object",
        "properties": {
          "tfaCode": {
            "type": "string"
          },
          "authAttempt": {
            "$ref": "#/components/schemas/AuthAttemptDto"
          }
        },
        "required": [
          "tfaCode",
          "authAttempt"
        ]
      },
      "TfaLoginResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean"
          },
          "status": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/AuthAttemptStatus"
              }
            ]
          },
          "csrfToken": {
            "type": "string"
          },
          "redirectUri": {
            "type": "string"
          }
        },
        "required": [
          "success",
          "status",
          "csrfToken",
          "redirectUri"
        ]
      },
      "SendEmailOtpDto": {
        "type": "object",
        "properties": {
          "authAttempt": {
            "$ref": "#/components/schemas/AuthAttemptDto"
          }
        },
        "required": [
          "authAttempt"
        ]
      },
      "GrowthPopupVariant": {
        "type": "string",
        "enum": [
          "popups",
          "checklist_only"
        ]
      },
      "AccessRightDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "schoolClassId": {
            "type": "number"
          },
          "permissions": {
            "$ref": "#/components/schemas/AccessRightPermissionsDto"
          }
        },
        "required": [
          "id",
          "createdAt",
          "updatedAt",
          "schoolClassId",
          "permissions"
        ]
      },
      "UserRoleWithTenantMetaDataDto": {
        "type": "object",
        "properties": {
          "roleType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserRoleType"
              }
            ]
          },
          "status": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserRoleStatus"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "tenantId": {
            "type": "number"
          },
          "isMaintenanceRole": {
            "type": "boolean"
          },
          "isSingleUserTenant": {
            "type": "boolean"
          },
          "tenant": {
            "$ref": "#/components/schemas/TenantDto"
          },
          "accessRights": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/AccessRightDto"
            }
          }
        },
        "required": [
          "roleType",
          "status",
          "id",
          "createdAt",
          "updatedAt",
          "tenantId",
          "isMaintenanceRole",
          "isSingleUserTenant",
          "tenant",
          "accessRights"
        ]
      },
      "WhoAmIDataDto": {
        "type": "object",
        "properties": {
          "source": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserSource"
              },
              {
                "nullable": true
              }
            ]
          },
          "nameRepresentation": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/NameRepresentation"
              }
            ]
          },
          "nameSortation": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/NameSortation"
              }
            ]
          },
          "weekRepresentation": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/WeekRepresentation"
              }
            ]
          },
          "growthPopupVariant": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/GrowthPopupVariant"
              },
              {
                "nullable": true
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "email": {
            "type": "string"
          },
          "firstName": {
            "type": "string",
            "nullable": true
          },
          "lastName": {
            "type": "string",
            "nullable": true
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "avatar": {
            "type": "string",
            "nullable": true
          },
          "avatarPictureId": {
            "type": "number",
            "nullable": true,
            "description": "File id of the uploaded avatar picture; resolve the signed url via GET /files/:id/url"
          },
          "sourceOther": {
            "type": "string",
            "nullable": true
          },
          "isSetupCompleted": {
            "type": "boolean"
          },
          "classSetupTooltipSeen": {
            "type": "boolean"
          },
          "teamSetupTooltipSeen": {
            "type": "boolean"
          },
          "classSelectorTooltipSeen": {
            "type": "boolean"
          },
          "studentOverviewPerformanceAssessmentTooltipSeen": {
            "type": "boolean"
          },
          "currentTenantId": {
            "type": "number",
            "nullable": true
          },
          "userRoles": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/UserRoleWithTenantMetaDataDto"
            }
          },
          "isApproved": {
            "type": "boolean"
          },
          "countryId": {
            "type": "number",
            "nullable": true
          },
          "stateId": {
            "type": "number",
            "nullable": true
          },
          "demoClassWizardSeen": {
            "type": "boolean"
          },
          "ratingDialogSeenAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "newsletterActive": {
            "type": "boolean"
          },
          "weeklyReportActive": {
            "type": "boolean"
          },
          "twoFactorRequiredUntil": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "deactivatedAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "hasLocalLoginEntity": {
            "type": "boolean"
          },
          "language": {
            "type": "string",
            "nullable": true,
            "description": "Base language preference; null = never explicitly set"
          }
        },
        "required": [
          "source",
          "nameRepresentation",
          "nameSortation",
          "weekRepresentation",
          "growthPopupVariant",
          "id",
          "email",
          "firstName",
          "lastName",
          "createdAt",
          "updatedAt",
          "avatar",
          "avatarPictureId",
          "sourceOther",
          "isSetupCompleted",
          "classSetupTooltipSeen",
          "teamSetupTooltipSeen",
          "classSelectorTooltipSeen",
          "studentOverviewPerformanceAssessmentTooltipSeen",
          "currentTenantId",
          "userRoles",
          "isApproved",
          "countryId",
          "stateId",
          "demoClassWizardSeen",
          "ratingDialogSeenAt",
          "newsletterActive",
          "weeklyReportActive",
          "twoFactorRequiredUntil",
          "deactivatedAt",
          "hasLocalLoginEntity",
          "language"
        ]
      },
      "WhoAmIResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/WhoAmIDataDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "AttributionLandingDto": {
        "type": "object",
        "properties": {
          "hostname": {
            "type": "string"
          },
          "pathname": {
            "type": "string"
          }
        },
        "required": [
          "hostname",
          "pathname"
        ]
      },
      "AttributionUtmDto": {
        "type": "object",
        "properties": {
          "source": {
            "type": "string"
          },
          "medium": {
            "type": "string"
          },
          "campaign": {
            "type": "string"
          },
          "term": {
            "type": "string"
          },
          "content": {
            "type": "string"
          }
        }
      },
      "AttributionFirstTouchDto": {
        "type": "object",
        "properties": {
          "clickIdKeys": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ClickIdKey"
            }
          },
          "capturedAt": {
            "type": "number",
            "description": "Unix epoch milliseconds"
          },
          "landing": {
            "$ref": "#/components/schemas/AttributionLandingDto"
          },
          "referrerHostname": {
            "type": "string"
          },
          "utm": {
            "$ref": "#/components/schemas/AttributionUtmDto"
          }
        },
        "required": [
          "clickIdKeys",
          "capturedAt",
          "landing",
          "utm"
        ]
      },
      "AttributionClickIdDto": {
        "type": "object",
        "properties": {
          "value": {
            "type": "string"
          },
          "capturedAt": {
            "type": "number",
            "description": "Unix epoch milliseconds"
          }
        },
        "required": [
          "value",
          "capturedAt"
        ]
      },
      "AttributionClickIdsDto": {
        "type": "object",
        "properties": {
          "gclid": {
            "$ref": "#/components/schemas/AttributionClickIdDto"
          },
          "gbraid": {
            "$ref": "#/components/schemas/AttributionClickIdDto"
          },
          "wbraid": {
            "$ref": "#/components/schemas/AttributionClickIdDto"
          },
          "fbclid": {
            "$ref": "#/components/schemas/AttributionClickIdDto"
          },
          "msclkid": {
            "$ref": "#/components/schemas/AttributionClickIdDto"
          },
          "ttclid": {
            "$ref": "#/components/schemas/AttributionClickIdDto"
          }
        }
      },
      "AttributionSnapshotDto": {
        "type": "object",
        "properties": {
          "version": {
            "type": "number",
            "enum": [
              1
            ]
          },
          "firstTouch": {
            "$ref": "#/components/schemas/AttributionFirstTouchDto"
          },
          "clickIds": {
            "$ref": "#/components/schemas/AttributionClickIdsDto"
          }
        },
        "required": [
          "version",
          "firstTouch",
          "clickIds"
        ]
      },
      "LocalLoginRegisterDto": {
        "type": "object",
        "properties": {
          "language": {
            "type": "string",
            "description": "Base language preference at registration time",
            "pattern": "^[a-z]{2,3}$",
            "example": "de"
          },
          "email": {
            "type": "string"
          },
          "firstName": {
            "type": "string",
            "maxLength": 100
          },
          "lastName": {
            "type": "string",
            "maxLength": 100
          },
          "newsletterActive": {
            "type": "boolean"
          },
          "invitationCode": {
            "type": "string",
            "description": "Optional invitation code - if the user has received an invitation and wants to register an account for this invitation, then we use this invitation code\ndirectly and the user skips the \"create a school\" onboarding",
            "maxLength": 1000
          },
          "registeredOnMobile": {
            "type": "boolean"
          },
          "attribution": {
            "$ref": "#/components/schemas/AttributionSnapshotDto"
          }
        },
        "required": [
          "email"
        ]
      },
      "SsoAuthProviderDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "type": {
            "type": "string"
          }
        },
        "required": [
          "id",
          "name",
          "type"
        ]
      },
      "SsoAuthProviderListResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SsoAuthProviderDto"
            }
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "ChangeUserRoleDto": {
        "type": "object",
        "properties": {
          "userRoleId": {
            "type": "number"
          }
        },
        "required": [
          "userRoleId"
        ]
      },
      "CreatePasswordResetCodeDto": {
        "type": "object",
        "properties": {
          "email": {
            "type": "string"
          }
        },
        "required": [
          "email"
        ]
      },
      "CheckPasswordResetCodeDto": {
        "type": "object",
        "properties": {
          "email": {
            "type": "string"
          },
          "code": {
            "type": "string"
          }
        },
        "required": [
          "email",
          "code"
        ]
      },
      "CheckPasswordValidityResponse": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "isValid": {
            "type": "boolean"
          }
        },
        "required": [
          "success",
          "isValid"
        ]
      },
      "UsePasswordResetCodeDto": {
        "type": "object",
        "properties": {
          "email": {
            "type": "string"
          },
          "code": {
            "type": "string"
          },
          "password": {
            "type": "string",
            "minLength": 6,
            "maxLength": 1000
          },
          "isFinishRegistration": {
            "type": "boolean"
          }
        },
        "required": [
          "email",
          "code",
          "password"
        ]
      },
      "PasswordResetResponse": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "csrfToken": {
            "type": "string"
          }
        },
        "required": [
          "success",
          "csrfToken"
        ]
      },
      "ChangePasswordDto": {
        "type": "object",
        "properties": {
          "currentPassword": {
            "type": "string"
          },
          "newPassword": {
            "type": "string",
            "minLength": 6,
            "maxLength": 1000
          }
        },
        "required": [
          "currentPassword",
          "newPassword"
        ]
      },
      "RequestEmailChangeDto": {
        "type": "object",
        "properties": {
          "currentPassword": {
            "type": "string",
            "maxLength": 1000
          },
          "newEmail": {
            "type": "string"
          }
        },
        "required": [
          "currentPassword",
          "newEmail"
        ]
      },
      "ConfirmEmailChangeDto": {
        "type": "object",
        "properties": {
          "code": {
            "type": "string"
          }
        },
        "required": [
          "code"
        ]
      },
      "SavePendingSsoAttributionDto": {
        "type": "object",
        "properties": {
          "secret": {
            "type": "string",
            "description": "Secret of the auth attempt returned when the SSO login started",
            "maxLength": 1000
          },
          "attribution": {
            "$ref": "#/components/schemas/AttributionSnapshotDto"
          }
        },
        "required": [
          "secret"
        ]
      },
      "VerifyInvitationCodeResponseDto": {
        "type": "object",
        "properties": {
          "valid": {
            "type": "boolean"
          },
          "tenantName": {
            "type": "string"
          },
          "existingUser": {
            "type": "boolean"
          },
          "message": {
            "type": "string"
          }
        },
        "required": [
          "valid"
        ]
      },
      "AcceptInvitationResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "userRoleId": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "userRoleId"
        ]
      },
      "TenantUserInvitationType": {
        "type": "string",
        "enum": [
          "userInvitation",
          "transferOwnershipInvitation"
        ]
      },
      "TenantUserInvitationDto": {
        "type": "object",
        "properties": {
          "type": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/TenantUserInvitationType"
              }
            ]
          },
          "userRoleType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/UserRoleType"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "activeUntil": {
            "format": "date-time",
            "type": "string"
          },
          "code": {
            "type": "string"
          },
          "used": {
            "type": "number",
            "description": "Amount of times this invitation has been used already."
          },
          "maximumUses": {
            "type": "number",
            "description": "Maximum number of time this invitation can be used.\nThe invitation is automatically inactive when used >= maximumUses"
          },
          "email": {
            "type": "string",
            "nullable": true,
            "description": "Target email of the invited user. May be null if only the code has been generated."
          },
          "acceptUrl": {
            "type": "string",
            "nullable": true,
            "description": "URL that can be used to accept the invitation."
          }
        },
        "required": [
          "type",
          "userRoleType",
          "id",
          "createdAt",
          "activeUntil",
          "code",
          "used",
          "maximumUses",
          "email",
          "acceptUrl"
        ]
      },
      "TenantUserInvitationsPaginatedDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/TenantUserInvitationDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "RenewInvitationDto": {
        "type": "object",
        "properties": {
          "email": {
            "type": "string"
          }
        },
        "required": [
          "email"
        ]
      },
      "NotificationType": {
        "type": "string",
        "enum": [
          "classInvite",
          "welcome",
          "general",
          "reportSubjectEditRequest",
          "reportSubjectCompleted",
          "newRelease"
        ]
      },
      "NotificationChannel": {
        "type": "string",
        "enum": [
          "inApp",
          "email"
        ]
      },
      "NotificationButtonDto": {
        "type": "object",
        "properties": {
          "text": {
            "type": "string"
          },
          "action": {
            "type": "string"
          }
        },
        "required": [
          "text",
          "action"
        ]
      },
      "SubjectMeta": {
        "type": "object",
        "properties": {
          "abbreviation": {
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "color": {
            "type": "string"
          }
        },
        "required": [
          "abbreviation",
          "name",
          "color"
        ]
      },
      "ReportMeta": {
        "type": "object",
        "properties": {
          "reportId": {
            "type": "number"
          },
          "title": {
            "type": "string"
          },
          "studentName": {
            "type": "string"
          },
          "subjects": {
            "minItems": 1,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SubjectMeta"
            }
          }
        },
        "required": [
          "reportId",
          "title",
          "studentName",
          "subjects"
        ]
      },
      "NotificationMetadataDto": {
        "type": "object",
        "properties": {
          "icon": {
            "type": "string"
          },
          "button": {
            "$ref": "#/components/schemas/NotificationButtonDto"
          },
          "inviter": {
            "type": "string"
          },
          "className": {
            "type": "string"
          },
          "classId": {
            "type": "number"
          },
          "reports": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ReportMeta"
            }
          },
          "reportGroupId": {
            "type": "number"
          },
          "subjectTeacher": {
            "type": "string"
          },
          "studentName": {
            "type": "string"
          },
          "reportTitle": {
            "type": "string"
          },
          "reportId": {
            "type": "number"
          },
          "subject": {
            "$ref": "#/components/schemas/SubjectMeta"
          },
          "releaseId": {
            "type": "string"
          }
        }
      },
      "NotificationDto": {
        "type": "object",
        "properties": {
          "type": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/NotificationType"
              }
            ]
          },
          "channel": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/NotificationChannel"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "title": {
            "type": "string"
          },
          "message": {
            "type": "string"
          },
          "isRead": {
            "type": "boolean"
          },
          "tenantId": {
            "type": "number",
            "nullable": true
          },
          "targetId": {
            "type": "number",
            "nullable": true
          },
          "metaData": {
            "$ref": "#/components/schemas/NotificationMetadataDto"
          },
          "sender": {
            "$ref": "#/components/schemas/UserDataDto"
          }
        },
        "required": [
          "type",
          "channel",
          "id",
          "createdAt",
          "title",
          "message",
          "isRead",
          "tenantId"
        ]
      },
      "PaginatedNotificationResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/NotificationDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "MarkNotificationsAsReadDto": {
        "type": "object",
        "properties": {
          "ids": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "ids"
        ]
      },
      "TemplateSetDto": {
        "type": "object",
        "properties": {
          "source": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/TemplateSetSource"
              }
            ]
          },
          "labelMode": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SchoolLevelLabelMode"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "label": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "version": {
            "type": "string"
          },
          "isDefault": {
            "type": "boolean"
          },
          "isCurrent": {
            "type": "boolean"
          },
          "countryId": {
            "type": "number"
          },
          "stateId": {
            "type": "number",
            "nullable": true
          },
          "schoolTypeId": {
            "type": "number",
            "nullable": true
          },
          "languageId": {
            "type": "number",
            "nullable": true
          },
          "schoolTypeAbbr": {
            "type": "string",
            "nullable": true
          },
          "schoolLevels": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "source",
          "labelMode",
          "id",
          "createdAt",
          "updatedAt",
          "name",
          "label",
          "description",
          "version",
          "isDefault",
          "isCurrent",
          "countryId",
          "stateId",
          "schoolTypeId",
          "languageId",
          "schoolTypeAbbr",
          "schoolLevels"
        ]
      },
      "PaginatedTemplateSetResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/TemplateSetDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "ResolvedTemplateSetResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/TemplateSetDto"
              },
              {
                "nullable": true
              }
            ]
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "TemplateSetUploadValidationDto": {
        "type": "object",
        "properties": {
          "schoolLevels": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "schoolLevels"
        ]
      },
      "TemplateSetUploadValidationResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/TemplateSetUploadValidationDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "IntersectionUploadTemplateSetDtoWithFile": {
        "type": "object",
        "properties": {
          "version": {
            "type": "string",
            "pattern": "^\\d{4}(-(0[1-9]|1[0-2]))?$",
            "example": "2026"
          },
          "source": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/TemplateSetSource"
              }
            ]
          },
          "file": {
            "type": "string",
            "format": "binary"
          },
          "countryId": {
            "type": "number"
          },
          "stateId": {
            "type": "number"
          },
          "schoolTypeId": {
            "type": "number"
          },
          "languageId": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "label": {
            "type": "string"
          },
          "description": {
            "type": "string"
          }
        },
        "required": [
          "version",
          "source",
          "file",
          "countryId",
          "schoolTypeId",
          "languageId",
          "name",
          "label"
        ]
      },
      "TemplateSetPdfPerformanceLevelDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "level": {
            "type": "number"
          },
          "picturePath": {
            "type": "string",
            "nullable": true
          },
          "pictureId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "id",
          "level",
          "picturePath",
          "pictureId"
        ]
      },
      "TemplateSetPdfPerformanceVisualDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "levels": {
            "type": "number"
          },
          "performanceLevelsV2": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/TemplateSetPdfPerformanceLevelDto"
            }
          }
        },
        "required": [
          "id",
          "name",
          "levels",
          "performanceLevelsV2"
        ]
      },
      "TemplateSetPdfCompetenceDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "description": {
            "type": "string"
          }
        },
        "required": [
          "id",
          "description"
        ]
      },
      "TemplateSetPdfDomainDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "symbol": {
            "type": "string"
          },
          "competences": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/TemplateSetPdfCompetenceDto"
            }
          }
        },
        "required": [
          "id",
          "name",
          "symbol",
          "competences"
        ]
      },
      "TemplateSetPdfSubjectDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "abbreviation": {
            "type": "string"
          },
          "color": {
            "type": "string"
          },
          "order": {
            "type": "number"
          },
          "competenceDomains": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/TemplateSetPdfDomainDto"
            }
          }
        },
        "required": [
          "id",
          "name",
          "abbreviation",
          "color",
          "order",
          "competenceDomains"
        ]
      },
      "TemplateSetPdfGroupDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "order": {
            "type": "number"
          },
          "subjects": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/TemplateSetPdfSubjectDto"
            }
          }
        },
        "required": [
          "id",
          "name",
          "order",
          "subjects"
        ]
      },
      "TemplateSetPdfPrintDataDto": {
        "type": "object",
        "properties": {
          "templateSetName": {
            "type": "string"
          },
          "templateSetLabel": {
            "type": "string"
          },
          "schoolLevel": {
            "type": "number"
          },
          "performanceVisual": {
            "$ref": "#/components/schemas/TemplateSetPdfPerformanceVisualDto"
          },
          "subjectGroups": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/TemplateSetPdfGroupDto"
            }
          }
        },
        "required": [
          "templateSetName",
          "templateSetLabel",
          "schoolLevel",
          "performanceVisual",
          "subjectGroups"
        ]
      },
      "TemplateSetPdfPrintDataResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/TemplateSetPdfPrintDataDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "TemplateSetPdfGenerateDto": {
        "type": "object",
        "properties": {
          "schoolLevel": {
            "type": "number"
          },
          "performanceVisualId": {
            "type": "number"
          },
          "subjectGroupIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "schoolLevel",
          "performanceVisualId"
        ]
      },
      "CheckoutSource": {
        "type": "string",
        "enum": [
          "default",
          "trialUpsell",
          "trialExpired",
          "trialWinback",
          "onboarding"
        ]
      },
      "BillingCheckoutDto": {
        "type": "object",
        "properties": {
          "source": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/CheckoutSource"
              }
            ]
          },
          "billingInterval": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingInterval"
              }
            ]
          },
          "productTypeId": {
            "type": "number",
            "description": "The product type id that you want to buy/subscribe to"
          },
          "quantity": {
            "type": "number",
            "minimum": 1,
            "maximum": 10000
          },
          "returnPath": {
            "type": "string"
          }
        },
        "required": [
          "productTypeId"
        ]
      },
      "BillingLinkResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "url": {
            "type": "string",
            "nullable": true,
            "description": "A URL pointing to the Billingservice.\nDepending on the request this may start the checkout process, go to the customer portal, ...\n\nMay be null if the user/tenant has no billing customer and therefore there is no customer portal."
          }
        },
        "required": [
          "success",
          "url"
        ]
      },
      "BillingCheckoutPreviewDto": {
        "type": "object",
        "properties": {
          "source": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/CheckoutSource"
              }
            ]
          },
          "billingInterval": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingInterval"
              }
            ]
          },
          "productTypeId": {
            "type": "number",
            "description": "The product type id that you want to buy/subscribe to"
          },
          "quantity": {
            "type": "number",
            "minimum": 1,
            "maximum": 10000
          },
          "returnPath": {
            "type": "string"
          }
        },
        "required": [
          "productTypeId"
        ]
      },
      "BillingCheckoutPreviewDtoData": {
        "type": "object",
        "properties": {
          "availablePaymentMethods": {
            "type": "array",
            "items": {
              "type": "string",
              "enum": [
                "online",
                "invoice"
              ]
            }
          },
          "finalAmountCents": {
            "type": "number"
          },
          "currency": {
            "type": "string",
            "description": "Lowercase ISO 4217 the preview amount is denominated in."
          },
          "invoiceEligible": {
            "type": "boolean"
          },
          "invoiceEnabled": {
            "type": "boolean"
          },
          "invoiceDaysUntilDue": {
            "type": "number"
          }
        },
        "required": [
          "availablePaymentMethods",
          "finalAmountCents",
          "currency",
          "invoiceEligible",
          "invoiceEnabled",
          "invoiceDaysUntilDue"
        ]
      },
      "BillingCheckoutPreviewResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/BillingCheckoutPreviewDtoData"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "BillingWinbackOfferDto": {
        "type": "object",
        "properties": {
          "discountPercent": {
            "type": "number"
          },
          "eligibleProductTypeIds": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "discountPercent",
          "eligibleProductTypeIds"
        ]
      },
      "BillingCheckoutOptionsDtoData": {
        "type": "object",
        "properties": {
          "invoiceEnabled": {
            "type": "boolean"
          },
          "invoiceDaysUntilDue": {
            "type": "number"
          },
          "studentSeatsUsed": {
            "type": "number"
          },
          "winbackOffer": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingWinbackOfferDto"
              },
              {
                "nullable": true
              }
            ]
          }
        },
        "required": [
          "invoiceEnabled",
          "invoiceDaysUntilDue",
          "studentSeatsUsed",
          "winbackOffer"
        ]
      },
      "BillingCheckoutOptionsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/BillingCheckoutOptionsDtoData"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "BillingInvoiceAddressDto": {
        "type": "object",
        "properties": {
          "countryIsoCode": {
            "type": "string",
            "nullable": true
          },
          "stripeTaxId": {
            "type": "string",
            "nullable": true
          },
          "name": {
            "type": "string",
            "maxLength": 255
          },
          "line1": {
            "type": "string",
            "maxLength": 255
          },
          "city": {
            "type": "string",
            "maxLength": 120
          },
          "postalCode": {
            "type": "string",
            "maxLength": 40
          },
          "vatId": {
            "type": "string",
            "nullable": true,
            "maxLength": 40
          },
          "notes": {
            "type": "string",
            "nullable": true,
            "maxLength": 140
          }
        },
        "required": [
          "countryIsoCode",
          "name",
          "line1",
          "city",
          "postalCode"
        ]
      },
      "BillingInvoiceAddressResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/BillingInvoiceAddressDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "SeatType": {
        "type": "string",
        "enum": [
          "student",
          "user"
        ]
      },
      "BillingInvoiceDto": {
        "type": "object",
        "properties": {
          "product": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/Product"
              },
              {
                "nullable": true
              }
            ]
          },
          "billingInterval": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingInterval"
              },
              {
                "nullable": true
              }
            ]
          },
          "seatType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SeatType"
              },
              {
                "nullable": true
              }
            ]
          },
          "billingInvoiceId": {
            "type": "string"
          },
          "billingSubscriptionId": {
            "type": "string",
            "nullable": true
          },
          "invoiceNumber": {
            "type": "string",
            "nullable": true
          },
          "issuedAt": {
            "type": "string",
            "nullable": true
          },
          "status": {
            "type": "string"
          },
          "hostedInvoiceUrl": {
            "type": "string",
            "nullable": true
          },
          "invoicePdfUrl": {
            "type": "string",
            "nullable": true
          },
          "dueAt": {
            "type": "string",
            "nullable": true
          },
          "paidAt": {
            "type": "string",
            "nullable": true
          },
          "amountDue": {
            "type": "number"
          },
          "amountRemaining": {
            "type": "number"
          },
          "amountPaid": {
            "type": "number"
          },
          "currency": {
            "type": "string"
          },
          "productTypeId": {
            "type": "number",
            "nullable": true
          },
          "quantity": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "product",
          "billingInterval",
          "seatType",
          "billingInvoiceId",
          "billingSubscriptionId",
          "invoiceNumber",
          "issuedAt",
          "status",
          "hostedInvoiceUrl",
          "invoicePdfUrl",
          "dueAt",
          "paidAt",
          "amountDue",
          "amountRemaining",
          "amountPaid",
          "currency",
          "productTypeId",
          "quantity"
        ]
      },
      "PaginatedBillingInvoiceResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/BillingInvoiceDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "BillingOfferStatus": {
        "type": "string",
        "enum": [
          "pending",
          "accepted",
          "expired",
          "replaced",
          "deleted"
        ]
      },
      "BillingOfferAcceptanceMethod": {
        "type": "string",
        "enum": [
          "invoice",
          "online"
        ]
      },
      "BillingOfferDto": {
        "type": "object",
        "properties": {
          "product": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/Product"
              }
            ]
          },
          "seatType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SeatType"
              }
            ]
          },
          "billingInterval": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingInterval"
              }
            ]
          },
          "status": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingOfferStatus"
              }
            ]
          },
          "acceptanceMethod": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingOfferAcceptanceMethod"
              },
              {
                "nullable": true
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "type": "string"
          },
          "updatedAt": {
            "type": "string"
          },
          "productTypeId": {
            "type": "number"
          },
          "billingPriceId": {
            "type": "string"
          },
          "quantity": {
            "type": "number"
          },
          "amountSubtotal": {
            "type": "number"
          },
          "amountTotal": {
            "type": "number"
          },
          "currency": {
            "type": "string"
          },
          "validUntil": {
            "type": "string"
          },
          "acceptedAt": {
            "type": "string",
            "nullable": true
          },
          "deletedAt": {
            "type": "string",
            "nullable": true
          },
          "billingSubscriptionId": {
            "type": "string",
            "nullable": true
          },
          "billingInvoiceId": {
            "type": "string",
            "nullable": true
          },
          "checkoutSessionId": {
            "type": "string",
            "nullable": true
          },
          "stripeQuoteId": {
            "type": "string"
          },
          "stripeQuoteNumber": {
            "type": "string",
            "nullable": true
          },
          "stripeQuoteStatus": {
            "type": "string"
          },
          "address": {
            "$ref": "#/components/schemas/BillingInvoiceAddressDto"
          }
        },
        "required": [
          "product",
          "seatType",
          "billingInterval",
          "status",
          "acceptanceMethod",
          "id",
          "createdAt",
          "updatedAt",
          "productTypeId",
          "billingPriceId",
          "quantity",
          "amountSubtotal",
          "amountTotal",
          "currency",
          "validUntil",
          "acceptedAt",
          "deletedAt",
          "billingSubscriptionId",
          "billingInvoiceId",
          "checkoutSessionId",
          "stripeQuoteId",
          "stripeQuoteNumber",
          "stripeQuoteStatus",
          "address"
        ]
      },
      "PaginatedBillingOfferResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/BillingOfferDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "UpsertTenantInvoiceAddressDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "maxLength": 255
          },
          "line1": {
            "type": "string",
            "maxLength": 255
          },
          "city": {
            "type": "string",
            "maxLength": 120
          },
          "postalCode": {
            "type": "string",
            "maxLength": 40
          },
          "vatId": {
            "type": "string",
            "nullable": true,
            "maxLength": 40
          },
          "notes": {
            "type": "string",
            "nullable": true,
            "maxLength": 140
          }
        },
        "required": [
          "name",
          "line1",
          "city",
          "postalCode"
        ]
      },
      "TenantInvoiceCheckoutResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/BillingInvoiceDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "CreateBillingOfferDto": {
        "type": "object",
        "properties": {
          "address": {
            "$ref": "#/components/schemas/UpsertTenantInvoiceAddressDto"
          },
          "productTypeId": {
            "type": "number"
          },
          "quantity": {
            "type": "number",
            "minimum": 1,
            "maximum": 10000
          }
        },
        "required": [
          "address",
          "productTypeId"
        ]
      },
      "BillingOfferResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/BillingOfferDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "AcceptBillingOfferOnlineDto": {
        "type": "object",
        "properties": {
          "returnPath": {
            "type": "string"
          }
        }
      },
      "BillingPortalDto": {
        "type": "object",
        "properties": {
          "returnPath": {
            "type": "string"
          }
        }
      },
      "BillingCollectionMethod": {
        "type": "string",
        "enum": [
          "chargeAutomatically",
          "sendInvoice"
        ]
      },
      "ProductFeature": {
        "type": "string",
        "enum": [
          "competenceDocumentation",
          "statistic",
          "collaboration",
          "report",
          "tenantCustomization",
          "accessRights",
          "gradeCustomization",
          "supportMeasures",
          "attachments"
        ]
      },
      "SeatUsageDto": {
        "type": "object",
        "properties": {
          "capacity": {
            "type": "number"
          },
          "used": {
            "type": "number"
          },
          "remaining": {
            "type": "number"
          },
          "ok": {
            "type": "boolean"
          }
        },
        "required": [
          "capacity",
          "used",
          "remaining",
          "ok"
        ]
      },
      "BillingStatusProductDto": {
        "type": "object",
        "properties": {
          "product": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/Product"
              }
            ]
          },
          "billingInterval": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingInterval"
              }
            ]
          },
          "seatType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SeatType"
              }
            ]
          },
          "enabledFeatures": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ProductFeature"
            }
          },
          "productTypeId": {
            "type": "number"
          },
          "billingPriceId": {
            "type": "string"
          },
          "seats": {
            "type": "number",
            "nullable": true
          },
          "supportsSeats": {
            "type": "boolean"
          },
          "validFrom": {
            "type": "string"
          },
          "validTo": {
            "type": "string"
          },
          "seatUsage": {
            "$ref": "#/components/schemas/SeatUsageDto"
          },
          "isCurrentlyActive": {
            "type": "boolean"
          }
        },
        "required": [
          "product",
          "billingInterval",
          "seatType",
          "enabledFeatures",
          "productTypeId",
          "billingPriceId",
          "supportsSeats",
          "validFrom",
          "validTo",
          "isCurrentlyActive"
        ]
      },
      "BillingStatusDto": {
        "type": "object",
        "properties": {
          "status": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SubscriptionStatus"
              }
            ]
          },
          "collectionMethod": {
            "default": null,
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingCollectionMethod"
              },
              {
                "nullable": true
              }
            ]
          },
          "currentBillingInterval": {
            "default": null,
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingInterval"
              },
              {
                "nullable": true
              }
            ]
          },
          "isBillingActive": {
            "type": "boolean"
          },
          "products": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/BillingStatusProductDto"
            }
          },
          "currentPeriodEnd": {
            "format": "date-time",
            "type": "string",
            "nullable": true,
            "default": null
          },
          "cancelAtPeriodEnd": {
            "type": "boolean",
            "nullable": true,
            "default": null
          },
          "hasAnySubscriptionHistory": {
            "type": "boolean"
          },
          "hasActivePlan": {
            "type": "boolean"
          },
          "isInvoicePastDue": {
            "type": "boolean"
          },
          "primaryProductTypeId": {
            "type": "number",
            "nullable": true,
            "default": null
          },
          "pendingInvoice": {
            "default": null,
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingInvoiceDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "pendingOffer": {
            "default": null,
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingOfferDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "isTrialActive": {
            "type": "boolean"
          },
          "hasEverStartedTrial": {
            "type": "boolean"
          },
          "hasSeenTrialExpiredHint": {
            "type": "boolean"
          },
          "trialStartsAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true,
            "default": null
          },
          "trialEndsAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true,
            "default": null
          },
          "trialDays": {
            "type": "number"
          },
          "hasUsedTrialExtension": {
            "type": "boolean"
          }
        },
        "required": [
          "status",
          "collectionMethod",
          "currentBillingInterval",
          "isBillingActive",
          "products",
          "currentPeriodEnd",
          "cancelAtPeriodEnd",
          "hasAnySubscriptionHistory",
          "hasActivePlan",
          "isInvoicePastDue",
          "primaryProductTypeId",
          "pendingInvoice",
          "pendingOffer",
          "isTrialActive",
          "hasEverStartedTrial",
          "hasSeenTrialExpiredHint",
          "trialStartsAt",
          "trialEndsAt",
          "trialDays",
          "hasUsedTrialExtension"
        ]
      },
      "BillingStatusResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/BillingStatusDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "ProductOwnerType": {
        "type": "string",
        "enum": [
          "tenant",
          "user"
        ]
      },
      "ProductTypeDto": {
        "type": "object",
        "properties": {
          "product": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/Product"
              }
            ]
          },
          "ownerType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ProductOwnerType"
              }
            ]
          },
          "seatType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SeatType"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "supportsSeats": {
            "type": "boolean"
          },
          "billingProductId": {
            "type": "string"
          },
          "billingDefaultPriceId": {
            "type": "string"
          },
          "billingMonthlyPriceId": {
            "type": "string",
            "nullable": true
          },
          "trialUpsellDiscount": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "product",
          "ownerType",
          "seatType",
          "id",
          "createdAt",
          "updatedAt",
          "supportsSeats",
          "billingProductId",
          "billingDefaultPriceId"
        ]
      },
      "CheckoutPurchaseDto": {
        "type": "object",
        "properties": {
          "orderId": {
            "type": "string",
            "description": "The Stripe subscription id; the server reports the purchase to the ad platforms under the same id."
          },
          "value": {
            "type": "number",
            "description": "Net amount without tax in the main currency unit."
          },
          "currency": {
            "type": "string",
            "description": "Uppercase ISO 4217."
          }
        },
        "required": [
          "orderId",
          "value",
          "currency"
        ]
      },
      "CheckoutSummaryDto": {
        "type": "object",
        "properties": {
          "products": {
            "description": "Empty while the checkout is unpaid or belongs to another school.",
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ProductTypeDto"
            }
          },
          "purchase": {
            "description": "Null while the first invoice is unpaid or the checkout belongs to another school.",
            "oneOf": [
              {
                "$ref": "#/components/schemas/CheckoutPurchaseDto"
              },
              {
                "nullable": true
              }
            ]
          }
        },
        "required": [
          "products",
          "purchase"
        ]
      },
      "CheckoutSummaryResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/CheckoutSummaryDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "BillingPlanSwitchPreviewDto": {
        "type": "object",
        "properties": {
          "source": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/CheckoutSource"
              }
            ]
          },
          "billingInterval": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingInterval"
              }
            ]
          },
          "productTypeId": {
            "type": "number",
            "description": "The product type id that you want to buy/subscribe to"
          },
          "quantity": {
            "type": "number",
            "minimum": 1,
            "maximum": 10000
          },
          "returnPath": {
            "type": "string"
          }
        },
        "required": [
          "productTypeId"
        ]
      },
      "BillingPlanSwitchEffect": {
        "type": "string",
        "enum": [
          "noChange",
          "immediate",
          "periodEnd"
        ]
      },
      "BillingPlanSwitchPreviewDtoData": {
        "type": "object",
        "properties": {
          "effect": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingPlanSwitchEffect"
              }
            ]
          },
          "currentBillingInterval": {
            "default": null,
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingInterval"
              },
              {
                "nullable": true
              }
            ]
          },
          "targetBillingInterval": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingInterval"
              }
            ]
          },
          "currentProductTypeId": {
            "type": "number",
            "nullable": true,
            "default": null
          },
          "targetProductTypeId": {
            "type": "number"
          },
          "currentQuantity": {
            "type": "number",
            "nullable": true,
            "default": null
          },
          "targetQuantity": {
            "type": "number"
          },
          "effectiveAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true,
            "default": null
          },
          "createsImmediateInvoice": {
            "type": "boolean"
          },
          "amountDueNowCents": {
            "type": "number",
            "nullable": true,
            "description": "Net amount (excl. VAT) — plan-switch amounts are communicated net app-wide; the issued invoice adds tax on top.",
            "default": null
          },
          "currency": {
            "type": "string",
            "nullable": true,
            "default": null
          },
          "isAmountEstimate": {
            "type": "boolean"
          },
          "releasesScheduledChange": {
            "type": "boolean",
            "description": "True when the target equals the current plan but a scheduled change (downgrade) is pending: confirming releases it."
          }
        },
        "required": [
          "effect",
          "currentBillingInterval",
          "targetBillingInterval",
          "currentProductTypeId",
          "targetProductTypeId",
          "currentQuantity",
          "targetQuantity",
          "effectiveAt",
          "createsImmediateInvoice",
          "amountDueNowCents",
          "currency",
          "isAmountEstimate",
          "releasesScheduledChange"
        ]
      },
      "BillingPlanSwitchPreviewResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/BillingPlanSwitchPreviewDtoData"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "BillingScheduledPlanChangeDtoData": {
        "type": "object",
        "properties": {
          "effectiveAt": {
            "format": "date-time",
            "type": "string",
            "nullable": true,
            "description": "When the pending scheduled plan change (period-end downgrade) takes effect; null when nothing is scheduled.",
            "default": null
          }
        },
        "required": [
          "effectiveAt"
        ]
      },
      "BillingScheduledPlanChangeResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/BillingScheduledPlanChangeDtoData"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpcomingBillingAmountResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "upcomingAmount": {
            "type": "number"
          },
          "upcomingCurrency": {
            "type": "string",
            "nullable": true,
            "description": "Lowercase ISO 4217 of the upcoming invoice; null while unknown (no upcoming invoice)."
          }
        },
        "required": [
          "success",
          "upcomingAmount",
          "upcomingCurrency"
        ]
      },
      "TenantHasUsablePaymentMethodResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "hasUsableMethod": {
            "type": "boolean"
          }
        },
        "required": [
          "success",
          "hasUsableMethod"
        ]
      },
      "BillingPriceTierDto": {
        "type": "object",
        "properties": {
          "upTo": {
            "type": "number",
            "nullable": true,
            "description": "Upper seat bound of the tier (inclusive); null = the open-ended last tier."
          },
          "perSeatCents": {
            "type": "number"
          }
        },
        "required": [
          "upTo",
          "perSeatCents"
        ]
      },
      "BillingIntervalPricingDto": {
        "type": "object",
        "properties": {
          "billingPriceId": {
            "type": "string"
          },
          "unitAmountCents": {
            "type": "number",
            "nullable": true,
            "description": "Flat/licensed unit amount; null for graduated-tier prices."
          },
          "seatTiers": {
            "nullable": true,
            "description": "Graduated tier table; null for flat prices.",
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/BillingPriceTierDto"
            }
          }
        },
        "required": [
          "billingPriceId",
          "unitAmountCents",
          "seatTiers"
        ]
      },
      "BillingProductPricingDto": {
        "type": "object",
        "properties": {
          "product": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/Product"
              }
            ]
          },
          "productTypeId": {
            "type": "number"
          },
          "yearly": {
            "description": "Null = the product is not offered in this market (no Stripe currency option).",
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingIntervalPricingDto"
              },
              {
                "nullable": true
              }
            ]
          },
          "monthly": {
            "description": "Null = no monthly billing in this market.",
            "oneOf": [
              {
                "$ref": "#/components/schemas/BillingIntervalPricingDto"
              },
              {
                "nullable": true
              }
            ]
          }
        },
        "required": [
          "product",
          "productTypeId",
          "yearly",
          "monthly"
        ]
      },
      "BillingMarketPricingDtoData": {
        "type": "object",
        "properties": {
          "currency": {
            "type": "string",
            "description": "Lowercase ISO 4217 all amounts in this payload are denominated in."
          },
          "products": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/BillingProductPricingDto"
            }
          }
        },
        "required": [
          "currency",
          "products"
        ]
      },
      "BillingMarketPricingResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/BillingMarketPricingDtoData"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "PaginatedBillingProductResponse": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ProductTypeDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "BillingSyncCustomerSuccessResponse": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "customerId": {
            "type": "string"
          }
        },
        "required": [
          "success",
          "customerId"
        ]
      },
      "ReferralLinkResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "code": {
            "type": "string"
          },
          "url": {
            "type": "string"
          }
        },
        "required": [
          "success",
          "code",
          "url"
        ]
      },
      "ReferralStatusResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "availablePercent": {
            "type": "number"
          },
          "successfulReferralCount": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "availablePercent",
          "successfulReferralCount"
        ]
      },
      "AttributeReferralDto": {
        "type": "object",
        "properties": {
          "code": {
            "type": "string"
          },
          "source": {
            "type": "string",
            "enum": [
              "signup",
              "checkout"
            ]
          }
        },
        "required": [
          "code",
          "source"
        ]
      },
      "GradeCalculationSubjectRecommendationSummaryDto": {
        "type": "object",
        "properties": {
          "grade": {
            "type": "number",
            "nullable": true
          },
          "exactGrade": {
            "type": "number",
            "nullable": true
          },
          "achievedPercentage": {
            "type": "number",
            "nullable": true
          },
          "gradeLevelName": {
            "type": "string",
            "nullable": true
          },
          "schoolSubjectId": {
            "type": "number"
          }
        },
        "required": [
          "grade",
          "exactGrade",
          "achievedPercentage",
          "gradeLevelName",
          "schoolSubjectId"
        ]
      },
      "GradeCalculationClassRecommendationRowDto": {
        "type": "object",
        "properties": {
          "avatar": {
            "type": "string",
            "nullable": true
          },
          "recommendations": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/GradeCalculationSubjectRecommendationSummaryDto"
            }
          },
          "studentId": {
            "type": "number"
          },
          "firstName": {
            "type": "string"
          },
          "lastName": {
            "type": "string"
          }
        },
        "required": [
          "avatar",
          "recommendations",
          "studentId",
          "firstName",
          "lastName"
        ]
      },
      "GradeCalculationClassRecommendationListResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/GradeCalculationClassRecommendationRowDto"
            }
          }
        },
        "required": [
          "success",
          "rows"
        ]
      },
      "GradeCalculationSubjectRecommendationListResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/GradeCalculationSubjectRecommendationSummaryDto"
            }
          }
        },
        "required": [
          "success",
          "rows"
        ]
      },
      "GradeCalculationContributionDto": {
        "type": "object",
        "properties": {
          "achievedPercentage": {
            "type": "number",
            "nullable": true
          },
          "weightedContributionPercentage": {
            "type": "number",
            "nullable": true
          },
          "exactGrade": {
            "type": "number",
            "nullable": true
          },
          "performanceAssessmentId": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "key": {
            "type": "string",
            "nullable": true
          },
          "isNameCustomized": {
            "type": "boolean"
          },
          "symbol": {
            "type": "string"
          },
          "weighting": {
            "type": "number"
          },
          "ratedEntryCount": {
            "type": "number"
          },
          "includedEntryCount": {
            "type": "number"
          }
        },
        "required": [
          "achievedPercentage",
          "weightedContributionPercentage",
          "exactGrade",
          "performanceAssessmentId",
          "name",
          "key",
          "isNameCustomized",
          "symbol",
          "weighting",
          "ratedEntryCount",
          "includedEntryCount"
        ]
      },
      "GradeCalculationSubjectRecommendationDto": {
        "type": "object",
        "properties": {
          "grade": {
            "type": "number",
            "nullable": true
          },
          "exactGrade": {
            "type": "number",
            "nullable": true
          },
          "achievedPercentage": {
            "type": "number",
            "nullable": true
          },
          "gradeLevelName": {
            "type": "string",
            "nullable": true
          },
          "contributions": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/GradeCalculationContributionDto"
            }
          },
          "schoolSubject": {
            "$ref": "#/components/schemas/BaseSchoolSubjectDto"
          },
          "isSubjectSpecificContext": {
            "type": "boolean"
          },
          "usesSubjectSpecificAssessments": {
            "type": "boolean"
          },
          "gradeScaleLevels": {
            "type": "number"
          },
          "availableWeight": {
            "type": "number"
          },
          "schoolSubjectId": {
            "type": "number"
          }
        },
        "required": [
          "grade",
          "exactGrade",
          "achievedPercentage",
          "gradeLevelName",
          "contributions",
          "schoolSubject",
          "isSubjectSpecificContext",
          "usesSubjectSpecificAssessments",
          "gradeScaleLevels",
          "availableWeight",
          "schoolSubjectId"
        ]
      },
      "GradeCalculationSubjectRecommendationResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/GradeCalculationSubjectRecommendationDto"
              },
              {
                "nullable": true
              }
            ]
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "GradeCalculationWeightingItemDto": {
        "type": "object",
        "properties": {
          "performanceAssessmentId": {
            "type": "number"
          },
          "weighting": {
            "type": "number",
            "minimum": 0,
            "maximum": 100
          }
        },
        "required": [
          "performanceAssessmentId",
          "weighting"
        ]
      },
      "UpdateGradeCalculationWeightingsDto": {
        "type": "object",
        "properties": {
          "assessments": {
            "minItems": 1,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/GradeCalculationWeightingItemDto"
            }
          }
        },
        "required": [
          "assessments"
        ]
      },
      "GradeCalculationSettingsWithTagsDto": {
        "type": "object",
        "properties": {
          "settings": {
            "$ref": "#/components/schemas/GradeCalculationSettingsDto"
          },
          "tags": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/GradeCalculationTagDto"
            }
          }
        },
        "required": [
          "settings",
          "tags"
        ]
      },
      "GradeCalculationSettingsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/GradeCalculationSettingsWithTagsDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateGradeCalculationSettingsDto": {
        "type": "object",
        "properties": {
          "decimalGradesEnabled": {
            "type": "boolean"
          },
          "gradeModifiersEnabled": {
            "type": "boolean"
          },
          "enabled": {
            "type": "boolean"
          },
          "schoolLevels": {
            "type": "array",
            "items": {
              "type": "number",
              "maximum": 13,
              "minimum": 0
            }
          }
        }
      },
      "GradeScaleUsageDto": {
        "type": "object",
        "properties": {
          "hasRecordedGrades": {
            "type": "boolean"
          },
          "hasDecimalGrades": {
            "type": "boolean"
          },
          "hasGradeModifiers": {
            "type": "boolean"
          }
        },
        "required": [
          "hasRecordedGrades",
          "hasDecimalGrades",
          "hasGradeModifiers"
        ]
      },
      "GradeScaleUsageResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/GradeScaleUsageDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateConfiguredGradeLevelDto": {
        "type": "object",
        "properties": {
          "level": {
            "type": "number",
            "minimum": 1,
            "maximum": 6
          },
          "name": {
            "type": "string"
          },
          "description": {
            "type": "string"
          },
          "isNameCustomized": {
            "type": "boolean"
          }
        },
        "required": [
          "level"
        ]
      },
      "UpdateSchoolGradeScaleDto": {
        "type": "object",
        "properties": {
          "gradeLevels": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/UpdateConfiguredGradeLevelDto"
            }
          },
          "gradeScaleSize": {
            "type": "number",
            "enum": [
              5,
              6
            ]
          },
          "lowerGradeValueIsBetter": {
            "type": "boolean"
          }
        }
      },
      "CreateGradeLevelDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          },
          "description": {
            "type": "string"
          }
        }
      },
      "CreateGradeScaleDto": {
        "type": "object",
        "properties": {
          "visualizationType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/GradeVisualizationType"
              }
            ]
          },
          "lowerGradeValueIsBetter": {
            "type": "boolean"
          },
          "isTemplate": {
            "type": "boolean"
          },
          "levels": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CreateGradeLevelDto"
            }
          },
          "countryId": {
            "type": "number",
            "nullable": true
          },
          "stateId": {
            "type": "number",
            "nullable": true
          },
          "schoolTypeId": {
            "type": "number",
            "nullable": true
          },
          "languageId": {
            "type": "number",
            "nullable": true
          }
        }
      },
      "GradeScaleDto": {
        "type": "object",
        "properties": {
          "visualizationType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/GradeVisualizationType"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "originId": {
            "type": "number"
          },
          "lowerGradeValueIsBetter": {
            "type": "boolean"
          },
          "isTemplate": {
            "type": "boolean"
          },
          "tenantId": {
            "type": "number",
            "nullable": true
          },
          "countryId": {
            "type": "number",
            "nullable": true
          },
          "levels": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/GradeLevelDto"
            }
          },
          "isInUse": {
            "type": "boolean"
          }
        },
        "required": [
          "visualizationType",
          "id",
          "createdAt",
          "updatedAt",
          "originId",
          "lowerGradeValueIsBetter",
          "isTemplate",
          "tenantId",
          "countryId",
          "levels",
          "isInUse"
        ]
      },
      "GradeScaleResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/GradeScaleDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateGradeScaleDto": {
        "type": "object",
        "properties": {
          "visualizationType": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/GradeVisualizationType"
              }
            ]
          },
          "lowerGradeValueIsBetter": {
            "type": "boolean"
          }
        }
      },
      "PaginatedGradeScaleResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/GradeScaleDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "GradeLevelResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/GradeLevelDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateGradeLevelDto": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          },
          "description": {
            "type": "string"
          },
          "isNameCustomized": {
            "type": "boolean"
          }
        }
      },
      "GrowthPopupType": {
        "type": "string",
        "enum": [
          "POPUP_FIRST_ENTRY",
          "POPUP_CREATE_CLASS",
          "POPUP_SCHOOL_SETUP",
          "NONE"
        ]
      },
      "GrowthCtaDto": {
        "type": "object",
        "properties": {
          "popup": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/GrowthPopupType"
              }
            ]
          }
        },
        "required": [
          "popup"
        ]
      },
      "GrowthCtaResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/GrowthCtaDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "GrowthStateDto": {
        "type": "object",
        "properties": {
          "firstEntryDone": {
            "type": "boolean"
          },
          "firstEntryPromptIgnoredCount": {
            "type": "number"
          },
          "createClassDone": {
            "type": "boolean"
          },
          "createClassPromptIgnoredCount": {
            "type": "number"
          },
          "schoolSetupDone": {
            "type": "boolean"
          },
          "schoolSetupPromptIgnoredCount": {
            "type": "number"
          }
        },
        "required": [
          "firstEntryDone",
          "firstEntryPromptIgnoredCount",
          "createClassDone",
          "createClassPromptIgnoredCount",
          "schoolSetupDone",
          "schoolSetupPromptIgnoredCount"
        ]
      },
      "GrowthStateResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/GrowthStateDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "GrowthPopupDismissDto": {
        "type": "object",
        "properties": {
          "popup": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/GrowthPopupType"
              }
            ]
          }
        },
        "required": [
          "popup"
        ]
      },
      "SetupChecklistStepsDto": {
        "type": "object",
        "properties": {
          "demoClassTour": {
            "type": "boolean"
          },
          "createFirstEntry": {
            "type": "boolean"
          },
          "createClass": {
            "type": "boolean"
          },
          "createDemoReport": {
            "type": "boolean"
          },
          "setupSchool": {
            "type": "boolean"
          },
          "inviteTeam": {
            "type": "boolean"
          }
        },
        "required": [
          "demoClassTour",
          "createFirstEntry",
          "createClass",
          "createDemoReport",
          "setupSchool",
          "inviteTeam"
        ]
      },
      "SetupChecklistStateDto": {
        "type": "object",
        "properties": {
          "dismissed": {
            "type": "boolean"
          },
          "steps": {
            "$ref": "#/components/schemas/SetupChecklistStepsDto"
          }
        },
        "required": [
          "dismissed",
          "steps"
        ]
      },
      "SetupChecklistStateResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/SetupChecklistStateDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "CreateSchoolTypeConfigurationDto": {
        "type": "object",
        "properties": {
          "labelMode": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SchoolLevelLabelMode"
              }
            ]
          },
          "schoolTypeId": {
            "type": "number"
          },
          "stateId": {
            "type": "number",
            "nullable": true
          },
          "languageId": {
            "type": "number",
            "nullable": true
          },
          "schoolLevels": {
            "uniqueItems": true,
            "type": "array",
            "items": {
              "type": "number",
              "minimum": 0
            }
          }
        },
        "required": [
          "labelMode",
          "schoolTypeId",
          "schoolLevels"
        ]
      },
      "SchoolTypeConfigurationDto": {
        "type": "object",
        "properties": {
          "labelMode": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SchoolLevelLabelMode"
              }
            ]
          },
          "id": {
            "type": "number"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "schoolTypeId": {
            "type": "number"
          },
          "stateId": {
            "type": "number",
            "nullable": true
          },
          "languageId": {
            "type": "number",
            "nullable": true
          },
          "schoolLevels": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "labelMode",
          "id",
          "createdAt",
          "updatedAt",
          "schoolTypeId",
          "stateId",
          "languageId",
          "schoolLevels"
        ]
      },
      "SchoolTypeConfigurationResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/SchoolTypeConfigurationDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateSchoolTypeConfigurationDto": {
        "type": "object",
        "properties": {
          "labelMode": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/SchoolLevelLabelMode"
              }
            ]
          },
          "schoolLevels": {
            "uniqueItems": true,
            "type": "array",
            "items": {
              "type": "number",
              "minimum": 0
            }
          }
        }
      },
      "PaginatedSchoolTypeConfigurationResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SchoolTypeConfigurationDto"
            }
          },
          "count": {
            "type": "number"
          }
        },
        "required": [
          "success",
          "rows",
          "count"
        ]
      },
      "AuthProviderDto": {
        "type": "object",
        "properties": {
          "config": {
            "type": "object",
            "additionalProperties": true
          },
          "id": {
            "type": "string"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "type": {
            "type": "string"
          },
          "default": {
            "type": "boolean"
          },
          "enabled": {
            "type": "boolean"
          }
        },
        "required": [
          "config",
          "id",
          "createdAt",
          "updatedAt",
          "name",
          "type",
          "default",
          "enabled"
        ]
      },
      "AuthProviderListResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/AuthProviderDto"
            }
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "CreateAuthProviderDto": {
        "type": "object",
        "properties": {
          "config": {
            "type": "object",
            "additionalProperties": true
          },
          "id": {
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "type": {
            "type": "string"
          },
          "default": {
            "type": "boolean"
          },
          "enabled": {
            "type": "boolean"
          }
        },
        "required": [
          "config",
          "id",
          "name",
          "type",
          "default",
          "enabled"
        ]
      },
      "AuthProviderResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "$ref": "#/components/schemas/AuthProviderDto"
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "UpdateAuthProviderDto": {
        "type": "object",
        "properties": {
          "config": {
            "type": "object",
            "additionalProperties": true
          },
          "name": {
            "type": "string"
          },
          "type": {
            "type": "string"
          },
          "default": {
            "type": "boolean"
          },
          "enabled": {
            "type": "boolean"
          }
        }
      },
      "RegistrationAnalyticsContextDto": {
        "type": "object",
        "properties": {
          "method": {
            "type": "string"
          }
        },
        "required": [
          "method"
        ]
      },
      "ConsumeRegistrationAnalyticsResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "data": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/RegistrationAnalyticsContextDto"
              },
              {
                "nullable": true
              }
            ]
          }
        },
        "required": [
          "success",
          "data"
        ]
      },
      "ApiErrorResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "readOnly": true
          },
          "error": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/ErrorTypes"
              }
            ]
          },
          "message": {
            "type": "string"
          },
          "details": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": [
          "success",
          "error",
          "message"
        ]
      }
    }
  }
}